
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bRTjQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iTJtk = parcelRequire("iTJtk");


var $3d3WW = parcelRequire("3d3WW");


var $hcnuR = parcelRequire("hcnuR");


var $3jRrs = parcelRequire("3jRrs");


var $3jwuS = parcelRequire("3jwuS");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $7QM6o = parcelRequire("7QM6o");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $4c66dfa08a03eed2$var$handleOnProseMirrorRendered = (onProseMirrorRendered, eventAttributes)=>{
    if (onProseMirrorRendered && typeof onProseMirrorRendered === 'function') {
        const clientRouteStart = performance.getEntriesByName('browser-metric.start').pop()?.startTime;
        const proseMirrorRenderedTimestamp = (0, $2SowE.getProseMirrorFMPTimestamp)(eventAttributes?.startTime, eventAttributes?.duration);
        const proseMirrorRenderedFMP = typeof clientRouteStart !== 'undefined' && typeof proseMirrorRenderedTimestamp !== 'undefined' ? Math.round(proseMirrorRenderedTimestamp - clientRouteStart) : proseMirrorRenderedTimestamp;
        onProseMirrorRendered({
            ...eventAttributes,
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp
        });
    }
};
const $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f = (props)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const holdoutAnalyticsAttributesRef = (0, $cozmU.useRef)(null);
    const getCachedHoldoutAnalyticsAttributes = (0, $cozmU.useCallback)(()=>{
        if (holdoutAnalyticsAttributesRef.current === null) holdoutAnalyticsAttributesRef.current = (0, $3jRrs.getIsInConfluenceHoldoutData)();
        return holdoutAnalyticsAttributesRef.current;
    }, []);
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const { contentId: contentId, contentType: contentType, children: children, source: source, collabService: collabService, onProseMirrorRendered: onProseMirrorRendered, isGuest: isGuest, touchpointId: touchpointId } = props;
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        if (event?.payload?.action === 'proseMirrorRendered') $4c66dfa08a03eed2$var$handleOnProseMirrorRendered(onProseMirrorRendered, event?.payload?.attributes);
        event.update((payload)=>{
            const isCommentEvent = payload.attributes && payload.attributes.appearance === 'comment';
            // WS-3190 If this is a comment event use the existing objectId as it correlates to the commentId
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: isCommentEvent ? payload.attributes.objectId : contentId,
                editorSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                collabService: collabService ?? 'none',
                contentType: contentType,
                isLivePage: isLivePage,
                edition: edition,
                spaceId: spaceId,
                ...getCachedHoldoutAnalyticsAttributes()
            });
            if (isGuest !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                isGuest: isGuest
            });
            if (touchpointId) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                touchpointId: touchpointId
            });
            newPayload.source = source || 'unknown';
            if (event.context) {
                const attributesFromContext = (0, $2SowE.extractAttributesFromContext)(event.context);
                newPayload.attributes = {
                    ...newPayload.attributes,
                    ...attributesFromContext
                };
            }
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            if (source === 'pageAndBlogEditor' && (payload.actionSubject === 'annotation' && payload.actionSubjectId === 'inlineComment' && payload.action === 'viewed' || payload.eventType === 'screen' && payload.actionSubject === 'inlineCommentToolbar')) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                pageMode: isLivePage ? 'live' : 'edit'
            });
            return newPayload;
        });
    }, [
        contentId,
        contentType,
        source,
        collabService,
        onProseMirrorRendered,
        edition,
        safeEnvironment,
        isLivePage,
        spaceId,
        isGuest,
        touchpointId,
        nonProductionBuildAnalyticsAttributes,
        getCachedHoldoutAnalyticsAttributes
    ]);
    const handleFabricElementsEvents = (0, $cozmU.useCallback)((event)=>{
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                pageType: contentType,
                editorSource: source,
                objectId: contentId,
                objectType: contentType,
                spaceId: spaceId,
                isLivePage: isLivePage
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        contentId,
        contentType,
        source,
        isLivePage,
        spaceId,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $iTJtk.FabricChannel).elements
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $iTJtk.FabricChannel).media
    }, children)));
};
module.exports["EditorAnalyticsListener"] = $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f;

});

parcelRegister("8iNtg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $jbxiN = parcelRequire("jbxiN");


var $eRJEr = parcelRequire("eRJEr");


var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $mW7G5 = parcelRequire("mW7G5");


var $fjeDY = parcelRequire("fjeDY");


var $gRoSG = parcelRequire("gRoSG");


var $dE5YE = parcelRequire("dE5YE");


var $krYZG = parcelRequire("krYZG");








var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $b4d126e73ed52524$export$4b29030e1d9baeba = (node, previousMauiId, localId)=>{
    return node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui' && node.attrs.parameters?.macroParams?.url?.value.endsWith(previousMauiId) && (localId ? node.attrs?.localId === localId : true);
};
const $b4d126e73ed52524$export$47dfdc23943fef4 = (attrs, previousMauiId, newMauiId)=>{
    /**
   * Some older browsers like chrome 97 doesn't support structuredClone.
   * So using JSON.parse(JSON.stringify()) as a fallback.
   */ const newAttrs = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(attrs) : JSON.parse(JSON.stringify(attrs));
    newAttrs.parameters.macroParams.url.value = newAttrs.parameters.macroParams.url.value.replace(previousMauiId, newMauiId);
    return newAttrs;
};
const $b4d126e73ed52524$export$ff177b3b8713a3ae = ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId, suppressScrollIntoView: suppressScrollIntoView })=>({ tr: tr })=>{
        // Check current selection, if the node is already selected we can skip expensive document traversal
        if ((0, $bjg0G.isNodeSelection)(tr.selection) && $b4d126e73ed52524$export$4b29030e1d9baeba(tr.selection.node, previousMauiId, localId)) {
            const node = tr.selection.node;
            const pos = tr.selection.$anchor.pos;
            tr.setNodeMarkup(pos, undefined, $b4d126e73ed52524$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
            if (suppressScrollIntoView) tr.setMeta('scrollIntoView', false);
            return tr;
        }
        // Find the first node that matches the previous MAUI App ID
        let nodeResult;
        tr.doc.descendants((node, pos)=>{
            if (nodeResult) return false;
            if ($b4d126e73ed52524$export$4b29030e1d9baeba(node, previousMauiId, localId)) nodeResult = {
                node: node,
                pos: pos
            };
            return !nodeResult;
        });
        if (nodeResult) {
            const { node: node, pos: pos } = nodeResult;
            tr.setNodeMarkup(pos, undefined, $b4d126e73ed52524$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
            if (suppressScrollIntoView) tr.setMeta('scrollIntoView', false);
            return tr;
        }
        return null;
    };



var $bpOXf = parcelRequire("bpOXf");

function $9ea85748e8d18b6b$export$4f422ec95246a715({ api: api, config: config }) {
    return async ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId, requireInsertionAcknowledgement: requireInsertionAcknowledgement, onInsertionResult: onInsertionResult })=>{
        let idToInsert = newMauiId;
        if (!(0, $cXtTj.default).getExperimentValue('remix_maui_duplicate_stability_improvement', 'value', false)) {
            // TODO: lift these deps out of `config.diagramPaste` to top-level `PluginConfiguration` once both flows share a config surface.
            const duplicateConfig = config?.diagramPaste;
            const duplicateMauiApp = duplicateConfig?.duplicateMauiApp;
            const containerContentId = duplicateConfig?.getCurrentPageId?.();
            const containerContentType = duplicateConfig?.getCurrentContentType?.();
            if (duplicateMauiApp && containerContentId) {
                const experienceTracker = (0, $bjY3F.ExperienceTrackerHandler).getInstance().experienceTracker;
                const experienceAttributes = {
                    appId: newMauiId,
                    currentPageId: containerContentId,
                    source: 'mauiInlineEdit'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    id: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                    attributes: {
                        ...experienceAttributes,
                        remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                    }
                });
                try {
                    const { id: id, attempts: attempts, statusCode: statusCode } = await duplicateMauiApp(newMauiId, containerContentId, containerContentType);
                    idToInsert = id;
                    const wasNoOp = id === newMauiId;
                    $9ea85748e8d18b6b$var$fireAnalytics(api, {
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'succeeded',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            newId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        attributes: {
                            ...experienceAttributes,
                            newAppId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                } catch (error) {
                    const statusCode = error?.statusCode;
                    const errorCode = error?.code;
                    const attempts = error?.attempts;
                    const isPermissionError = statusCode === 403;
                    $9ea85748e8d18b6b$var$fireAnalytics(api, {
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'failed',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            errorMessage: error?.message,
                            isPermissionError: isPermissionError,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            attempts: attempts
                        }
                    });
                    const duplicateError = error instanceof Error ? error : new Error('Failed to duplicate MAUI app');
                    experienceTracker.fail({
                        teamName: 'CC CE MAU',
                        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                    experienceTracker.fail({
                        teamName: 'CC CE MAU',
                        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            failedDueTo: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts,
                            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
                        }
                    });
                }
            }
        }
        const aiDecorationState = api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState;
        const isMatchingInlineEditTarget = Boolean(previousMauiId) && Boolean(localId) && (Boolean(aiDecorationState?.isInlineEditReady) && aiDecorationState?.inlineEditReadyTargetId === localId || aiDecorationState?.inlineRovoStreamingTargetId === localId);
        const shouldManageInlineEditScroll = isMatchingInlineEditTarget && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
        const isTargetInView = shouldManageInlineEditScroll ? api?.aiExperience?.actions.isInlineEditTargetInView?.(localId) : undefined;
        const suppressScrollIntoView = shouldManageInlineEditScroll && isTargetInView !== true;
        let targetMissing = false;
        const didReplace = api?.core?.actions.execute(({ tr: tr })=>{
            const result = (0, $b4d126e73ed52524$export$ff177b3b8713a3ae)({
                previousMauiId: previousMauiId,
                newMauiId: idToInsert,
                localId: localId,
                ...suppressScrollIntoView ? {
                    suppressScrollIntoView: suppressScrollIntoView
                } : {}
            })({
                tr: tr
            });
            targetMissing = result === null;
            if (result && localId) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                addAiEditReplacementLocalId: localId
            });
            return result;
        });
        onInsertionResult?.(didReplace ? 'inserted' : targetMissing ? 'target-missing' : 'failed');
        if (!didReplace && requireInsertionAcknowledgement) return undefined;
        return {
            insertedMauiId: idToInsert
        };
    };
}
function $9ea85748e8d18b6b$var$fireAnalytics(api, payload) {
    api?.analytics?.actions.fireAnalyticsEvent(payload);
}






var $5J9kV = parcelRequire("5J9kV");


var $3kyUj = parcelRequire("3kyUj");

function $157df83f4da5e36c$export$68002784dcd3d97({ config: config }) {
    return async (args)=>{
        if (args.targetSpace && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return {
            status: 'not-finalized'
        };
        const diagramPaste = config?.diagramPaste;
        if (!diagramPaste) return {
            status: 'not-finalized'
        };
        const { originalUrl: originalUrl, conversationContext: conversationContext, mode: mode, targetSpace: targetSpace } = args;
        // Use the view that owns this embed URL.
        const view = (0, $3kyUj.getMauiDiagramPasteView)(originalUrl);
        if (!view) return {
            status: 'not-finalized'
        };
        let contentId = args.contentId;
        if (!contentId) {
            const parsed = (0, $5J9kV.parseMauiDiagramLink)(originalUrl);
            contentId = parsed?.contentId;
        }
        if (!contentId) return {
            status: 'not-finalized'
        };
        const workflowArgs = {
            contentId: contentId,
            originalUrl: originalUrl,
            conversationContext: conversationContext,
            mode: mode,
            targetSpace: targetSpace
        };
        await (0, $3kyUj.executeMauiEmbedFinalize)(view, diagramPaste, workflowArgs);
        const status = (0, $3kyUj.mauiDiagramPastePluginKey).getState(view.state)?.embedFinalizeStates[contentId]?.status;
        return status === (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZED || status === (0, $3kyUj.MauiEmbedFinalizeStatus).NOT_NEEDED ? {
            status: 'finalized',
            contentId: contentId
        } : {
            status: 'not-finalized',
            contentId: contentId
        };
    };
}



var $kpCD8 = parcelRequire("kpCD8");





var $dOW9b = parcelRequire("dOW9b");


var $iCjKh = parcelRequire("iCjKh");

const $93f21268088062df$var$isUndoTransaction = (transaction)=>Object.values(transaction.meta ?? {}).some((value)=>typeof value === 'object' && value !== null && 'redo' in value && value.redo === false && 'historyState' in value);
const $93f21268088062df$var$nodeMatchesStackEntry = (node, { fieldId: fieldId, url: url })=>{
    if (fieldId && node.attrs?.id === fieldId) return true;
    if (!url) return false;
    const nodeUrl = node.attrs?.parameters?.macroParams?.url?.value;
    if (typeof nodeUrl !== 'string') return false;
    const entryMauiId = (0, $dOW9b.getMauiIdFromUrl)(url);
    return nodeUrl === url || entryMauiId !== undefined && (0, $dOW9b.getMauiIdFromUrl)(nodeUrl) === entryMauiId;
};
const $93f21268088062df$var$getActiveStackIndex = (doc, stack)=>{
    for(let index = stack.length - 1; index >= 0; index--){
        let found = $93f21268088062df$var$nodeMatchesStackEntry(doc, stack[index]);
        if (!found) doc.descendants((node)=>{
            if ($93f21268088062df$var$nodeMatchesStackEntry(node, stack[index])) {
                found = true;
                return false;
            }
            return true;
        });
        if (found) return index;
    }
    return -1;
};
const $93f21268088062df$var$getUndoneRemixEntry = ({ historyMap: historyMap, newDoc: newDoc, oldDoc: oldDoc })=>{
    for (const historyEntry of Object.values(historyMap)){
        const oldIndex = $93f21268088062df$var$getActiveStackIndex(oldDoc, historyEntry.stack);
        if (oldIndex !== -1 && oldIndex !== $93f21268088062df$var$getActiveStackIndex(newDoc, historyEntry.stack)) return historyEntry.stack[oldIndex];
    }
};
function $93f21268088062df$var$getMatchingStackIndex(stack, { fieldId: fieldId, url: url }) {
    if (!fieldId && !url) return -1;
    for(let index = stack.length - 1; index >= 0; index--){
        const stackEntry = stack[index];
        if (url && stackEntry.url === url || fieldId && stackEntry.fieldId === fieldId) return index;
    }
    return -1;
}
/**
 * Find the history entry whose stack contains a step matching the given id
 * (image fieldId or MAUI app id extracted from the stack entry's URL).
 * Returns the conversation key, the entry, and the matched stack index so the
 * caller can trim redo entries above it.
 */ function $93f21268088062df$var$findHistoryEntryByStackId(historyMap, id) {
    for (const [key, entry] of Object.entries(historyMap).reverse())for(let stackIndex = entry.stack.length - 1; stackIndex >= 0; stackIndex--){
        const stackEntry = entry.stack[stackIndex];
        if (stackEntry.fieldId === id || (0, $dOW9b.getMauiIdFromUrl)(stackEntry.url) === id) return {
            key: key,
            entry: entry,
            stackIndex: stackIndex
        };
    }
    return undefined;
}
function $93f21268088062df$var$reducer(state, meta) {
    switch(meta?.type){
        // for image, the fieldId will be updated after the image is uploaded via updateRemixImageHistoryFieldId
        case 'addHistoryEntry':
            {
                const { admissionBaselineInvocationId: admissionBaselineInvocationId, conversationId: conversationId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, finalMessage: finalMessage, url: url, fieldId: fieldId } = meta.payload;
                const finalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
                const historyEntry = {
                    conversationId: conversationId,
                    dynamicUiSource: dynamicUiSource,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        {
                            ...admissionBaselineInvocationId !== undefined && {
                                admissionBaselineInvocationId: admissionBaselineInvocationId
                            },
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: historyEntry
                    }
                };
            }
        case 'updateRemixImageHistoryFieldId':
            {
                const { conversationId: conversationId, fieldId: fieldId } = meta.payload;
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = historyEntry.stack.length - 1;
                if (currentStackIndex < 0) return state;
                const updatedHistoryEntry = {
                    ...historyEntry,
                    stack: historyEntry.stack.map((stackEntry, index)=>index === currentStackIndex ? {
                            ...stackEntry,
                            fieldId: fieldId
                        } : stackEntry)
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        case 'addHistoryStackEntry':
            {
                const { admissionBaselineInvocationId: admissionBaselineInvocationId, conversationId: conversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, finalMessage: finalMessage, url: url, fieldId: fieldId, previousUrl: previousUrl, previousFieldId: previousFieldId } = meta.payload;
                const finalMessageId = (0, $dOW9b.getFinalMessageId)(finalMessage);
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = $93f21268088062df$var$getMatchingStackIndex(historyEntry.stack, {
                    url: previousUrl,
                    fieldId: previousFieldId
                });
                const stackEntriesToKeep = currentStackIndex === -1 ? historyEntry.stack : historyEntry.stack.slice(0, currentStackIndex + 1);
                const updatedHistoryEntry = {
                    ...historyEntry,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        ...stackEntriesToKeep,
                        {
                            ...admissionBaselineInvocationId !== undefined && {
                                admissionBaselineInvocationId: admissionBaselineInvocationId
                            },
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        // Append a stack entry for a backend-initiated update (bridge stream).
        // No conversationId / finalMessage in payload — inherit both from the
        // existing entry, located by stack-id search. The payload is a
        // discriminated union: MAUI variant carries previousMauiId + new URL;
        // image variant carries previousFieldId + new fieldId.
        case 'addBackendHistoryStackEntry':
            {
                const { payload: payload } = meta;
                const isMauiPayload = (0, $iCjKh.isAddBackendMauiRemixHistoryStackEntryPayload)(payload);
                const lookupId = isMauiPayload ? payload.previousMauiId : payload.previousFieldId;
                const found = $93f21268088062df$var$findHistoryEntryByStackId(state.historyMap, lookupId);
                if (!found) return state;
                const { key: key, entry: entry, stackIndex: stackIndex } = found;
                const matchedStackEntry = entry.stack[stackIndex];
                const inheritedFinalMessage = entry.latestFinalMessage ?? matchedStackEntry.finalMessage;
                const inheritedFinalMessageId = entry.latestFinalMessageId ?? (0, $dOW9b.getFinalMessageId)(entry.latestFinalMessage) ?? matchedStackEntry.finalMessageId ?? (0, $dOW9b.getFinalMessageId)(matchedStackEntry.finalMessage);
                // Prefer the payload's `dynamicUiSubtype` when the processor passes one —
                // a backend edit that changed the type (e.g. line-chart → bar-chart, or a
                // new tree map) — so the style picker reflects the new type. Otherwise
                // inherit the matched entry's subtype (e.g. the backend omitted it).
                const newStackEntry = isMauiPayload ? {
                    dynamicUiType: payload.dynamicUiType ?? matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: payload.dynamicUiSubtype ?? matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: payload.url,
                    fieldId: undefined
                } : {
                    dynamicUiType: matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: undefined,
                    fieldId: payload.fieldId
                };
                const updatedHistoryEntry = {
                    ...entry,
                    stack: [
                        ...entry.stack.slice(0, stackIndex + 1),
                        newStackEntry
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [key]: updatedHistoryEntry
                    }
                };
            }
        case 'goBackInHistory':
        case 'goForwardInHistory':
            return state;
        default:
            return state;
    }
}
const $93f21268088062df$export$2e13bdf171bca4ae = new (0, $kCECX.PluginKey)('remixHistoryPlugin');
function $93f21268088062df$export$275a1873be81202e({ api: api, dispatch: dispatch }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $93f21268088062df$export$2e13bdf171bca4ae,
        state: {
            init () {
                return {
                    historyMap: {}
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($93f21268088062df$export$2e13bdf171bca4ae);
                if (meta) newPluginState = $93f21268088062df$var$reducer(newPluginState, meta);
                if ($93f21268088062df$var$isUndoTransaction(tr) && oldState?.doc && newState?.doc) {
                    const undoneEntry = $93f21268088062df$var$getUndoneRemixEntry({
                        historyMap: pluginState.historyMap,
                        newDoc: newState.doc,
                        oldDoc: oldState.doc
                    });
                    if (undoneEntry) api?.analytics?.actions.fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'remixUndo',
                        attributes: {
                            remixType: undoneEntry.dynamicUiType,
                            remixSubtype: undoneEntry.dynamicUiSubtype
                        }
                    });
                }
                if (newPluginState !== pluginState) dispatch($93f21268088062df$export$2e13bdf171bca4ae, newPluginState);
                return newPluginState;
            }
        }
    });
}


function $f4ca8840d77ba1f3$export$b509b1134d7bb5c1(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'addBackendHistoryStackEntry',
            payload: options
        });
        return tr;
    };
}









var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");




// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");







const $d41f3058f4db498d$export$dba6b5560458426e = 'cc_maui_inline_edit_cancel_on_target_mutation';
const $d41f3058f4db498d$var$entries = new WeakMap();
const $d41f3058f4db498d$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $d41f3058f4db498d$var$entryFor = (api)=>{
    if (!api) return undefined;
    const existing = $d41f3058f4db498d$var$entries.get(api);
    if (existing) return existing;
    const entry = {};
    $d41f3058f4db498d$var$entries.set(api, entry);
    return entry;
};
/**
 * The owner can release a retained attempt without this coordinator, e.g. Stop on the Remix
 * presentation sends `CANCELLED` straight to the lifecycle. Drop such an attempt so it cannot
 * block later edits.
 */ const $d41f3058f4db498d$var$currentAttempt = (entry)=>{
    if (entry?.active?.lifecycle.isCurrent?.() === false) entry.active = undefined;
    return entry?.active;
};
const $d41f3058f4db498d$export$a890533e09d530df = (api, adapter)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry) return ()=>{};
    entry.adapter = adapter;
    return ()=>{
        if (entry.adapter === adapter) {
            entry.adapter = undefined;
            entry.active?.lifecycle.end('aborted');
            entry.active = undefined;
        }
    };
};
const $d41f3058f4db498d$export$12ede4f917884c4 = (api, owner)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry) return ()=>{};
    entry.owner = owner;
    return ()=>{
        if (entry.owner === owner) {
            entry.owner = undefined;
            entry.active?.lifecycle.end('aborted');
            entry.active = undefined;
        }
    };
};
const $d41f3058f4db498d$export$b9869b87d1be6011 = (api, targetId)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    if (!entry?.adapter || !entry.owner) return {
        status: 'unavailable'
    };
    const normalizedTargetId = targetId || undefined;
    if ($d41f3058f4db498d$var$currentAttempt(entry)) return {
        status: 'rejected'
    };
    const lifecycleRetention = (()=>{
        try {
            const lifecycleTargetId = normalizedTargetId ?? `inline-untargeted:${$d41f3058f4db498d$var$randomId()}`;
            return (0, $fjeDY.admitAndRetainEditorRemixLifecycle)({
                adapter: entry.adapter,
                owner: entry.owner,
                request: {
                    kind: 'update',
                    conversationId: lifecycleTargetId,
                    targetNodeId: lifecycleTargetId,
                    updateSentinel: lifecycleTargetId
                }
            });
        } catch  {
            return undefined;
        }
    })();
    if (!lifecycleRetention) return {
        status: 'unavailable'
    };
    if (lifecycleRetention.status === 'active-flow-rejected') return {
        status: 'rejected'
    };
    if (lifecycleRetention.status !== 'retained') return lifecycleRetention.status === 'infrastructure-failure' ? {
        status: 'unavailable'
    } : {
        status: 'legacy'
    };
    const attemptId = lifecycleRetention.lifecycle.remixId;
    // Only a targeted attempt can be cancelled by a target mutation, so only it records exposure.
    const mutationCancellationEnabled = Boolean(normalizedTargetId) && (0, $4o0zT.isExperimentEnabled)($d41f3058f4db498d$export$dba6b5560458426e);
    entry.active = {
        claimed: false,
        lifecycle: lifecycleRetention.lifecycle,
        mutationCancellationEnabled: mutationCancellationEnabled,
        presentationStarted: false,
        targetId: normalizedTargetId,
        artifactType: 'unknown'
    };
    return {
        status: 'admitted',
        attemptId: attemptId
    };
};
const $d41f3058f4db498d$export$8e0c5d14aac36ef6 = (api)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    if (!active?.targetId || !active.mutationCancellationEnabled) return undefined;
    return {
        attemptId: active.lifecycle.remixId,
        localId: active.targetId
    };
};
const $d41f3058f4db498d$export$c5048d45fef04519 = (api)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    if (!active?.mutationCancellationEnabled) return false;
    active.mutationCancellationEnabled = false;
    return true;
};
const $d41f3058f4db498d$export$2f8c8e2f516411c2 = (api)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    const active = $d41f3058f4db498d$var$currentAttempt(entry);
    if (!api || !entry || !active || !active.mutationCancellationEnabled) return undefined;
    return ()=>{
        // A release between capture and this call (owner, settlement, or replacement) is a no-op.
        if ($d41f3058f4db498d$var$currentAttempt(entry) !== active || !active.mutationCancellationEnabled) return false;
        // One cancellation per attempt: later transactions in the same tick must not repeat it.
        active.mutationCancellationEnabled = false;
        try {
            return api.aiExperience?.actions.cancelInlineRovoEdit?.(active.lifecycle.remixId) ?? false;
        } catch  {
            // A failing cancellation must not throw into editor transaction handling.
            return false;
        }
    };
};
const $d41f3058f4db498d$export$516511b718918dc3 = (api, attemptId)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    if (!active || active.lifecycle.remixId !== attemptId || active.presentationStarted) return false;
    active.presentationStarted = true;
    return true;
};
const $d41f3058f4db498d$export$804d6981ddbce4fe = (api, targetId)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    if (!active || !targetId || !active.targetId || active.targetId !== targetId || active.claimed) return undefined;
    active.claimed = true;
    return active.lifecycle.remixId;
};
const $d41f3058f4db498d$export$ffcbf537033846f5 = (api, observation)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    // A concurrent rejected/unavailable submission is not the retained attempt and must not
    // relabel the active flow.
    if (active && observation.outcome === 'admitted') active.artifactType = observation.artifactType;
};
const $d41f3058f4db498d$export$14ce80a40ed788cd = (api, attemptId)=>{
    const active = $d41f3058f4db498d$var$currentAttempt($d41f3058f4db498d$var$entryFor(api));
    if (!active || active.lifecycle.remixId !== attemptId || active.claimed) return false;
    return $d41f3058f4db498d$export$5b4e6541783f126c(api, attemptId, 'handoff');
};
const $d41f3058f4db498d$export$5b4e6541783f126c = (api, attemptId, result)=>{
    const entry = $d41f3058f4db498d$var$entryFor(api);
    const active = $d41f3058f4db498d$var$currentAttempt(entry);
    if (!entry || !active || active.lifecycle.remixId !== attemptId) return false;
    const transition = (event)=>active.lifecycle.transition(event);
    if (result === 'result-ready' || result === 'direct-insertion-started') // From here the bridge rewrites the target node itself; that must not read as a user edit.
    active.mutationCancellationEnabled = false;
    if (result === 'result-ready') return transition({
        type: 'RESULT_READY'
    });
    if (result === 'direct-insertion-started') return transition({
        type: 'DIRECT_INSERTION_STARTED'
    });
    if (result === 'handoff') {
        if (!active.lifecycle.end('handed-off')) return false;
    } else if (result === 'inserted') {
        if (!transition({
            type: 'INSERTED'
        })) return false;
    } else if (result === 'insertion-failed') {
        if (!transition({
            type: 'INSERTION_FAILED'
        })) return false;
    } else if (result === 'generation-error') {
        if (!transition({
            type: 'GENERATION_ERROR'
        })) return false;
    } else if (!transition({
        type: 'GENERATION_ABORTED'
    })) return false;
    // The retained attempt owns its artifact loading state. Clear it only after
    // a matching terminal transition, so a late result cannot clear a newer edit.
    // MAUI insertion leaves the target for the bridge's ready-bar check and
    // subsequent endAIExperience call.
    if ((0, $4o0zT.isExperimentEnabled)('cc_maui_1293_chat_thinking_bar')) {
        const liveTargetId = api?.aiExperience?.sharedState?.currentState()?.aiDecorationExperiencePluginState?.inlineRovoStreamingTargetId;
        if (active.targetId && active.targetId === liveTargetId && (result !== 'inserted' || active.artifactType === 'image')) api?.aiExperience?.actions.endInlineRovoStreaming?.();
    }
    entry.active = undefined;
    return true;
};


/**
 * Editor-`api`-keyed slots for callbacks that cross a boundary React context cannot.
 *
 * The thinking widget renders through `nodeViewPortalProviderAPI`, so it is not a descendant of the
 * plugin's `contentComponent()`. The UX closures live in `RemixContentComponentInner`, inside
 * `@atlassian/malleable-ui-components`, which cannot import from this package. Both reach across via
 * `api`, the way `onRegisterAbortRequest` already bridges `registerAbortRequest` in `./remix-state`.
 *
 * Machine ownership and completion presentation belong to the retained lifecycle session; UX
 * handles belong to a content component that unmounts on terminal cleanup.
 */ const $dc44c0de1ed07c1a$export$a859f285a4975566 = ()=>{
    const entries = new WeakMap();
    return {
        get: (api)=>api ? entries.get(api)?.value : undefined,
        register: (api, value)=>{
            // No-op cleanup for an absent api keeps callers from branching.
            if (!api) return ()=>{};
            const entry = {
                value: value
            };
            entries.set(api, entry);
            return ()=>{
                if (entries.get(api) === entry) entries.delete(api);
            };
        }
    };
};
const $dc44c0de1ed07c1a$var$uxHandlesSlot = $dc44c0de1ed07c1a$export$a859f285a4975566();
const $dc44c0de1ed07c1a$var$lifecycleSessions = new WeakMap();
const $dc44c0de1ed07c1a$var$presentationListeners = new WeakMap();
const $dc44c0de1ed07c1a$var$mutationCancellationSinks = new WeakMap();
const $dc44c0de1ed07c1a$var$EMPTY_PRESENTATION = Object.freeze({
    animationFinished: false,
    authority: undefined,
    phase: undefined,
    remixId: undefined,
    token: undefined
});
const $dc44c0de1ed07c1a$var$notifyPresentation = (api)=>{
    $dc44c0de1ed07c1a$var$presentationListeners.get(api)?.forEach((listener)=>{
        try {
            listener();
        } catch  {
        // A presentation subscriber cannot prevent lifecycle authority from latching or releasing.
        }
    });
};
const $dc44c0de1ed07c1a$export$d8fb321eb73ac931 = (api)=>{
    const captured = $dc44c0de1ed07c1a$export$66f5178019bac961(api);
    return captured ? ()=>{
        captured();
    } : undefined;
};
const $dc44c0de1ed07c1a$export$66f5178019bac961 = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    return session?.authority === 'active' ? session.animationFinishedSink : undefined;
};
const $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0 = (api)=>{
    if (!api) return undefined;
    const capturedApi = api;
    const captured = $dc44c0de1ed07c1a$var$lifecycleSessions.get(capturedApi);
    if (!captured) return undefined;
    return (cleanup)=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(capturedApi) !== captured) return false;
        try {
            cleanup();
        } finally{
            if (captured.authority === 'terminal-latched') $dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(capturedApi, captured.token);
        }
        return true;
    };
};
const $dc44c0de1ed07c1a$export$7d31a25b751a9034 = (api, handles)=>$dc44c0de1ed07c1a$var$uxHandlesSlot.register(api, handles);
const $dc44c0de1ed07c1a$export$e4c5d0e97ec647cf = (api, sink)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.authority !== 'active') return ()=>{};
    const entry = {
        session: session,
        sink: sink
    };
    $dc44c0de1ed07c1a$var$mutationCancellationSinks.set(api, entry);
    return ()=>{
        if ($dc44c0de1ed07c1a$var$mutationCancellationSinks.get(api) === entry) $dc44c0de1ed07c1a$var$mutationCancellationSinks.delete(api);
    };
};
const $dc44c0de1ed07c1a$export$5ff3ad1bbf1465a9 = (api)=>{
    if (!api) return undefined;
    const entry = $dc44c0de1ed07c1a$var$mutationCancellationSinks.get(api);
    if (!entry || $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== entry.session || entry.session.authority !== 'active' || !entry.session.mutationCancellationEnabled) return undefined;
    return ()=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== entry.session || entry.session.authority !== 'active') return false;
        entry.session.mutationInvalidationPending = true;
        const cancelled = entry.sink();
        // A refused cancellation must not leak presentation state.
        if (!cancelled && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) === entry.session) entry.session.mutationInvalidationPending = false;
        return cancelled;
    };
};
const $dc44c0de1ed07c1a$export$8c3960abef4008ee = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.authority !== 'active') return false;
    session.mutationCancellationEnabled = false;
    return true;
};
const $dc44c0de1ed07c1a$export$c2ad78149c7e98ec = (api, remixId)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!session || session.remixId !== remixId || !session.mutationInvalidationPending) return false;
    session.mutationInvalidationPending = false;
    return true;
};
const $dc44c0de1ed07c1a$export$a174cbea3e7863fe = (api)=>$dc44c0de1ed07c1a$var$uxHandlesSlot.get(api);
const $dc44c0de1ed07c1a$export$10406465ad92edb2 = (api, options)=>{
    if (!api) return ()=>{};
    const { remixId: remixId, token: token } = options;
    const session = {
        animationFinished: false,
        animationFinishedSink: ()=>{
            // The closure captures the session identity at registration time. A portal callback retained
            // by A cannot complete a replacement B, even if B is now the registry's current session.
            const currentSession = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
            if (!api || currentSession !== session || currentSession?.token !== token || currentSession.authority !== 'active') return false;
            $dc44c0de1ed07c1a$export$9b7a6c697ac7e013(api, token);
            return true;
        },
        remixId: remixId,
        token: token,
        authority: 'active',
        mutationCancellationEnabled: true,
        mutationInvalidationPending: false,
        presentation: {
            animationFinished: false,
            authority: 'active',
            phase: undefined,
            remixId: remixId,
            token: token
        }
    };
    $dc44c0de1ed07c1a$var$lifecycleSessions.set(api, session);
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
    const cleanup = Object.assign(()=>{
        if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== session || session.authority === 'terminal-latched') return;
        $dc44c0de1ed07c1a$var$lifecycleSessions.delete(api);
        $dc44c0de1ed07c1a$var$notifyPresentation(api);
    }, {
        latchTerminalAuthority: ()=>{
            if ($dc44c0de1ed07c1a$var$lifecycleSessions.get(api) !== session) return;
            session.authority = 'terminal-latched';
            session.presentation = {
                ...session.presentation,
                authority: 'terminal-latched'
            };
            $dc44c0de1ed07c1a$var$notifyPresentation(api);
        },
        settleTerminalAuthority: ()=>$dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(api, token)
    });
    return cleanup;
};
const $dc44c0de1ed07c1a$export$4050079e84e0fec6 = (api)=>Boolean(api && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api)?.authority === 'active');
const $dc44c0de1ed07c1a$export$f2d1c70f96537b99 = (api)=>Boolean(api && $dc44c0de1ed07c1a$var$lifecycleSessions.get(api)?.token);
/** Releases only the matching terminal authority lease; stale cleanup cannot affect a replacement. */ function $dc44c0de1ed07c1a$var$releaseEditorRemixLifecycleAuthority(api, token) {
    if (!api || token === undefined) return false;
    const session = $dc44c0de1ed07c1a$var$lifecycleSessions.get(api);
    if (session?.token !== token || session.authority !== 'terminal-latched') return false;
    $dc44c0de1ed07c1a$var$lifecycleSessions.delete(api);
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
    return true;
}
const $dc44c0de1ed07c1a$export$58aeb614b6d856f7 = (api)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    return session?.presentation ?? $dc44c0de1ed07c1a$var$EMPTY_PRESENTATION;
};
const $dc44c0de1ed07c1a$export$ca9605d624b3c2db = (api, listener)=>{
    if (!api) return ()=>{};
    const listeners = $dc44c0de1ed07c1a$var$presentationListeners.get(api) ?? new Set();
    $dc44c0de1ed07c1a$var$presentationListeners.set(api, listeners);
    listeners.add(listener);
    return ()=>listeners.delete(listener);
};
const $dc44c0de1ed07c1a$export$1ae55ee74816df71 = (api, token, phase)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || token === undefined || session.token !== token) return;
    if (session.presentation.phase === phase) return;
    session.presentation = {
        ...session.presentation,
        phase: phase
    };
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
};
const $dc44c0de1ed07c1a$export$9b7a6c697ac7e013 = (api, token)=>{
    const session = api ? $dc44c0de1ed07c1a$var$lifecycleSessions.get(api) : undefined;
    if (!api || !session || session.token !== token || session.authority !== 'active' || session.animationFinished) return;
    session.animationFinished = true;
    session.presentation = {
        ...session.presentation,
        animationFinished: true
    };
    $dc44c0de1ed07c1a$var$notifyPresentation(api);
};





function $d6e48ea9734cb2b1$export$aadcc3ba2430b(doc, localId) {
    let found;
    doc.descendants((node, pos)=>{
        if (found) return false;
        if (node.attrs?.localId === localId) {
            found = {
                node: node,
                pos: pos
            };
            return false;
        }
        return true;
    });
    return found;
}
function $d6e48ea9734cb2b1$export$a4adf1fa5f704f96(before, after) {
    if (!after) return true;
    if (after.type !== before.type) return true;
    if (before.type.name === 'mediaSingle') {
        const beforeMedia = before.firstChild;
        const afterMedia = after.firstChild;
        return !beforeMedia || !afterMedia || !beforeMedia.eq(afterMedia);
    }
    return false;
}
function $d6e48ea9734cb2b1$export$9c5a58d22cfc825e(oldDoc, newDoc, localId) {
    const before = $d6e48ea9734cb2b1$export$aadcc3ba2430b(oldDoc, localId);
    if (!before) return false;
    return $d6e48ea9734cb2b1$export$a4adf1fa5f704f96(before.node, $d6e48ea9734cb2b1$export$aadcc3ba2430b(newDoc, localId)?.node);
}
const $d6e48ea9734cb2b1$var$rangeOf = ({ node: node, pos: pos })=>({
        from: pos,
        to: pos + node.nodeSize
    });
function $d6e48ea9734cb2b1$export$190321771ee8e286({ isRangeTouched: isRangeTouched, localId: localId, mapping: mapping, newDoc: newDoc, oldDoc: oldDoc, range: range }) {
    const current = range ?? (()=>{
        const resolved = $d6e48ea9734cb2b1$export$aadcc3ba2430b(oldDoc, localId);
        return resolved ? $d6e48ea9734cb2b1$var$rangeOf(resolved) : undefined;
    })();
    if (!current) // Not in the old document: nothing to compare against for this transaction.
    return {
        changed: false,
        range: undefined
    };
    const mapped = {
        from: mapping.map(current.from, 1),
        to: mapping.map(current.to, -1)
    };
    if (!isRangeTouched(current)) return {
        changed: false,
        range: mapped
    };
    const before = oldDoc.nodeAt(current.from);
    if (!before || before.attrs?.localId !== localId) // The cached range drifted from the target; re-anchor from scratch on the next transaction.
    return {
        changed: false,
        range: undefined
    };
    const atMapped = mapped.to > mapped.from && mapped.from < newDoc.content.size ? newDoc.nodeAt(mapped.from) : null;
    const after = atMapped && atMapped.attrs?.localId === localId ? {
        node: atMapped,
        pos: mapped.from
    } : $d6e48ea9734cb2b1$export$aadcc3ba2430b(newDoc, localId);
    return {
        changed: $d6e48ea9734cb2b1$export$a4adf1fa5f704f96(before, after?.node),
        range: after ? $d6e48ea9734cb2b1$var$rangeOf(after) : undefined
    };
}






var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");











var $b6QLO = parcelRequire("b6QLO");





const $06443500a2493931$export$5569fef6b45e570f = ({ reopenModal: reopenModal } = {})=>({ tr: tr })=>{
        const thinkingMeta = {
            presentation: {
                kind: 'stop',
                preserveSavedSelection: !!reopenModal
            },
            lifecycle: {
                kind: 'legacy-stop'
            }
        };
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), thinkingMeta);
        if (reopenModal) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            isRemixModalOpen: true
        });
        return tr;
    };











/**
 * Registry keyed by the editor api object (unique per editor instance).
 * Stores the stopRemixing function so cancelRemixThinking can call it to abort
 * the in-flight AI request and trigger paired aiInteraction analytics via AbortError,
 * without needing stopRemixing to be passed through the component tree.
 *
 * Uses the shared slot so a stale cleanup cannot delete a newer registration. No current mount
 * sequence produces one (there is a single registering effect per editor), so this keeps the
 * guarantee without changing behaviour.
 */ const $b96b9e650a905796$var$abortRequestSlot = (0, $dc44c0de1ed07c1a$export$a859f285a4975566)();
function $b96b9e650a905796$export$f9cb53c9d12f6f55(api, abortFn) {
    return $b96b9e650a905796$var$abortRequestSlot.register(api, abortFn);
}
function $b96b9e650a905796$export$e125c3b8c9ddf1a1(api) {
    return $b96b9e650a905796$var$abortRequestSlot.get(api);
}
function $b96b9e650a905796$export$e02ace41eac2e13a({ api: api, reopenModal: reopenModal }) {
    // end the inline-Rovo streaming
    api?.aiExperience?.actions?.endInlineRovoStreaming?.();
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
        // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
        // call the onCancel callback instead of reopening the remix modal.
        const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
        const userPrompt = remixModalMetadata?.userPrompt;
        const onCancel = remixModalMetadata?.onCancel;
        if (onCancel && userPrompt) {
            api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                reopenModal: false
            }));
            onCancel();
            return;
        }
    }
    const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
    api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
        reopenModal: reopenModal ?? ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop') ? false : !isUpdate)
    }));
}
function $b96b9e650a905796$export$ae8cbff5055b0856({ api: api, capturedAnimationFinishedSink: capturedAnimationFinishedSink }) {
    if (capturedAnimationFinishedSink) {
        // The sink is the whole guard: it accepts only while this flow still holds its session, so a
        // late callback retained by flow A cannot release entry points that replacement B disabled.
        // This relies on the insertion settle running *after* completion (see `hasInsertionSucceeded`
        // in `useOnComplete`); settle first and the session is already gone, the sink declines, and
        // nothing ever re-enables the entry points.
        if (capturedAnimationFinishedSink()) api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        return;
    }
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)());
}


const $29d6db7c0a9c3ffe$export$4ea4004ba136efe5 = 'remix-thinking-widget';
const $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY = 'remix-thinking-widget-placeholder';
function $29d6db7c0a9c3ffe$export$ca6d884735f53b24({ api: api, container: container, contentType: contentType, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput = false, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const intl = getIntl();
    const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
    const userPrompt = remixModalMetadata?.userPrompt;
    const capturedCompletionSink = (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api) ? (0, $dc44c0de1ed07c1a$export$66f5178019bac961)(api) : undefined;
    const capturedTerminalCleanupSink = (0, $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0)(api);
    const onStopThinking = ()=>{
        // Settle the attempt rendered by this presentation, not the current active attempt.
        if (remixAttemptId) api?.malleableUi?.actions.reportInlineRovoEdit?.(remixAttemptId, 'generation-aborted');
        const cleanup = ()=>{
            const shouldCloseModal = !userPrompt;
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                // Abort before cancelling so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events via AbortError.
                (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                    api: api,
                    reopenModal: shouldCloseModal ? false : undefined
                });
            } else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                    const onCancel = remixModalMetadata?.onCancel;
                    if (onCancel && userPrompt) {
                        // Abort the AI request so send-message-action.ts fires the paired
                        // aiInteraction initiated + dismissed events automatically via AbortError.
                        (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                        api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                            reopenModal: false
                        }));
                        onCancel();
                        return;
                    }
                }
                const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
                api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)({
                    reopenModal: shouldCloseModal ? false : (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? !isUpdate : true
                }));
            }
        };
        const cancel = ()=>{
            const cancelFromThinkingBar = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.cancelFromThinkingBar : undefined;
            if (cancelFromThinkingBar) cancelFromThinkingBar(cleanup);
            else cleanup();
        };
        if (capturedTerminalCleanupSink) capturedTerminalCleanupSink(cancel);
        else cancel();
    };
    const onComplete = ()=>{
        if (capturedCompletionSink) {
            if (capturedCompletionSink()) api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            return;
        }
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute((0, $06443500a2493931$export$5569fef6b45e570f)());
        }
    };
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: intl.defaultLocale || 'en-US',
            locale: intl.locale || 'en-US',
            messages: intl.messages,
            formats: intl.formats,
            onError: intl.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            isWaitingForInput: isWaitingForInput,
            remixAttemptId: remixAttemptId,
            loadingBarType: "big-bar",
            // when userPrompt is not set, it means it is a remix entrance
            // otherwise it is a non-remix entrance
            isRemixEntrance: (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? !userPrompt : true,
            contentType: contentType,
            isComplete: isComplete,
            isRelative: true,
            onCompleteAnimationFinished: onComplete,
            onStop: onStopThinking,
            showProgressBar: true
        })), container, $29d6db7c0a9c3ffe$export$4ea4004ba136efe5, undefined, true);
}
function $29d6db7c0a9c3ffe$var$createRemixThinkingWidget({ api: api, contentType: contentType, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput, isPlaceholder: isPlaceholder, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const document = (0, $1hQ0e.getDocument)();
    if (!document) throw new Error('Document is required to render the remix thinking widget.');
    const container = document.createElement('div');
    container.className = isPlaceholder ? `${$29d6db7c0a9c3ffe$export$4ea4004ba136efe5} ${$29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY}` : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    container.dataset.testid = isPlaceholder ? $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    if (!isPlaceholder) $29d6db7c0a9c3ffe$export$ca6d884735f53b24({
        api: api,
        container: container,
        contentType: contentType,
        getIntl: getIntl,
        isComplete: isComplete,
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: remixAttemptId,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    });
    return container;
}
function $29d6db7c0a9c3ffe$export$2f3df55a342cf539(view) {
    return view.dom.querySelector(`.${$29d6db7c0a9c3ffe$export$4ea4004ba136efe5}`);
}
function $29d6db7c0a9c3ffe$var$getPositionAfterDepthOneParent({ doc: doc, to: to }) {
    const $to = doc.resolve(to);
    return $to.depth >= 1 ? $to.after(1) : to;
}
function $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d({ api: api, contentType: contentType, doc: doc, getIntl: getIntl, isComplete: isComplete, isWaitingForInput: isWaitingForInput, isPlaceholder: isPlaceholder, remixAttemptId: remixAttemptId, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, to: to }) {
    const decorationKey = isPlaceholder ? $29d6db7c0a9c3ffe$var$THINKING_WIDGET_PLACEHOLDER_KEY : $29d6db7c0a9c3ffe$export$4ea4004ba136efe5;
    const widgetPosition = $29d6db7c0a9c3ffe$var$getPositionAfterDepthOneParent({
        doc: doc,
        to: to
    });
    return (0, $8nvEM.Decoration).widget(widgetPosition, ()=>$29d6db7c0a9c3ffe$var$createRemixThinkingWidget({
            api: api,
            contentType: contentType,
            getIntl: getIntl,
            isComplete: isComplete ?? false,
            isWaitingForInput: isWaitingForInput ?? false,
            isPlaceholder: isPlaceholder,
            remixAttemptId: remixAttemptId,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        }), {
        key: decorationKey,
        // use a low negative side to ensure the decoration is rendered before all other decorations
        // so other decorations update don't cause this decoration to be re-rendered
        side: -999,
        destroy: ()=>{
            if (!isPlaceholder) nodeViewPortalProviderAPI.remove($29d6db7c0a9c3ffe$export$4ea4004ba136efe5);
        }
    });
}


const $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS = 'remix-thinking-highlight';
const $5ea92dab24394af7$export$38c8fc373d691b1d = new (0, $kCECX.PluginKey)('remixThinkingPlugin');
function $5ea92dab24394af7$var$getInitialState() {
    return {
        isThinking: false,
        isComplete: false,
        isUpdate: false,
        historyEntryForUpdate: undefined,
        dynamicUiSubtypeForUpdate: undefined,
        remixAttemptId: undefined,
        decorationSet: (0, $8nvEM.DecorationSet).empty
    };
}
function $5ea92dab24394af7$var$withoutInlineTargetRange(pluginState) {
    if (!('inlineTargetRange' in pluginState)) return pluginState;
    const nextState = {
        ...pluginState
    };
    delete nextState.inlineTargetRange;
    return nextState;
}
/**
 * Follows the admitted inline Rovo edit's target across `tr` and cancels the attempt when the
 * target changed identity (deleted, converted, or its media child edited). Inline edits never
 * write `savedSelection`; their target is tracked by localId on the admitted attempt instead.
 *
 * This must not depend on `isThinking`: the machine projection lands in a React commit, and the
 * user's delete can arrive first. The target is resolved with one traversal per attempt and then
 * remapped through `tr.mapping`, so the per-transaction cost is O(steps) unless a step touched it.
 */ function $5ea92dab24394af7$var$applyInlineRovoEditTargetTracking({ api: api, newState: newState, oldState: oldState, pluginState: pluginState, tr: tr }) {
    if (tr.getMeta((0, $bpOXf.INLINE_ROVO_EDIT_INSERTION_META))) {
        // The bridge is inserting the inline edit's own result. That rewrite ends tracking, whether
        // or not the bridge claimed the attempt (an unclaimed attempt never reports `result-ready`).
        (0, $d41f3058f4db498d$export$c5048d45fef04519)(api);
        return $5ea92dab24394af7$var$withoutInlineTargetRange(pluginState);
    }
    const target = (0, $d41f3058f4db498d$export$8e0c5d14aac36ef6)(api);
    const cached = pluginState.inlineTargetRange;
    if (!target) return $5ea92dab24394af7$var$withoutInlineTargetRange(pluginState);
    const cachedForAttempt = cached?.attemptId === target.attemptId && cached.localId === target.localId ? cached : undefined;
    const withRange = (range)=>{
        if (!range) return $5ea92dab24394af7$var$withoutInlineTargetRange(pluginState);
        if (cachedForAttempt && cachedForAttempt.from === range.from && cachedForAttempt.to === range.to) return pluginState;
        return {
            ...pluginState,
            inlineTargetRange: {
                ...range,
                attemptId: target.attemptId,
                localId: target.localId
            }
        };
    };
    if (!tr.docChanged) {
        if (cachedForAttempt) return pluginState;
        // One-time initialisation for a newly admitted attempt (guarded traversal).
        const resolved = (0, $d6e48ea9734cb2b1$export$aadcc3ba2430b)(newState.doc, target.localId);
        return withRange(resolved ? {
            from: resolved.pos,
            to: resolved.pos + resolved.node.nodeSize
        } : undefined);
    }
    const { changed: changed, range: range } = (0, $d6e48ea9734cb2b1$export$190321771ee8e286)({
        isRangeTouched: ({ from: from, to: to })=>$5ea92dab24394af7$export$ac33393cae2df1df({
                maps: tr.mapping.maps,
                savedSelection: {
                    from: from,
                    to: to,
                    isNodeSelection: true
                }
            }),
        localId: target.localId,
        mapping: tr.mapping,
        newDoc: newState.doc,
        oldDoc: oldState.doc,
        range: cachedForAttempt
    });
    if (changed) {
        // Capture the attempt before leaving Plugin.apply; the abort dispatches transactions.
        const cancelInlineEdit = (0, $d41f3058f4db498d$export$2f8c8e2f516411c2)(api);
        if (cancelInlineEdit) queueMicrotask(()=>{
            cancelInlineEdit();
        });
    }
    return withRange(range);
}
function $5ea92dab24394af7$var$withoutWaitingForInput(pluginState) {
    if (!('isWaitingForInput' in pluginState)) return pluginState;
    const nextState = {
        ...pluginState
    };
    delete nextState.isWaitingForInput;
    return nextState;
}
/**
 * Whether every field the `reset` presentation kind clears is already cleared. `isThinking` and
 * `isComplete` are excluded: they belong to the lifecycle channel, which `reset` leaves alone.
 */ function $5ea92dab24394af7$var$hasNoPresentationState(pluginState) {
    return pluginState.contentType === undefined && pluginState.remixAttemptId === undefined && pluginState.isUpdate === false && pluginState.historyEntryForUpdate === undefined && pluginState.dynamicUiSubtypeForUpdate === undefined && pluginState.savedSelection === undefined && !pluginState.isWaitingForInput && pluginState.decorationSet.find().length === 0;
}
function $5ea92dab24394af7$export$ac33393cae2df1df({ maps: maps, savedSelection: savedSelection }) {
    let { from: from, to: to } = savedSelection;
    for (const map of maps){
        let touched = false;
        map.forEach((oldStart, oldEnd)=>{
            if (oldStart === oldEnd) {
                // Boundary insertions are outside the tracked content.
                touched || (touched = oldStart > from && oldStart < to);
                return;
            }
            // This also catches equal-size replacement, for which mapped positions alone are ambiguous.
            touched || (touched = oldStart < to && oldEnd > from);
        });
        if (touched) return true;
        // Keep boundary insertions outside the remapped range.
        from = map.map(from, 1);
        to = map.map(to, -1);
    }
    return false;
}
function $5ea92dab24394af7$var$reducePresentationUpdate({ api: api, getIntl: getIntl, isViewMode: isViewMode, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, newState: newState, presentation: presentation, pluginState: pluginState }) {
    switch(presentation.kind){
        case 'reset':
            // Same reference when there is nothing to clear, so a caller that pairs this with a
            // lifecycle write does not churn the plugin state on a no-op.
            if ($5ea92dab24394af7$var$hasNoPresentationState(pluginState)) return pluginState;
            return {
                ...$5ea92dab24394af7$var$getInitialState(),
                isComplete: pluginState.isComplete,
                isThinking: pluginState.isThinking
            };
        case 'start':
            {
                const from = presentation.thinkingSelectionFrom;
                const to = presentation.thinkingSelectionTo;
                let decorations;
                if (presentation.suppressThinkingHighlight) decorations = [];
                else if (presentation.cellSelectionRanges) decorations = presentation.cellSelectionRanges.map((range)=>(0, $8nvEM.Decoration).inline(range.from, range.to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    }));
                else if (presentation.isNodeSelection) decorations = [
                    (0, $8nvEM.Decoration).node(from, to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    })
                ];
                else decorations = [
                    (0, $8nvEM.Decoration).inline(from, to, {
                        class: $5ea92dab24394af7$var$THINKING_HIGHLIGHT_CLASS
                    })
                ];
                if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) decorations.push((0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                    api: api,
                    contentType: presentation.contentType,
                    doc: newState.doc,
                    getIntl: getIntl,
                    isComplete: false,
                    isWaitingForInput: false,
                    isPlaceholder: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.isUpdate ?? false : false,
                    remixAttemptId: presentation.remixAttemptId,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    to: to
                }));
                const decorationSet = (0, $8nvEM.DecorationSet).create(newState.doc, decorations);
                const result = {
                    contentType: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? presentation.contentType : undefined,
                    remixAttemptId: presentation.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.isUpdate : undefined,
                    dynamicUiSubtypeForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.dynamicUiSubtypeForUpdate : undefined,
                    historyEntryForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? presentation.historyEntryForUpdate : undefined,
                    isComplete: pluginState.isComplete,
                    decorationSet: decorationSet,
                    savedSelection: {
                        from: from,
                        to: to,
                        isNodeSelection: presentation.isNodeSelection ?? false,
                        anchorCellPos: presentation.anchorCellPos,
                        headCellPos: presentation.headCellPos
                    }
                };
                return result;
            }
        case 'clear-decoration':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') || !pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    ...pluginState.isWaitingForInput ? {
                        isWaitingForInput: true
                    } : {},
                    isUpdate: pluginState.isUpdate,
                    isComplete: pluginState.isComplete,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: (0, $8nvEM.DecorationSet).empty,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'stop':
            {
                const decorations = [];
                if (!isViewMode && pluginState.isComplete && pluginState.savedSelection?.to) decorations.push((0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                    api: api,
                    // The pre-split stop meta never carried a contentType.
                    contentType: undefined,
                    doc: newState.doc,
                    getIntl: getIntl,
                    isComplete: false,
                    isWaitingForInput: false,
                    isPlaceholder: true,
                    remixAttemptId: pluginState.remixAttemptId,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    to: pluginState.savedSelection.to
                }));
                const result = {
                    contentType: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.contentType : undefined,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: pluginState.isComplete,
                    decorationSet: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $8nvEM.DecorationSet).create(newState.doc, decorations) : (0, $8nvEM.DecorationSet).empty,
                    savedSelection: presentation.preserveSavedSelection ? pluginState.savedSelection : undefined
                };
                return result;
            }
    }
}
// Returns `undefined` where the pre-split reducer fell through without a result.
function $5ea92dab24394af7$var$reduceLifecycleUpdate({ lifecycle: lifecycle, pluginState: pluginState }) {
    switch(lifecycle.kind){
        case 'legacy-start':
            {
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: true,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? false : undefined,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-complete':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (pluginState.isComplete || !pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: pluginState.isThinking,
                    isUpdate: pluginState.isUpdate,
                    isComplete: true,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-complete-false':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (pluginState.isComplete === false) return pluginState;
                const result = {
                    contentType: undefined,
                    remixAttemptId: undefined,
                    isThinking: false,
                    isComplete: false,
                    isUpdate: false,
                    historyEntryForUpdate: undefined,
                    dynamicUiSubtypeForUpdate: undefined,
                    decorationSet: (0, $8nvEM.DecorationSet).empty,
                    savedSelection: undefined
                };
                return result;
            }
        case 'legacy-stop':
            {
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: false,
                    isUpdate: pluginState.isUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.isComplete : undefined,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-clear':
            {
                if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return undefined;
                if (!pluginState.isThinking) return pluginState;
                const result = {
                    contentType: pluginState.contentType,
                    remixAttemptId: pluginState.remixAttemptId,
                    isThinking: true,
                    isUpdate: pluginState.isUpdate,
                    isComplete: false,
                    historyEntryForUpdate: pluginState.historyEntryForUpdate,
                    dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
                    decorationSet: pluginState.decorationSet,
                    savedSelection: pluginState.savedSelection
                };
                return result;
            }
        case 'legacy-reset':
            return $5ea92dab24394af7$var$getInitialState();
        case 'dismiss':
            if (!pluginState.isThinking && !pluginState.isComplete) return pluginState;
            // The pair the machine's terminal projection writes, so it agrees when it gets there.
            return $5ea92dab24394af7$var$withoutWaitingForInput({
                ...pluginState,
                isThinking: false,
                isComplete: false
            });
        case 'machine-projection':
            {
                const { isComplete: isComplete, isThinking: isThinking } = lifecycle;
                if (isThinking === pluginState.isThinking && isComplete === pluginState.isComplete) return pluginState;
                const result = {
                    ...pluginState,
                    isThinking: isThinking,
                    isComplete: isComplete
                };
                return isThinking && !isComplete ? result : $5ea92dab24394af7$var$withoutWaitingForInput(result);
            }
    }
}
/**
 * normal flow:
 * - reset when show modal
 * - start: isThinking: true
 * - complete: isThinking: true; isComplete: true (after we have final network response)
 * - stop: isThinking: false; isComplete: true; (after onCompleteAnimationFinished)
 * 	 - we can't reset isComplete when stop thinking because we need it to show the ready toast
 *   - if the ready toast is not shown, currently, we're not resetting isComplete at all
 *   - if this become a bigger issue later, we need to properly reset it
 * - optional: complete-false: isThinking: false; isComplete: false; (after clicking ready toast)
 *
 * update flow:
 * - start: isThinking: true; isUpdate: true;
 * - rest is same as normal flow
 */ function $5ea92dab24394af7$var$reducePluginState({ api: api, getIntl: getIntl, isViewMode: isViewMode, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, newState: newState, meta: meta, pluginState: pluginState }) {
    if (!meta.presentation && !meta.lifecycle && meta.isWaitingForInput === undefined) return undefined;
    let result = pluginState;
    if (meta.presentation) result = $5ea92dab24394af7$var$reducePresentationUpdate({
        api: api,
        getIntl: getIntl,
        isViewMode: isViewMode,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        newState: newState,
        presentation: meta.presentation,
        pluginState: result
    });
    if (meta.lifecycle) {
        const isLegacyLifecycle = meta.lifecycle.kind.startsWith('legacy-');
        if (isLegacyLifecycle && (0, $dc44c0de1ed07c1a$export$f2d1c70f96537b99)(api)) return meta.presentation ? result : undefined;
        const lifecycleResult = $5ea92dab24394af7$var$reduceLifecycleUpdate({
            lifecycle: meta.lifecycle,
            pluginState: result
        });
        if (lifecycleResult) result = lifecycleResult;
    }
    if (meta.isWaitingForInput !== undefined) {
        const isWaitingForInput = result.isThinking && !result.isComplete ? meta.isWaitingForInput : false;
        if (isWaitingForInput && !result.isWaitingForInput) result = {
            ...result,
            isWaitingForInput: true
        };
        else if (!isWaitingForInput && result.isWaitingForInput) result = $5ea92dab24394af7$var$withoutWaitingForInput(result);
    }
    return result === pluginState ? undefined : result;
}
function $5ea92dab24394af7$export$1c17a47e3daa5065({ api: api, config: config, dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $5ea92dab24394af7$export$38c8fc373d691b1d,
        state: {
            init () {
                return $5ea92dab24394af7$var$getInitialState();
            },
            apply (tr, incomingPluginState, oldState, newState) {
                const pluginState = $5ea92dab24394af7$var$applyInlineRovoEditTargetTracking({
                    api: api,
                    newState: newState,
                    oldState: oldState,
                    pluginState: incomingPluginState,
                    tr: tr
                });
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const meta = tr.getMeta($5ea92dab24394af7$export$38c8fc373d691b1d);
                if (meta) {
                    const result = $5ea92dab24394af7$var$reducePluginState({
                        api: api,
                        getIntl: getIntl,
                        isViewMode: isViewMode,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                        newState: newState,
                        meta: meta,
                        pluginState: pluginState
                    });
                    if (result) {
                        dispatch($5ea92dab24394af7$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                if (pluginState.isThinking && tr.docChanged && pluginState.savedSelection && $5ea92dab24394af7$export$ac33393cae2df1df({
                    maps: tr.mapping.maps,
                    savedSelection: pluginState.savedSelection
                })) {
                    // Capture the session before leaving Plugin.apply.
                    const cancel = (0, $dc44c0de1ed07c1a$export$5ff3ad1bbf1465a9)(api);
                    if (cancel) queueMicrotask(()=>{
                        cancel();
                    });
                }
                if (pluginState.isThinking) {
                    // Remap savedSelection even when visual decorations are suppressed.
                    let mappedDecorationSet = pluginState.decorationSet;
                    if (pluginState.decorationSet !== (0, $8nvEM.DecorationSet).empty) {
                        mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                        // re-create the thinking widget decoration if the widget is not in the mapped decoration set while thinking
                        // it can be removed when updating the remix, which will replace the node and delete the decoration
                        if (!isViewMode && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                            const thinkingWidgetDecoration = mappedDecorationSet.find(undefined, undefined, (spec)=>{
                                return spec?.key === (0, $29d6db7c0a9c3ffe$export$4ea4004ba136efe5);
                            });
                            if (!thinkingWidgetDecoration.length && pluginState.savedSelection?.to) mappedDecorationSet = mappedDecorationSet.add(newState.doc, [
                                (0, $29d6db7c0a9c3ffe$export$cce5a0bc4f5e594d)({
                                    api: api,
                                    contentType: pluginState.contentType,
                                    doc: newState.doc,
                                    getIntl: getIntl,
                                    isComplete: false,
                                    isWaitingForInput: pluginState.isWaitingForInput,
                                    isPlaceholder: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? pluginState.isUpdate ?? false : false,
                                    remixAttemptId: pluginState.remixAttemptId,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                                    to: tr.mapping.map(pluginState.savedSelection.to)
                                })
                            ]);
                        }
                    }
                    const mappedSavedSelection = tr.docChanged && pluginState.savedSelection ? {
                        ...pluginState.savedSelection,
                        from: tr.mapping.map(pluginState.savedSelection.from),
                        to: tr.mapping.map(pluginState.savedSelection.to),
                        anchorCellPos: pluginState.savedSelection.anchorCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.anchorCellPos) : undefined,
                        headCellPos: pluginState.savedSelection.headCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.headCellPos) : undefined
                    } : pluginState.savedSelection;
                    if (mappedDecorationSet !== pluginState.decorationSet || mappedSavedSelection !== pluginState.savedSelection) {
                        const result = {
                            ...pluginState,
                            decorationSet: mappedDecorationSet,
                            savedSelection: mappedSavedSelection
                        };
                        dispatch($5ea92dab24394af7$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                return pluginState;
            }
        },
        view () {
            return {
                update (view, previousState) {
                    const previousPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(previousState);
                    const currentPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(view.state);
                    const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                    // Scroll thinking bar into view when thinking starts (for large blocks like tables)
                    if (!isViewMode && currentPluginState?.isThinking && !previousPluginState?.isThinking && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) requestAnimationFrame(()=>{
                        const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(view);
                        container?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    });
                    const shouldRerenderThinkingPortal = !isViewMode && currentPluginState?.isThinking && (!previousPluginState?.isComplete && currentPluginState.isComplete || previousPluginState?.isWaitingForInput !== currentPluginState.isWaitingForInput) && ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? !currentPluginState.isUpdate : true) && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
                    if (shouldRerenderThinkingPortal) {
                        const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(view);
                        if (!container) return;
                        (0, $29d6db7c0a9c3ffe$export$ca6d884735f53b24)({
                            api: api,
                            container: container,
                            contentType: currentPluginState.contentType,
                            getIntl: getIntl,
                            isComplete: currentPluginState.isComplete ?? false,
                            isWaitingForInput: currentPluginState.isWaitingForInput,
                            remixAttemptId: currentPluginState.remixAttemptId,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                }
            };
        },
        appendTransaction (_transactions, oldState, newState) {
            const oldPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(oldState);
            const newPluginState = $5ea92dab24394af7$export$38c8fc373d691b1d.getState(newState);
            // only restore selection if the plugin state is not complete
            // which means the remix is cancelled
            // we don't want to restore selection if the remix is complete
            // which will trigger floating toolbar
            if (oldPluginState?.isThinking && !newPluginState?.isThinking && newPluginState?.savedSelection && !(newPluginState?.isComplete && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'))) {
                const { savedSelection: savedSelection } = newPluginState;
                const tr = newState.tr;
                if (savedSelection.anchorCellPos !== undefined && savedSelection.headCellPos !== undefined) tr.setSelection((0, $8HW7o.CellSelection).create(tr.doc, savedSelection.anchorCellPos, savedSelection.headCellPos));
                else if (savedSelection.isNodeSelection) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, savedSelection.from));
                else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, savedSelection.from, savedSelection.to));
                return tr;
            }
            return null;
        },
        props: {
            decorations (state) {
                return $5ea92dab24394af7$export$38c8fc373d691b1d.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}


const $592515a66bfc26f7$export$65f89d2d4741e4b7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            presentation: {
                kind: 'clear-decoration'
            },
            lifecycle: {
                kind: 'legacy-clear'
            }
        });
        return tr;
    };





const $d02a52a2c9adaa11$export$8818f9db6e7370f7 = (api)=>()=>({ tr: tr })=>{
            // Clear the block selection so stale ak-editor-selected-node decorations
            // are removed when the modal is dismissed.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: undefined,
                remixSource: undefined
            });
            return tr;
        };



var $j8XGH = parcelRequire("j8XGH");


















var $2ROjz = parcelRequire("2ROjz");

var $3rWk6 = parcelRequire("3rWk6");







const $fd2d11a909978b4f$export$c6b79f111952071b = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    if (!(selection instanceof (0, $kCECX.TextSelection)) || selection.empty || $from.sameParent($to) || !$from.parent.isTextblock || !$to.parent.isTextblock) return selection;
    let from = selection.from;
    let to = selection.to;
    if ($from.parent.content.size > 0 && $from.parentOffset === $from.parent.content.size) {
        let depth = $from.depth;
        while(depth > 1 && $from.indexAfter(depth - 1) === $from.node(depth - 1).childCount)depth--;
        const next = (0, $kCECX.Selection).findFrom($from.doc.resolve($from.after(depth)), 1);
        if (next instanceof (0, $kCECX.TextSelection)) from = next.from;
    }
    if ($to.parent.content.size > 0 && $to.parentOffset === 0) {
        let depth = $to.depth;
        while(depth > 1 && $to.index(depth - 1) === 0)depth--;
        const previous = (0, $kCECX.Selection).findFrom($to.doc.resolve($to.before(depth)), -1);
        if (previous instanceof (0, $kCECX.TextSelection)) to = previous.to;
    }
    if (from >= to || from < selection.from || to > selection.to || from === selection.from && to === selection.to) return selection;
    return (0, $kCECX.TextSelection).create($from.doc, selection.anchor <= selection.head ? from : to, selection.anchor <= selection.head ? to : from);
};


const $b6b9bfab07ae0f32$export$efc081ba493dec77 = (tr, api)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('cc-ce-mau-remix-editor-selection-boundaries') || api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return undefined;
    const selection = (0, $fd2d11a909978b4f$export$c6b79f111952071b)(tr.selection);
    if (selection === tr.selection) return undefined;
    tr.setSelection(selection);
    const context = api?.aiExperience?.actions.getAISelectionContext();
    return {
        ...context,
        selectionFragment: (0, $2ROjz.getFragmentsFromSelection)(selection),
        localIds: (0, $3rWk6.getLocalIdsFromSelection)(selection),
        selectionMarkdown: null,
        startIndex: selection.$from.parentOffset,
        endIndex: selection.$to.parentOffset
    };
};











const $6687d9fc6cf5746d$var$HEADING_NODE_TYPE = 'heading';
const $6687d9fc6cf5746d$export$e8f38c0ba1044114 = (doc, headingPos)=>{
    let currentPos = 0;
    for(let index = 0; index < doc.childCount; index++){
        const child = doc.child(index);
        if (currentPos !== headingPos) {
            currentPos += child.nodeSize;
            continue;
        }
        if (child.type.name !== $6687d9fc6cf5746d$var$HEADING_NODE_TYPE) return null;
        let endPos = headingPos + child.nodeSize;
        let endIndex = index + 1;
        for(let sectionIndex = index + 1; sectionIndex < doc.childCount; sectionIndex++){
            const sectionNode = doc.child(sectionIndex);
            if (sectionNode.type.name === $6687d9fc6cf5746d$var$HEADING_NODE_TYPE) break;
            endPos += sectionNode.nodeSize;
            endIndex = sectionIndex + 1;
        }
        return {
            startPos: headingPos,
            endPos: endPos,
            startIndex: index,
            endIndex: endIndex
        };
    }
    return null;
};


const $1cd013bee2f15b85$export$f7560b42cf0c7e6b = 'blockNudge';
const $1cd013bee2f15b85$export$601d1e5a3bab7ca2 = ({ nodePos: nodePos, source: source, tr: tr })=>{
    if (source !== $1cd013bee2f15b85$export$f7560b42cf0c7e6b) return false;
    const headingSection = (0, $6687d9fc6cf5746d$export$e8f38c0ba1044114)(tr.doc, nodePos);
    if (!headingSection) return false;
    const headingSectionSelection = (0, $kCECX.TextSelection).create(tr.doc, headingSection.startPos, headingSection.endPos);
    tr.setSelection(headingSectionSelection);
    return true;
};
const $1cd013bee2f15b85$export$5dcb9dab860f04dd = (api)=>({ nodePos: nodePos, nodeType: nodeType, source: source, from: from, to: to } = {})=>({ tr: tr })=>{
            if (from !== undefined && to !== undefined) {
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from, to));
                api?.selection?.commands?.setBlockSelection(tr.selection)({
                    tr: tr
                });
                return tr;
            }
            if (nodePos === undefined || !nodeType) return tr;
            if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
                const didApplyHeadingSelection = $1cd013bee2f15b85$export$601d1e5a3bab7ca2({
                    nodePos: nodePos,
                    source: source,
                    tr: tr
                });
                if (!didApplyHeadingSelection) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
            } else if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
            else api?.blockControls?.commands.expandAndUpdateSelection({
                startPos: nodePos,
                nodeType: nodeType,
                selection: tr.selection,
                isShiftPressed: false
            })({
                tr: tr
            });
            // If a multi-block TextSelection was set, signal to the selection plugin
            // so that ak-editor-selected-node decorations are applied to all selected nodes.
            if (tr.selection instanceof (0, $kCECX.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                tr: tr
            });
            return tr;
        };


const $a41417a475703a7a$export$f437f2a5f6852f29 = 'pasteMenu';
const $a41417a475703a7a$export$e01f52b7ef73f07b = (api)=>({ nodePos: nodePos, nodeType: nodeType, metadata: metadata, source: source } = {})=>({ tr: tr })=>{
            // If the remix modal is being opened from the paste menu, set the selection to the pasted content range
            if (source === $a41417a475703a7a$export$f437f2a5f6852f29 && api && 'pasteOptionsToolbarPlugin' in api && api.pasteOptionsToolbarPlugin && [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) {
                const pasteState = api.pasteOptionsToolbarPlugin.sharedState.currentState();
                if (!pasteState) // Exit early if we can't get the paste state, which means we won't be able to set the selection to the pasted content.
                return null;
                const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteState;
                if (pasteStartPos === undefined || pasteEndPos === undefined) // Exit early if the paste state doesn't have valid start or end positions.
                return null;
                const pasteSelection = (0, $kCECX.TextSelection).create(tr.doc, pasteStartPos, pasteEndPos);
                tr.setSelection(pasteSelection);
                api?.selection?.commands?.setBlockSelection(pasteSelection)({
                    tr: tr
                });
            } else if (nodePos !== undefined && nodeType) {
                if ((0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false) || (0, $iDrrr.fg)('platform_editor_ai_suggested_edits')) // Node-selection logic extracted into `makeSelectRemixAnchor` so it can be reused to
                // anchor a remix without opening the modal (e.g. Suggested Remix).
                (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                    nodePos: nodePos,
                    nodeType: nodeType,
                    source: source
                })({
                    tr: tr
                });
                else {
                    // TODO(platform_editor_ai_content_suggested_edits cleanup): delete this legacy inline
                    // branch — the `makeSelectRemixAnchor` call above is the replacement.
                    if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
                        const didApplyHeadingSelection = (0, $1cd013bee2f15b85$export$601d1e5a3bab7ca2)({
                            nodePos: nodePos,
                            source: source,
                            tr: tr
                        });
                        if (!didApplyHeadingSelection) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
                    } else if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) (0, $j8XGH.selectNodeAtPos)(tr, nodePos, nodeType);
                    else api?.blockControls?.commands.expandAndUpdateSelection({
                        startPos: nodePos,
                        nodeType: nodeType,
                        selection: tr.selection,
                        isShiftPressed: false
                    })({
                        tr: tr
                    });
                    // If a multi-block TextSelection was set, signal to the selection plugin
                    // so that ak-editor-selected-node decorations are applied to all selected nodes.
                    if (tr.selection instanceof (0, $kCECX.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                        tr: tr
                    });
                }
            }
            const capturedSelectionContext = (0, $b6b9bfab07ae0f32$export$efc081ba493dec77)(tr, api);
            const remixModalMetadata = capturedSelectionContext ? {
                ...metadata,
                capturedSelectionContext: capturedSelectionContext,
                hasNormalizedSelection: true
            } : metadata;
            tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: true,
                remixModalMetadata: remixModalMetadata,
                remixSource: source
            });
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
                presentation: {
                    kind: 'reset'
                },
                lifecycle: {
                    kind: 'legacy-reset'
                }
            });
            return tr;
        };












// The native-embeds auto-converter wraps a MAUI whiteboard URL
// (`...?isRemixDiagram=true`) into an extension node keyed by the
// `maui-whiteboard` experience id, not the generic `whiteboard` experience.
// See native-embeds-editor-extension `createManifest` autoConvert.
const $51bd462f1be2ad42$var$NATIVE_WHITEBOARD_EXTENSION_KEY = 'native-embed:maui-whiteboard';
const $51bd462f1be2ad42$var$getString = (value)=>typeof value === 'string' ? value : undefined;
// The native-embeds plugin can persist a whiteboard extension in one of two
// shapes depending on how it was created/transformed:
// - Nested macro shape: `attrs.parameters.macroParams.url.value`
// - Flat shape:         `attrs.parameters.url`
const $51bd462f1be2ad42$var$getNativeWhiteboardUrl = (attrs)=>$51bd462f1be2ad42$var$getString(attrs.parameters?.macroParams?.url?.value) ?? $51bd462f1be2ad42$var$getString(attrs.parameters?.url);
const $51bd462f1be2ad42$var$getWhiteboardContentId = (url)=>{
    if (!url) return undefined;
    const match = /\/whiteboard\/([^/?#]+)/.exec(url);
    const encodedContentId = match?.[1];
    if (!encodedContentId) return undefined;
    try {
        return decodeURIComponent(encodedContentId);
    } catch  {
        return encodedContentId;
    }
};
const $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo = (node)=>{
    if (node.type.name === 'embedCard') return {
        kind: 'embedCard',
        localId: $51bd462f1be2ad42$var$getString(node.attrs.localId),
        url: $51bd462f1be2ad42$var$getString(node.attrs.url)
    };
    if (node.type.name === 'extension' && node.attrs.extensionKey === $51bd462f1be2ad42$var$NATIVE_WHITEBOARD_EXTENSION_KEY) return {
        kind: 'nativeWhiteboard',
        localId: $51bd462f1be2ad42$var$getString(node.attrs.localId),
        url: $51bd462f1be2ad42$var$getNativeWhiteboardUrl(node.attrs)
    };
    return undefined;
};
const $51bd462f1be2ad42$var$isMatchingWhiteboardContent = (url, contentId)=>$51bd462f1be2ad42$var$getWhiteboardContentId(url) === contentId;
const $51bd462f1be2ad42$var$isMatchingLocalId = (actualLocalId, expectedLocalId)=>expectedLocalId ? actualLocalId === expectedLocalId : true;
const $51bd462f1be2ad42$export$fc1c1f126d7fc18e = (node, contentId, localId)=>{
    const info = $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo(node);
    if (!info || !$51bd462f1be2ad42$var$isMatchingWhiteboardContent(info.url, contentId)) return false;
    // Finalize can run during the timing window before or after native-embeds
    // converts Rovo's early embedCard into a maui-whiteboard extension. The
    // embedCard has localId; the converted extension does not, so match it by
    // exact contentId.
    if (info.kind === 'nativeWhiteboard') return true;
    return $51bd462f1be2ad42$var$isMatchingLocalId(info.localId, localId);
};
const $51bd462f1be2ad42$export$c3cec2ff440d20b7 = (doc, contentId)=>{
    let found;
    doc.descendants((node, pos)=>{
        if (found !== undefined) return false;
        if ($51bd462f1be2ad42$export$fc1c1f126d7fc18e(node, contentId)) {
            found = pos;
            return false;
        }
        return true;
    });
    return found;
};
// Only updates the shapes that actually exist on the node, to avoid inventing
// missing nested objects on a flat node (mirrors `getNativeWhiteboardUrl`).
const $51bd462f1be2ad42$var$updateNativeWhiteboardUrlAttrs = (attrs, finalizedUrl)=>({
        ...attrs,
        parameters: {
            ...attrs.parameters,
            ...typeof attrs.parameters?.url === 'string' ? {
                url: finalizedUrl
            } : {},
            ...attrs.parameters?.macroParams ? {
                macroParams: {
                    ...attrs.parameters.macroParams,
                    url: {
                        ...attrs.parameters.macroParams.url,
                        value: finalizedUrl
                    }
                }
            } : {},
            ...attrs.parameters?.macroMetadata ? {
                macroMetadata: {
                    ...attrs.parameters.macroMetadata,
                    url: finalizedUrl
                }
            } : {}
        }
    });
const $51bd462f1be2ad42$export$f23238abf7f83f7e = (node, finalizedUrl)=>{
    const info = $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo(node);
    if (info?.kind === 'nativeWhiteboard') return $51bd462f1be2ad42$var$updateNativeWhiteboardUrlAttrs(node.attrs, finalizedUrl);
    return {
        ...node.attrs,
        url: finalizedUrl
    };
};
const $51bd462f1be2ad42$var$updateWhiteboardNodeUrl = (tr, node, pos, contentId, finalizedUrl)=>{
    tr.setNodeMarkup(pos, undefined, $51bd462f1be2ad42$export$f23238abf7f83f7e(node, finalizedUrl));
    // Tell the maui-diagram paste plugin that this content has been finalized so
    // the `MauiNativeEmbedBanner` stops surfacing the "needs finalize" warning
    // even if the BE move hasn't propagated by the time the probe fires.
    tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
        type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
        contentId: contentId,
        status: (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZED
    });
    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
    // Finalize's setNodeMarkup would otherwise trigger the editor's scroll-into-view plugin. Suppress
    // it so the ready-signal owns the scroll-vs-"View"-bar decision instead of a forced page scroll.
    tr.setMeta('scrollIntoView', false);
    return tr;
};
const $51bd462f1be2ad42$var$findWhiteboardNode = (doc, contentId, localId)=>{
    let nodeResult;
    let hasMatchingContentId = false;
    let hasMatchingLocalId = false;
    doc.descendants((node, pos)=>{
        if (nodeResult) return false;
        if ($51bd462f1be2ad42$export$fc1c1f126d7fc18e(node, contentId, localId)) {
            nodeResult = {
                node: node,
                pos: pos
            };
            return false;
        }
        const info = $51bd462f1be2ad42$var$getWhiteboardEmbedNodeInfo(node);
        if (!info) return true;
        hasMatchingContentId || (hasMatchingContentId = $51bd462f1be2ad42$var$isMatchingWhiteboardContent(info.url, contentId));
        hasMatchingLocalId || (hasMatchingLocalId = Boolean(localId && info.localId === localId));
        return !(hasMatchingContentId && hasMatchingLocalId);
    });
    if (nodeResult) return nodeResult;
    if (hasMatchingContentId) return {
        outcome: 'local-id-mismatch'
    };
    if (hasMatchingLocalId) return {
        outcome: 'content-id-mismatch'
    };
    return {
        outcome: 'node-not-found'
    };
};
const $51bd462f1be2ad42$export$1aa62896db449f52 = ({ contentId: contentId, finalizedUrl: finalizedUrl, localId: localId, onOutcome: onOutcome })=>({ tr: tr })=>{
        // Fast path: if the target is already selected, avoid walking the whole document.
        if ((0, $bjg0G.isNodeSelection)(tr.selection) && $51bd462f1be2ad42$export$fc1c1f126d7fc18e(tr.selection.node, contentId, localId)) {
            onOutcome?.('replaced');
            return $51bd462f1be2ad42$var$updateWhiteboardNodeUrl(tr, tr.selection.node, tr.selection.$anchor.pos, contentId, finalizedUrl);
        }
        const nodeResult = $51bd462f1be2ad42$var$findWhiteboardNode(tr.doc, contentId, localId);
        if ('node' in nodeResult) {
            onOutcome?.('replaced');
            return $51bd462f1be2ad42$var$updateWhiteboardNodeUrl(tr, nodeResult.node, nodeResult.pos, contentId, finalizedUrl);
        }
        onOutcome?.(nodeResult.outcome);
        return null;
    };





const $39483ef3a0dde328$export$d2cccfcd66c92b90 = ({ contentId: contentId, status: status })=>({ tr: tr })=>{
        if (!contentId) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
            contentId: contentId,
            status: status
        });
        return tr;
    };





const $8ef7f637f4ca3dda$export$f36198854f9520d1 = ({ mediaId: mediaId })=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixImageMediaId: mediaId
        });
        return tr;
    };









// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable




var $eaLat = parcelRequire("eaLat");


var $4EksL = parcelRequire("4EksL");




















const $3ed7f22374c9e3fb$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $3ed7f22374c9e3fb$export$b0011c604093029 = (api)=>({ contentType: contentType, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, remixAttemptId: remixAttemptId, remixModalMetadata: remixModalMetadata, suppressThinkingHighlight: suppressThinkingHighlight } = {})=>({ tr: tr })=>{
            const selection = tr.selection;
            const isNodeSelection = selection instanceof (0, $kCECX.NodeSelection);
            const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
            const presentation = {
                kind: 'start',
                contentType: contentType,
                remixAttemptId: remixAttemptId ?? $3ed7f22374c9e3fb$var$randomId(),
                isUpdate: isUpdate,
                historyEntryForUpdate: historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate,
                thinkingSelectionFrom: selection.from,
                thinkingSelectionTo: isNodeSelection ? selection.from + selection.node.nodeSize : selection.to,
                isNodeSelection: isNodeSelection,
                suppressThinkingHighlight: suppressThinkingHighlight
            };
            if (isCellSelection) {
                presentation.cellSelectionRanges = selection.ranges.map((range)=>({
                        from: range.$from.pos,
                        to: range.$to.pos
                    }));
                presentation.anchorCellPos = selection.$anchorCell.pos;
                presentation.headCellPos = selection.$headCell.pos;
            }
            const thinkingMeta = {
                presentation: presentation,
                lifecycle: {
                    kind: 'legacy-start'
                }
            };
            // Clear block selection decorations before applying the thinking state.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), thinkingMeta);
            /**
   * Added this check so that when a userPrompt is pre-supplied in metadata (e.g. from the AI Image Generation flow),
   * we can pass in necessary metadata to the malleable-ui plugin.
   * like the userPrompt
   */ if (remixModalMetadata && remixModalMetadata.userPrompt && (remixModalMetadata.remixSource === 'suggestedRemix' && ((0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false) || (0, $iDrrr.fg)('platform_editor_ai_suggested_edits')) || (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true))) tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: remixModalMetadata,
                remixSource: remixModalMetadata.remixSource,
                remixUpdateScrollTargetUrl: undefined
            });
            else tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixUpdateScrollTargetUrl: undefined
            });
            // Move the active selection away from the selected node so the user can
            // continue editing while the remix is processing.
            const endPos = isNodeSelection ? selection.from + selection.node.nodeSize : selection.to;
            if (isNodeSelection && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                const $endPos = tr.doc.resolve(endPos);
                tr.setSelection((0, $4EksL.GapCursorSelection).valid($endPos) ? new (0, $4EksL.GapCursorSelection)($endPos, (0, $eaLat.Side).RIGHT) : (0, $kCECX.TextSelection).create(tr.doc, endPos));
            } else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, endPos));
            return tr;
        };
function $3ed7f22374c9e3fb$export$fdf82e9851b59bf0({ api: api, options: options }) {
    api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
    api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
}


/** Finds nodes matching `localIds` in doc order; `from`/`to` are each block's content span. */ const $5708e7965bf3427a$var$findMatchedAnchors = (doc, localIds)=>{
    const wanted = new Set(localIds);
    const matches = [];
    if (wanted.size === 0) return matches;
    doc.descendants((node, pos)=>{
        const id = node.attrs?.localId;
        if (typeof id === 'string' && wanted.has(id)) {
            matches.push({
                nodePos: pos,
                nodeType: node.type.name,
                from: pos + 1,
                to: pos + node.nodeSize - 1
            });
            return false;
        }
        return true;
    });
    return matches;
};
const $5708e7965bf3427a$export$e34b9fef80996931 = (api)=>({ localIds: localIds, remixModalMetadata: remixModalMetadata })=>({ tr: tr })=>{
            const matches = $5708e7965bf3427a$var$findMatchedAnchors(tr.doc, localIds ?? []);
            if (matches.length === 1) (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                nodePos: matches[0].nodePos,
                nodeType: matches[0].nodeType,
                source: remixModalMetadata.remixSource
            })({
                tr: tr
            });
            else if (matches.length > 1) (0, $1cd013bee2f15b85$export$5dcb9dab860f04dd)(api)({
                from: Math.min(...matches.map((m)=>m.from)),
                to: Math.max(...matches.map((m)=>m.to)),
                source: remixModalMetadata.remixSource
            })({
                tr: tr
            });
            const normalizedContext = (0, $b6b9bfab07ae0f32$export$efc081ba493dec77)(tr, api);
            const selection = tr.selection;
            const capturedSelectionContext = normalizedContext ?? {
                selectionFragment: (0, $2ROjz.getFragmentsFromSelection)(selection),
                localIds: (0, $3rWk6.getLocalIdsFromSelection)(selection),
                selectionMarkdown: null,
                startIndex: selection.$from.parentOffset,
                endIndex: selection.$to.parentOffset
            };
            (0, $3ed7f22374c9e3fb$export$b0011c604093029)(api)({
                remixModalMetadata: {
                    ...remixModalMetadata,
                    capturedSelectionContext: capturedSelectionContext,
                    ...normalizedContext ? {
                        hasNormalizedSelection: true
                    } : {}
                }
            })({
                tr: tr
            });
            return tr;
        };







const $756f290e221243c1$export$a5258d8cd6540560 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showSubtypeAdjustedFlag: true
        });
        return tr;
    };
const $756f290e221243c1$export$cc7138497964f45a = ()=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showSubtypeAdjustedFlag: false
        });
        return tr;
    };





function $7725f70f68e88b96$export$b3219bd5df32333({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            addInFlightVariantUpdateId: id
        });
        return tr;
    };
}
function $7725f70f68e88b96$export$242a1c29a4a1fdc3({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            removeInFlightVariantUpdateId: id
        });
        return tr;
    };
}



function $51d6f7d12f1d2e45$export$de0bdc3bedba2bdf(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'updateRemixImageHistoryFieldId',
            payload: {
                conversationId: options.conversationId,
                fieldId: options.fieldId
            }
        });
        return tr;
    };
}








const $02be7c97acfb0d3f$var$cwrReplacementKey = (replacement)=>`${replacement.previousLocalId}:${replacement.previousResultId}`;
const $02be7c97acfb0d3f$var$getResultId = (node)=>{
    if (node.type.name === 'media') return typeof node.attrs.id === 'string' ? node.attrs.id : undefined;
    if (node.type.name === 'mediaSingle') return node.firstChild ? $02be7c97acfb0d3f$var$getResultId(node.firstChild) : undefined;
    if (node.type.name === 'embedCard') return (0, $dOW9b.getMauiIdFromUrl)(node.attrs.url);
    return (0, $dOW9b.getMauiIdFromAdfNode)(node);
};
const $02be7c97acfb0d3f$var$findResultId = (doc, localId)=>{
    let resultId;
    doc.descendants((node)=>{
        if (node.attrs.localId === localId) resultId = $02be7c97acfb0d3f$var$getResultId(node) ?? resultId;
    });
    return resultId;
};
const $02be7c97acfb0d3f$export$1e8b49a21b604124 = (doc, mediaId)=>{
    let found = false;
    let mediaLocalId;
    let wrapperLocalId;
    const localIdCounts = new Map();
    doc.descendants((node, _pos, parent)=>{
        if (node.type.name !== 'media') return;
        const nodeLocalId = node.attrs.localId;
        const parentLocalId = parent?.type.name === 'mediaSingle' ? parent.attrs.localId : undefined;
        if (typeof nodeLocalId === 'string') {
            const key = `media:${nodeLocalId}`;
            localIdCounts.set(key, (localIdCounts.get(key) ?? 0) + 1);
        }
        if (typeof parentLocalId === 'string') {
            const key = `mediaSingle:${parentLocalId}`;
            localIdCounts.set(key, (localIdCounts.get(key) ?? 0) + 1);
        }
        if (node.attrs.id === mediaId) {
            found = true;
            mediaLocalId = typeof nodeLocalId === 'string' ? nodeLocalId : undefined;
            wrapperLocalId = typeof parentLocalId === 'string' ? parentLocalId : undefined;
        }
    });
    if (wrapperLocalId && localIdCounts.get(`mediaSingle:${wrapperLocalId}`) === 1) return {
        found: found,
        localId: wrapperLocalId,
        localIdSource: 'mediaSingle'
    };
    if (mediaLocalId && localIdCounts.get(`media:${mediaLocalId}`) === 1) return {
        found: found,
        localId: mediaLocalId,
        localIdSource: 'media'
    };
    return {
        found: found
    };
};
// Compares matching media in the previous and current documents so a surviving copy
// is not mistaken for a replacement of the tracked result.
const $02be7c97acfb0d3f$var$findMediaIdByLocalId = (doc, oldDoc, localId, localIdSource, preferredMediaId)=>{
    const matchingIds = (docToSearch)=>{
        const ids = [];
        docToSearch.descendants((node, _pos, parent)=>{
            if (node.type.name === 'media' && (localIdSource === 'mediaSingle' ? parent?.type.name === 'mediaSingle' && parent.attrs.localId === localId : node.attrs.localId === localId) && typeof node.attrs.id === 'string') ids.push(node.attrs.id);
        });
        return ids;
    };
    const currentIds = matchingIds(doc);
    if (currentIds.includes(preferredMediaId)) return preferredMediaId;
    const previousIds = matchingIds(oldDoc);
    const newId = currentIds.filter((id)=>!previousIds.includes(id)).at(-1);
    if (newId) return newId;
    // A surviving copy is not a replacement for the tracked image.
    return previousIds.length > 1 ? undefined : currentIds.at(-1);
};
// Resolves the result currently represented by the tracked node.
// Media without a unique localId falls back to its original media ID.
const $02be7c97acfb0d3f$var$getCurrentResultId = (result, doc, oldDoc)=>{
    if (!result.mediaId) return result.localId ? $02be7c97acfb0d3f$var$findResultId(doc, result.localId) : undefined;
    if (result.localId && result.mediaLocalIdSource) return $02be7c97acfb0d3f$var$findMediaIdByLocalId(doc, oldDoc, result.localId, result.mediaLocalIdSource, result.resultId);
    return $02be7c97acfb0d3f$export$1e8b49a21b604124(doc, result.mediaId).found ? result.mediaId : undefined;
};
const $02be7c97acfb0d3f$var$containsResultId = (doc, resultId)=>{
    let found = false;
    doc.descendants((node)=>{
        if ($02be7c97acfb0d3f$var$getResultId(node) === resultId) {
            found = true;
            return false;
        }
        return !found;
    });
    return found;
};
const $02be7c97acfb0d3f$export$5f81010419ef00a3 = ()=>{
    const tracked = new Map();
    // CWR streams a replacement over several document updates before its final result is known.
    const pendingCwrReplacements = new Set();
    let previousDoc;
    const emit = (result, action)=>{
        result.onChange(action, {
            ...result.attributes,
            ...result.localId ? {
                localId: result.localId
            } : {},
            resultId: result.resultId,
            elapsedMs: Date.now() - result.appliedAt
        });
    };
    const isPendingCwrReplacement = (result)=>{
        if (!result.localId) return false;
        return pendingCwrReplacements.has($02be7c97acfb0d3f$var$cwrReplacementKey({
            previousLocalId: result.localId,
            previousResultId: result.resultId
        }));
    };
    const reconcilePendingCwrReplacement = (replacement, doc, resultId)=>{
        pendingCwrReplacements.delete($02be7c97acfb0d3f$var$cwrReplacementKey(replacement));
        for (const [key, result] of tracked){
            if (result.localId !== replacement.previousLocalId || result.resultId !== replacement.previousResultId) continue;
            const currentResultId = $02be7c97acfb0d3f$var$getCurrentResultId(result, doc, previousDoc ?? doc);
            if (currentResultId === result.resultId) continue;
            if (resultId && $02be7c97acfb0d3f$var$containsResultId(doc, resultId)) {
                emit(result, 'replaced');
                tracked.delete(key);
                continue;
            }
            result.currentResultId = currentResultId;
            if (!currentResultId) emit(result, 'deleted');
            else emit(result, 'replaced');
        }
    };
    const update = (doc)=>{
        const oldDoc = previousDoc;
        previousDoc = doc;
        if (tracked.size === 0 || !oldDoc || oldDoc === doc) return;
        const start = oldDoc.content.findDiffStart(doc.content);
        const end = oldDoc.content.findDiffEnd(doc.content);
        if (start === null || !end) return;
        const overlap = Math.max(0, start - Math.min(end.a, end.b));
        const changedLocalIds = new Set();
        const changedMediaIds = new Set();
        const collectChanged = (node)=>{
            if (typeof node.attrs.localId === 'string') changedLocalIds.add(node.attrs.localId);
            if (node.type.name === 'media' && typeof node.attrs.id === 'string') changedMediaIds.add(node.attrs.id);
        };
        oldDoc.nodesBetween(start, end.a + overlap, collectChanged);
        doc.nodesBetween(start, end.b + overlap, collectChanged);
        const results = new Map();
        tracked.forEach((result)=>{
            if (isPendingCwrReplacement(result)) return;
            if (!(result.localId && changedLocalIds.has(result.localId)) && !(result.previousLocalId && changedLocalIds.has(result.previousLocalId)) && !(result.mediaId && changedMediaIds.has(result.mediaId))) return;
            // Media lookups depend on the tracked result, so they are cached per result.
            const lookupKey = result.mediaId ? `media:${result.mediaLocalIdSource ?? 'id'}:${result.localId ?? result.mediaId}:${result.resultId}` : `maui:${result.localId}`;
            if (!results.has(lookupKey)) results.set(lookupKey, $02be7c97acfb0d3f$var$getCurrentResultId(result, doc, oldDoc));
            const currentResultId = results.get(lookupKey);
            if (currentResultId === result.currentResultId) return;
            const wasPresent = result.currentResultId === result.resultId;
            result.currentResultId = currentResultId;
            if (currentResultId === result.resultId) emit(result, 'restored');
            else if (wasPresent) {
                const previousResultId = result.previousResultId;
                const revertedToPreviousResult = previousResultId !== undefined && (currentResultId === previousResultId || currentResultId === undefined && typeof result.previousLocalId === 'string' && $02be7c97acfb0d3f$var$findResultId(doc, result.previousLocalId) === previousResultId);
                if (revertedToPreviousResult) emit(result, 'reverted');
                else if (!currentResultId) emit(result, 'deleted');
                else emit(result, 'replaced');
            }
        });
    };
    return {
        beginCwrReplacement (replacement) {
            pendingCwrReplacements.add($02be7c97acfb0d3f$var$cwrReplacementKey(replacement));
        },
        cancelCwrReplacement (replacement, doc) {
            reconcilePendingCwrReplacement(replacement, doc);
        },
        track (options, doc) {
            if (previousDoc !== doc) update(doc);
            const media = options.mediaId ? $02be7c97acfb0d3f$export$1e8b49a21b604124(doc, options.mediaId) : undefined;
            const localId = options.mediaId ? media?.localId : options.localId;
            const resultId = options.mediaId ? media?.found ? options.mediaId : undefined : localId ? $02be7c97acfb0d3f$var$findResultId(doc, localId) : undefined;
            if (!resultId || options.resultId && options.resultId !== resultId) return;
            const key = JSON.stringify([
                options.mediaId ? 'media' : 'maui',
                localId ?? options.mediaId,
                resultId,
                options.attributes.singleInstrumentationID
            ]);
            if (tracked.has(key)) return;
            const result = {
                ...options,
                localId: localId,
                mediaLocalIdSource: media?.localIdSource,
                resultId: resultId,
                currentResultId: resultId,
                appliedAt: Date.now()
            };
            tracked.set(key, result);
            emit(result, 'applied');
        },
        completeCwrReplacement (replacement, resultId, doc) {
            reconcilePendingCwrReplacement(replacement, doc, resultId);
        },
        update: update,
        clear () {
            tracked.clear();
            pendingCwrReplacements.clear();
            previousDoc = undefined;
        }
    };
};


const $f53c681beb60dc43$var$isMauiExtension = (node)=>node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui';
const $f53c681beb60dc43$var$getFileMediaId = (node)=>node?.type.name === 'media' && node.attrs.type === 'file' && typeof node.attrs.id === 'string' ? node.attrs.id : undefined;
const $f53c681beb60dc43$export$c2c0a8a24f6ef42 = (doc, localId)=>{
    let target;
    doc.descendants((node)=>{
        if (node.attrs.localId !== localId) return true;
        if ($f53c681beb60dc43$var$isMauiExtension(node)) {
            const mauiId = (0, $dOW9b.getMauiIdFromAdfNode)(node);
            if (mauiId) target = {
                identity: {
                    attribute: 'mauiVersion',
                    localId: localId,
                    value: mauiId
                },
                localId: localId
            };
            return false;
        }
        const mediaId = $f53c681beb60dc43$var$getFileMediaId(node.type.name === 'mediaSingle' ? node.firstChild : node);
        if (mediaId) target = {
            identity: {
                attribute: 'id',
                value: mediaId
            },
            localId: (0, $02be7c97acfb0d3f$export$1e8b49a21b604124)(doc, mediaId).localId ?? localId
        };
        return false;
    });
    return target;
};
const $f53c681beb60dc43$export$f983a316f6fb1b98 = (doc)=>{
    const keys = new Set();
    doc.descendants((node)=>{
        if ($f53c681beb60dc43$var$isMauiExtension(node)) {
            const mauiId = (0, $dOW9b.getMauiIdFromAdfNode)(node);
            if (mauiId) keys.add(`mauiVersion:${mauiId}`);
        }
        if (node.type.name === 'media' && typeof node.attrs.id === 'string') keys.add(`id:${node.attrs.id}`);
        return true;
    });
    return keys;
};














/**
 * Remix block control: positioned at the right edge of the block.
 * Uses anchor(anchorName end) or getRightPositionForRootElement (same coordinate system
 * as left controls). The widget span has no position:relative so position:absolute
 * uses the same containing block as the node.
 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");





var $1sCHt = parcelRequire("1sCHt");


var $k8PFz = parcelRequire("k8PFz");


var $3k5Tv = parcelRequire("3k5Tv");


var $bdkuW = parcelRequire("bdkuW");


var $hTjcC = parcelRequire("hTjcC");


var $fKt2m = parcelRequire("fKt2m");


var $jWiWP = parcelRequire("jWiWP");


var $lhJQI = parcelRequire("lhJQI");


var $69FTU = parcelRequire("69FTU");


var $1pCE4 = parcelRequire("1pCE4");


var $cha5E = parcelRequire("cha5E");








var $ieeJu = parcelRequire("ieeJu");





var $lpNn5 = parcelRequire("lpNn5");








var $iBsvI = parcelRequire("iBsvI");














const $3397a9320ab7f32b$export$95a12c22f1d400bc = new (0, $kCECX.PluginKey)('remixHoverHighlightPlugin');
const $3397a9320ab7f32b$export$cb3fa8e98acae648 = 'remix-hover-highlight';
const $3397a9320ab7f32b$var$getHeadingSectionDecorations = ({ doc: doc, headingPos: headingPos, className: className })=>{
    const headingSection = (0, $6687d9fc6cf5746d$export$e8f38c0ba1044114)(doc, headingPos);
    if (!headingSection) return [];
    const decorations = [];
    let currentPos = headingSection.startPos;
    for(let index = headingSection.startIndex; index < headingSection.endIndex; index++){
        const child = doc.child(index);
        decorations.push((0, $8nvEM.Decoration).node(currentPos, currentPos + child.nodeSize, {
            class: className
        }));
        currentPos += child.nodeSize;
    }
    return decorations;
};
function $3397a9320ab7f32b$export$1c5a63402318eb67() {
    return new (0, $kpCD8.SafePlugin)({
        key: $3397a9320ab7f32b$export$95a12c22f1d400bc,
        state: {
            init () {
                return {
                    highlightedPos: null,
                    decorationSet: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($3397a9320ab7f32b$export$95a12c22f1d400bc);
                if (meta !== undefined) {
                    if (meta.highlightPos === null) // Clear highlight
                    return {
                        highlightedPos: null,
                        decorationSet: (0, $8nvEM.DecorationSet).empty
                    };
                    const pos = meta.highlightPos;
                    const node = newState.doc.nodeAt(pos);
                    if (!node) return pluginState;
                    const decorationClassNames = meta.rootNodeType === 'table' ? [
                        'ak-editor-selected-node'
                    ] : [
                        $3397a9320ab7f32b$export$cb3fa8e98acae648
                    ];
                    const className = decorationClassNames.join(' ');
                    const headingSectionDecorations = $3397a9320ab7f32b$var$getHeadingSectionDecorations({
                        doc: newState.doc,
                        headingPos: pos,
                        className: className
                    });
                    const decorations = headingSectionDecorations.length > 0 ? headingSectionDecorations : [
                        (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                            class: className
                        })
                    ];
                    const decorationSet = (0, $8nvEM.DecorationSet).create(newState.doc, decorations);
                    return {
                        highlightedPos: pos,
                        decorationSet: decorationSet
                    };
                }
                // Map decorations on doc changes
                if (pluginState.highlightedPos !== null && pluginState.decorationSet !== (0, $8nvEM.DecorationSet).empty) {
                    const mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                    if (mappedDecorationSet !== pluginState.decorationSet) {
                        const mappedPos = tr.mapping.map(pluginState.highlightedPos);
                        return {
                            ...pluginState,
                            highlightedPos: mappedPos,
                            decorationSet: mappedDecorationSet
                        };
                    }
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return $3397a9320ab7f32b$export$95a12c22f1d400bc.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}



var $lhZdS = parcelRequire("lhZdS");

/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 * Use with block-controls activeNode (or a full PM node) and these filters in both edit and view.
 */ 






var $1qYXT = parcelRequire("1qYXT");

/**
 * Confluence-side read of `REMIX_EXPANDS_EXPERIMENT`, which unlocks Remix for expands.
 *
 * Exposure fires here because this is only reached for an expand node — i.e. at the point where
 * an expand Remix entry point is about to be shown or withheld.
 */ const $444f275c146ea05d$var$areRemixExpandsEnabled = ()=>(0, $4o0zT.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
const $444f275c146ea05d$export$d3f1ba79de0d4efe = [
    'mediaSingle',
    'media'
];
const $444f275c146ea05d$export$ebd59c3751cfcc95 = (node)=>{
    if (!node) return false;
    // Aya's principle:
    // Empty anything should not have the Remix button shown
    // Once there is text or something in the element, we can show it
    // NOTE: Currently, we are ignoring "something" because Remix can't handle only emoji, status, etc.
    return node.textContent.trim().length === 0;
};
const $444f275c146ea05d$export$dad9e20bd9ca4fef = 'editor-floating-toolbar__remix-button';
const $444f275c146ea05d$export$287305cbde0809e = 'editor-floating-toolbar__remove-background-button';
const $444f275c146ea05d$export$2c2cd6cb969bd93a = ()=>false;
/**
 * MBE extension keys that are allowed to use Remix in Confluence.
 * The allow list is owned by the product layer so product-specific
 * decisions stay out of platform code.
 *
 * Already gated by the existing `cc-maui` experiment (controls Remix
 * visibility) and `confluence_native_tabs_experiment` (controls
 * whether native tabs nodes exist in the editor).
 */ const $444f275c146ea05d$var$REMIX_MBE_ALLOW_LIST = [
    'native-tabs'
];
/**
 * Extension keys that are allowed to use Remix in Confluence, no empty check.
 * The allow list is owned by the product layer so product-specific
 * decisions stay out of platform code.
 *
 * Emptiness checks don't make sense for extensions like native embeds because
 * they don't have text content.
 */ const $444f275c146ea05d$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST = new Set([
    'native-embed:page'
]);
/**
 * Check if the extension key is allowed to use Remix, gated by feature flags.
 */ const $444f275c146ea05d$var$isAllowedExtensionForRemixNoEmptyCheck = (extensionKey)=>$444f275c146ea05d$var$REMIX_NO_EMPTY_CHECK_EXTENSION_ALLOW_LIST.has(extensionKey) && (0, $iDrrr.fg)('maui_remixable_page_native_embeds');
const $444f275c146ea05d$export$ff7e5ebac3487125 = (context)=>{
    const nodeType = context.node?.type?.name ?? context.nodeType;
    if (nodeType === undefined) return false;
    // Allow specific MBE variants (e.g. native tabs) even though the generic
    // multiBodiedExtension type is in the deny list.
    if (nodeType === 'multiBodiedExtension' && context.node) {
        const extensionKey = context.node.attrs?.extensionKey;
        if ((0, $1qYXT.isAllowedMBEExtensionForRemix)(extensionKey, $444f275c146ea05d$var$REMIX_MBE_ALLOW_LIST)) return true;
        return false;
    }
    const extensionKey = context.node?.attrs?.extensionKey ?? context.extensionKey ?? '';
    if (nodeType === 'extension' && $444f275c146ea05d$var$isAllowedExtensionForRemixNoEmptyCheck(extensionKey)) return true;
    // Expands are deny-listed by default and only become remixable under
    // `REMIX_EXPANDS_EXPERIMENT`; every other deny-listed type is unaffected. The thunk is only
    // invoked for expand nodes, so selecting a paragraph or a table never fires an exposure.
    if ((0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(nodeType, $444f275c146ea05d$var$areRemixExpandsEnabled)) return false;
    return !$444f275c146ea05d$export$ebd59c3751cfcc95(context.node);
};








const $185ff2366808da00$export$5626baa73ed0afeb = (formatMessage, reason)=>{
    // Hosts always pass a reason with their own `isDisabled`, so no reason means the AI entry points
    // are disabled because an AI flow (e.g. a Rovo Remix stream) is running on the page.
    if (reason === undefined && (0, $iDrrr.fg)('remix_state_rearchitecture_enabled')) return formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
    switch(reason){
        case 'version-history':
            return formatMessage((0, $lhZdS.messages).remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage((0, $lhZdS.messages).remixDisabledTooltipArchived);
    }
};


const $d1c28dddb88abfdb$export$44c2dcb159008a4b = (state)=>Boolean(state?.aiDecorationExperiencePluginState?.isRunning || state?.isStreaming || state?.isShowingAcceptRejectScreen);


function $1147f98e36d88087$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1147f98e36d88087$var$REMIX_BUTTON_HEIGHT = 24;
const $1147f98e36d88087$var$REMIX_BUTTON_WIDTH = 24;
const $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS = {
    width: $1147f98e36d88087$var$REMIX_BUTTON_WIDTH,
    height: $1147f98e36d88087$var$REMIX_BUTTON_HEIGHT
};
const $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET = 55;
// Column layout (layoutSection) has breakout resize handles extending to the right; push Remix button further so it doesn't overlap
const $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION = 91;
const $1147f98e36d88087$var$INNER_CONTAINER_SELECTORS = {
    embedCard: '.rich-media-item',
    table: '.resizer-item',
    mediaSingle: '.resizer-item',
    extension: '.extension-container[data-layout]',
    bodiedExtension: '.extension-container[data-layout]',
    blockCard: '.datasourceView-content-inner-wrap'
};
const $1147f98e36d88087$var$getInnerContainerAndEdgeCase = (dom, rootNodeType)=>{
    const selector = $1147f98e36d88087$var$INNER_CONTAINER_SELECTORS[rootNodeType];
    const innerContainer = selector ? dom.querySelector(selector) : null;
    // Edge case: nodes with nested inner containers (resizer, extension, embedCard, blockCard)
    // require offset-based positioning including dom.offsetLeft because anchor-based positioning
    // doesn't correctly account for the nested layout. Occurs when the inner container exists and
    // the block is not aligned to the right edge of the editor content area.
    const isEdgeCase = selector !== undefined && innerContainer !== null;
    return {
        innerContainer: innerContainer,
        isEdgeCase: isEdgeCase
    };
};
const $1147f98e36d88087$var$containerBaseStyles = {
    name: "1sgo8pu",
    styles: "position:absolute;z-index:100;display:flex;align-items:flex-start;justify-content:center"
};
const $1147f98e36d88087$var$stickyButtonContainerStyles = {
    name: "cdscbk",
    styles: "top:8px;position:sticky;display:block;z-index:100;button{border-radius:var(--ds-radius-full, 9999px);}"
};
const $1147f98e36d88087$var$stickyButtonContainerStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $1147f98e36d88087$var$stickyButtonContainerStylesImprovedStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $1147f98e36d88087$export$e420cb1e340b26d1 = ({ view: view, api: api, getPos: getPos, anchorName: anchorName, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, rootPos: rootPos })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { macroInteractionUpdates: macroInteractionUpdates, editorViewMode: editorViewMode, activeNode: activeNode, rightSideControlsEnabled: rightSideControlsEnabled, hoverSide: hoverSide, contentId: contentId, isOwnRemixing: isOwnRemixing, isAnyRemixing: isAnyRemixing, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'editorViewMode',
        'blockControls',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            editorViewMode: states.editorViewModeState?.mode,
            activeNode: states.blockControlsState?.activeNode,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false,
            hoverSide: states.blockControlsState?.hoverSide,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isOwnRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking || false,
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
        }));
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    const isViewMode = editorViewMode === 'view';
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    const isRemixAvailable = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    // Use block-controls shared state (activeNode) + reusable filter instead of DOM checks for restricted nodes.
    // When activeNode is null (e.g. on initial render), default to showing the button — the anchor/position
    // logic handles visibility. Only block when we have an explicit restricted node type.
    const activeNodeType = activeNode?.rootNodeType ?? activeNode?.nodeType;
    const activeNodeExtensionKey = activeNode && activeNodeType === 'extension' ? view.state.doc.nodeAt(activeNode?.rootPos ?? activeNode.pos)?.attrs?.extensionKey : undefined;
    const showRemixButton = activeNodeType === undefined || (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
        nodeType: activeNodeType,
        extensionKey: activeNodeExtensionKey
    });
    const hasRemixOrEditInProgress = (isRemixing || aiEditInProgress) && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    // Fire the experiments associated with this Remix control when it becomes visible.
    const hasFiredExposureRef = (0, $cozmU.useRef)(false);
    const isActiveBlock = activeNode?.rootPos === rootPos && activeNode?.rootAnchorName === (rootAnchorName ?? anchorName);
    const isRightSideVisible = rightSideControlsEnabled && (hoverSide === 'right' || isViewMode);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredExposureRef.current || !isActiveBlock || !isRightSideVisible || !isRemixAvailable || !showRemixButton || hasRemixOrEditInProgress || areAiEntryPointsDisabled) return;
        (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg');
        (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
        (0, $ieeJu.expValEquals)('cc_maui_remix_button_hover_corridor', 'isEnabled', true);
        hasFiredExposureRef.current = true;
    }, [
        areAiEntryPointsDisabled,
        hasRemixOrEditInProgress,
        isActiveBlock,
        isRemixAvailable,
        isRightSideVisible,
        showRemixButton
    ]);
    const [positionStyles, setPositionStyles] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Shared offset-based positioning for view mode and edit-mode fallback.
    // Horizontal (left) uses getRightPositionForRootElement; vertical uses getTopPosition.
    const rightOffset = rootNodeType === 'layoutSection' ? $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION : $1147f98e36d88087$var$REMIX_BUTTON_RIGHT_OFFSET;
    const getOffsetBasedPosition = (0, $cozmU.useCallback)((dom, safeAnchorName)=>{
        const { innerContainer: innerContainer, isEdgeCase: isEdgeCase } = $1147f98e36d88087$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        const rightEdgeLeft = (0, $69FTU.getRightPositionForRootElement)(dom, rootNodeType, $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS, innerContainer ?? undefined, isMacroInteractionUpdates);
        const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
        return {
            left: isEdgeCase ? `calc(${dom.offsetLeft}px + (${rightEdgeLeft}) + ${rightOffset}px)` : `calc(${rightEdgeLeft} + ${rightOffset}px)`,
            top: (0, $jWiWP.getTopPosition)(dom, rootNodeType),
            ...height,
            bottom: 'unset'
        };
    }, [
        rootNodeType,
        macroInteractionUpdates,
        rightOffset
    ]);
    // Edit mode: anchor-based when supported, otherwise offset-based (same as view mode).
    const calculatePosition = (0, $cozmU.useCallback)(()=>{
        const safeAnchorName = (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName ?? anchorName
        });
        let dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Fallback: table nodes use data-node-anchor (set by table-anchor-names plugin) rather than
        // data-drag-handler-anchor-name. When getAnchorAttrName() returns the drag-handler attribute
        // (experiment disabled), the primary query above finds nothing. Try data-node-anchor as a
        // fallback so tables work regardless of the platform_editor_native_anchor_with_dnd experiment.
        if (!dom) dom = view.dom.querySelector(`[data-node-anchor="${safeAnchorName}"]`);
        if (!dom) return {
            display: 'none'
        };
        // For layoutSection, the anchor attribute is on the outer ReactNodeView wrapper div which
        // may have a larger offsetWidth than the actual layout section content area.
        // Use the inner [data-layout-section] element for accurate width-based positioning.
        // Keep a reference to the outer wrapper: getTopPosition needs it because the inner
        // [data-layout-section] element's offsetTop is ~0 relative to the wrapper.
        const outerDom = dom;
        if (rootNodeType === 'layoutSection') dom = dom.querySelector('[data-layout-section]') ?? dom;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        // View mode always uses offset-based (anchor positioning can differ in view mode).
        if (isViewMode) {
            // layoutSection: the inner element's right edge gives the correct width, but its
            // offsetTop is ~0 (relative to the wrapper). Mirror the table branch — use a single
            // getBoundingClientRect() diff for the right edge and getTopPosition(outerDom) for top.
            if (rootNodeType === 'layoutSection') {
                const gap = (0, $hTjcC.rootElementGap)(rootNodeType);
                const layoutRight = outerDom.offsetLeft + (dom.getBoundingClientRect().right - outerDom.getBoundingClientRect().left) - gap - $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width;
                const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(outerDom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${layoutRight}px + ${rightOffset}px)`,
                    top: (0, $jWiWP.getTopPosition)(outerDom, rootNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            // In view mode, tables have no .resizer-item so isEdgeCase=false and getOffsetBasedPosition
            // uses dom.offsetWidth (editor width) instead of the actual table width. For wide/max tables
            // this places the button at the editor margin, not the table's right edge.
            // Use the first <tr> as the inner reference (same role as .resizer-item in edit mode):
            // tr.offsetLeft + tr.offsetWidth gives the actual table right edge relative to dom.
            const tableRow = rootNodeType === 'table' || rootNodeType === '' ? dom.querySelector('thead tr, tr') : null;
            if (tableRow) {
                const effectiveNodeType = rootNodeType || 'table';
                const gap = (0, $hTjcC.rootElementGap)(effectiveNodeType);
                // Get the tr's right edge relative to dom's left edge using BoundingClientRect
                // (avoids offset-parent chain issues between tr and the nodeview wrapper).
                const trRight = tableRow.getBoundingClientRect().right - dom.getBoundingClientRect().left;
                const rightEdgeLeft = dom.offsetLeft + trRight - gap - $1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width;
                const isSticky = (0, $jWiWP.shouldBeSticky)(effectiveNodeType);
                const height = (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${rightEdgeLeft}px + ${rightOffset}px)`,
                    top: (0, $jWiWP.getTopPosition)(dom, effectiveNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            return getOffsetBasedPosition(dom, safeAnchorName);
        }
        const { isEdgeCase: isEdgeCase } = $1147f98e36d88087$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        // Check anchor first (no reflow). Only use offset-based when fallback needed.
        const supportsAnchorRight = CSS.supports('left', `anchor(${safeAnchorName} end)`) && CSS.supports('top', `anchor(${safeAnchorName} start)`);
        if (supportsAnchorRight && !isEdgeCase) return {
            left: `calc(anchor(${safeAnchorName} end) - ${$1147f98e36d88087$var$REMIX_BUTTON_DIMENSIONS.width}px - ${(0, $hTjcC.rootElementGap)(rootNodeType)}px + ${rightOffset}px)`,
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $hTjcC.topPositionAdjustment)(rootNodeType)}px)`,
            ...(0, $jWiWP.getControlBottomCSSValue)(safeAnchorName, isSticky, true)
        };
        return getOffsetBasedPosition(dom, safeAnchorName);
    }, [
        view,
        getPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        isViewMode,
        getOffsetBasedPosition,
        rightOffset
    ]);
    // Recompute button position on mount and when the block's right edge can shift after mount:
    // - extension/embedCard layout changes (expand/collapse) via transitionend
    // - the editor content area resizing, e.g. the Rovo chat panel opening/closing (MAUI-923).
    //   Tables (and other pixel-positioned edge-case nodes) derive an absolute `left` from the
    //   block's right edge, and never use the self-reflowing CSS anchor() path, so without a
    //   resize listener the button keeps a stale position and can end up inside a wide table.
    //   Observe the same scroll-parent editor-plugin-block-controls observes for its own controls.
    (0, $cozmU.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const anchorDom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${rootAnchorName ?? anchorName}"]`);
            if (anchorDom) cleanUpTransitionListener = (0, $cbY7C.bind)(anchorDom, {
                type: 'transitionend',
                listener: ()=>setPositionStyles(calculatePosition())
            });
        }
        const id = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
        let resizeObserver;
        let resizeRafId;
        if (typeof ResizeObserver !== 'undefined' && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
            const scrollParent = view.dom.closest('.fabric-editor-popup-scroll-parent') ?? view.dom;
            resizeObserver = new ResizeObserver(()=>{
                if (resizeRafId !== undefined) cancelAnimationFrame(resizeRafId);
                resizeRafId = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
            });
            resizeObserver.observe(scrollParent);
        }
        return ()=>{
            cancelAnimationFrame(id);
            cleanUpTransitionListener?.();
            if (resizeRafId !== undefined) cancelAnimationFrame(resizeRafId);
            resizeObserver?.disconnect();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType,
        anchorName,
        isViewMode
    ]);
    const nodePosRef = (0, $cozmU.useRef)(undefined);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const clearHoverHighlight = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)(()=>{
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        // Clear the hover highlight decoration before opening the modal to prevent flashing
        clearHoverHighlight();
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: nodePosRef.current,
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge'
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        clearHoverHighlight,
        experienceTracker,
        rootNodeType
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        nodePosRef.current = getPos();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        openRemix();
    }, [
        getPos,
        isDisabled,
        openRemix
    ]);
    // Re-affirm activeNode when entering the remix button to prevent disappearing when moving
    // from block toward the button. Skip if already active to avoid flickering from re-dispatch.
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        const anchor = rootAnchorName ?? anchorName;
        if (activeNode?.rootAnchorName === anchor && activeNode?.rootPos === rootPos) return;
        api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(rootPos, anchor, rootNodeType, undefined, rootPos, anchor, rootNodeType));
    }, [
        api,
        rootPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        activeNode?.rootAnchorName,
        activeNode?.rootPos
    ]);
    // Show hover highlight decoration on the content block when hovering the Remix button
    const handleRemixButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
            highlightPos: rootPos,
            rootNodeType: rootNodeType
        });
        view.dispatch(tr);
    }, [
        view,
        rootPos,
        rootNodeType
    ]);
    const handleRemixButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
            highlightPos: null
        });
        view.dispatch(tr);
    }, [
        view
    ]);
    if (!isRemixAvailable || !showRemixButton || areAiEntryPointsDisabled || hasRemixOrEditInProgress) return null;
    const tooltipContent = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : isDisabled ? (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? formatMessage((0, $lhZdS.messages).remixBlockTooltipUpdated) : formatMessage((0, $lhZdS.messages).remixBlockTooltip);
    const renderIconButton = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            label: formatMessage((0, $lhZdS.messages).remixBlockLabel),
            icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
            isDisabled: isDisabled || isRemixing,
            analyticsContext: {
                actionSubjectId: 'remix',
                source: 'remixModalFromNudge',
                attributes: {
                    ...pageMode !== undefined && {
                        pageMode: pageMode
                    },
                    nodeType: rootNodeType,
                    ...contentId !== undefined && contentId !== '' && {
                        contentId: contentId
                    }
                }
            },
            testId: "visible-block-ctrl-remix-button",
            onMouseEnter: handleRemixButtonMouseEnter,
            onMouseLeave: handleRemixButtonMouseLeave,
            onBlur: handleRemixButtonMouseLeave,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: handleClick
        }));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: "right"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1147f98e36d88087$var$containerBaseStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning (left, top, height) calculated at runtime
        style: positionStyles,
        "data-testid": "block-ctrl-remix-button",
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $1147f98e36d88087$var$stickyButtonContainerStyles,
            (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') ? $1147f98e36d88087$var$stickyButtonContainerStylesImprovedStickyHeader : $1147f98e36d88087$var$stickyButtonContainerStylesStickyHeader
        ]
    }, renderIconButton())));
};


const $2986bbc07141fc36$var$TYPE_REMIX_BUTTON = 'REMIX_BUTTON';
const $2986bbc07141fc36$export$901fb543799e0108 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $2986bbc07141fc36$var$TYPE_REMIX_BUTTON);
};
const $2986bbc07141fc36$export$d411c8f539cb0edd = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType })=>{
    const key = crypto.randomUUID();
    const widgetSpec = {
        side: -4,
        type: $2986bbc07141fc36$var$TYPE_REMIX_BUTTON,
        destroy: (_)=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    };
    return (0, $8nvEM.Decoration).widget(rootPos, (view, getPos)=>{
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) throw new Error('Document not available');
        const element = doc.createElement('span');
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) // display:contents makes the span a "phantom" box - zero layout impact,
        // so it never pushes text down when inserted inline around media/embed wraps.
        // The inner position:absolute div in RemixButtonDecoration still renders correctly.
        element.style.display = 'contents';
        else element.style.display = 'block';
        element.contentEditable = 'false';
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
            // Generic right-edge control attribute for block-controls hover area (Remix-specific: data-blocks-remix-button-*)
            element.setAttribute('data-blocks-right-edge-button-container', 'true');
            element.setAttribute('data-blocks-right-edge-button-anchor', rootAnchorName ?? anchorName);
            element.setAttribute('data-blocks-remix-button-container', 'true');
            element.setAttribute('data-blocks-remix-button-anchor', rootAnchorName ?? anchorName);
        }
        element.setAttribute('data-testid', 'block-ctrl-remix-button-container');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $1147f98e36d88087$export$e420cb1e340b26d1), {
                api: api,
                getPos: getPos,
                view: view,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                rootPos: rootPos,
                livePage: livePage,
                isDisabled: isDisabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                remixDisabledReason: remixDisabledReason
            }), element, key, undefined, true);
        return element;
    }, widgetSpec);
};





function $0714cd2e74fa9587$export$c2f4e91d1c0a0502(onEditorViewInit, onEditorViewDestroy, onEditorViewUpdate, onDocumentUpdate) {
    return new (0, $kpCD8.SafePlugin)({
        view (editorView) {
            onEditorViewInit(editorView);
            return {
                update (view, previousState) {
                    if (view.state.doc !== previousState.doc) onDocumentUpdate?.(view);
                    if (!view.state.selection.eq(previousState.selection)) onEditorViewUpdate?.(view);
                },
                destroy () {
                    onEditorViewDestroy?.();
                }
            };
        }
    });
}












function $2bef14e94508caba$export$c976fd9e927eb20d({ state: state, url: url, fieldId: fieldId }) {
    const remixHistoryState = (0, $93f21268088062df$export$2e13bdf171bca4ae).getState(state);
    const historyMap = remixHistoryState?.historyMap;
    if (!historyMap) return;
    // The lookup URL is the live URL on the node. The stack entry URL is what
    // was synthesized when the entry was pushed. They may share a MAUI app id
    // but disagree on origin (e.g. BE-driven updates that re-use the node's
    // pre-update origin vs. user-driven inserts that use window.location.origin),
    // so compare by extracted app id rather than full-string equality.
    const targetAppId = (0, $dOW9b.getMauiIdFromUrl)(url);
    for (const historyEntry of Object.values(historyMap).reverse()){
        const currentStackEntry = [
            ...historyEntry.stack
        ].reverse().find((stackEntry)=>fieldId && stackEntry.fieldId === fieldId || url && stackEntry.url === url || targetAppId && (0, $dOW9b.getMauiIdFromUrl)(stackEntry.url) === targetAppId);
        if (!currentStackEntry) continue;
        const historyEntryForUpdate = {
            ...currentStackEntry.admissionBaselineInvocationId !== undefined && {
                admissionBaselineInvocationId: currentStackEntry.admissionBaselineInvocationId
            },
            conversationId: historyEntry.conversationId,
            dynamicUiSource: historyEntry.dynamicUiSource,
            latestFinalMessage: historyEntry.latestFinalMessage,
            latestFinalMessageId: historyEntry.latestFinalMessageId,
            dynamicUiType: currentStackEntry.dynamicUiType,
            dynamicUiSubtype: currentStackEntry.dynamicUiSubtype,
            finalMessage: currentStackEntry.finalMessage,
            finalMessageId: currentStackEntry.finalMessageId,
            fieldId: currentStackEntry.fieldId,
            url: currentStackEntry.url
        };
        return historyEntryForUpdate;
    }
}



















var $93WrI = parcelRequire("93WrI");





var $8i6M6 = parcelRequire("8i6M6");


var $cCXFd = parcelRequire("cCXFd");





var $dVKvM = parcelRequire("dVKvM");

































const $b924ab10b3fb73fd$var$hasRemixInProgressState = (state)=>Boolean(state?.isRemixModalOpen || state?.isThinking);
const $b924ab10b3fb73fd$var$RemixBlockMenuItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { api: api } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "aiExperience",
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { aiEditInProgress: aiEditInProgress, isRemixUpdate: isRemixUpdate, remixInProgress: remixInProgress } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $b924ab10b3fb73fd$var$_temp);
    const isDisabled = aiEditInProgress || remixInProgress;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
    } else t2 = $[1];
    (0, $cozmU.useEffect)($b924ab10b3fb73fd$var$_temp2, t2);
    let t3;
    if ($[2] !== api.analytics?.actions) {
        t3 = ()=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    entryPoint: "editor",
                    triggeredFrom: "blockMenu"
                }
            });
        };
        $[2] = api.analytics?.actions;
        $[3] = t3;
    } else t3 = $[3];
    const fireClickAnalytics = t3;
    let t4;
    if ($[4] !== api.blockControls?.commands || $[5] !== api.core || $[6] !== api.malleableUi?.commands || $[7] !== api.selection?.commands || $[8] !== experienceTracker) {
        t4 = ()=>{
            api?.core?.actions.execute((t5)=>{
                const { tr: tr } = t5;
                api?.blockControls?.commands?.stopPreservingSelection()({
                    tr: tr
                });
                api?.blockControls?.commands?.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api?.selection?.commands?.clearBlockSelection()({
                    tr: tr
                });
                return tr;
            });
            const openRemixModal = api.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromBlockMenu"
                },
                source: "remixModalFromBlockMenu"
            });
            if (openRemixModal) {
                const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: "editor",
                        remixSource: "blockMenu",
                        ...featureArea !== undefined && {
                            featureArea: featureArea
                        }
                    }
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: {
                        entryPoint: "editor",
                        remixSource: "blockMenu"
                    }
                });
                api.core.actions.execute(openRemixModal);
            }
        };
        $[4] = api.blockControls?.commands;
        $[5] = api.core;
        $[6] = api.malleableUi?.commands;
        $[7] = api.selection?.commands;
        $[8] = experienceTracker;
        $[9] = t4;
    } else t4 = $[9];
    const openRemix = t4;
    let t5;
    if ($[10] !== fireClickAnalytics || $[11] !== isDisabled || $[12] !== openRemix) {
        t5 = ()=>{
            if (isDisabled) return;
            fireClickAnalytics();
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            openRemix();
        };
        $[10] = fireClickAnalytics;
        $[11] = isDisabled;
        $[12] = openRemix;
        $[13] = t5;
    } else t5 = $[13];
    const handleClick = t5;
    let t6;
    if ($[14] !== aiEditInProgress || $[15] !== formatMessage || $[16] !== isDisabled || $[17] !== isRemixUpdate || $[18] !== remixInProgress) {
        t6 = isDisabled ? aiEditInProgress && (!remixInProgress || isRemixUpdate) ? formatMessage((0, $lhZdS.messages).editInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : undefined;
        $[14] = aiEditInProgress;
        $[15] = formatMessage;
        $[16] = isDisabled;
        $[17] = isRemixUpdate;
        $[18] = remixInProgress;
        $[19] = t6;
    } else t6 = $[19];
    const disabledTooltip = t6;
    let t7;
    if ($[20] !== disabledTooltip || $[21] !== formatMessage || $[22] !== handleClick || $[23] !== isDisabled) {
        const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
                onClick: handleClick,
                isDisabled: isDisabled,
                title: disabledTooltip
            }, formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
        t7 = renderMenuItem();
        $[20] = disabledTooltip;
        $[21] = formatMessage;
        $[22] = handleClick;
        $[23] = isDisabled;
        $[24] = t7;
    } else t7 = $[24];
    return t7;
} : ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { aiEditInProgress: aiEditInProgress, isRemixUpdate: isRemixUpdate, remixInProgress: remixInProgress } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience',
        'malleableUi'
    ], (states)=>({
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
            isRemixUpdate: states.malleableUiState?.isUpdate ?? false,
            remixInProgress: $b924ab10b3fb73fd$var$hasRemixInProgressState(states.malleableUiState)
        }));
    const isDisabled = aiEditInProgress || remixInProgress;
    // Fire experiment exposure on mount — registration uses expValEqualsNoExposure
    // to avoid over-counting on every editor load. The exposure is recorded here
    // when the Remix button is actually visible to the user.
    (0, $cozmU.useEffect)(()=>{
        (0, $ieeJu.expValEquals)('platform_editor_remix_in_block_menu', 'isEnabled', true);
    }, []);
    const fireClickAnalytics = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                entryPoint: 'editor',
                triggeredFrom: 'blockMenu'
            }
        });
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)(()=>{
        // Close block menu and clear selection highlight
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            return tr;
        });
        // Start experience tracking and open remix modal.
        // malleableUi is guaranteed to exist here — this component is always
        // registered by malleableUiPlugin itself.
        const openRemixModal = api.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromBlockMenu'
            },
            source: 'remixModalFromBlockMenu'
        });
        if (openRemixModal) {
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'blockMenu',
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'blockMenu'
                }
            });
            api.core.actions.execute(openRemixModal);
        }
    }, [
        api,
        experienceTracker
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        fireClickAnalytics();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        openRemix();
    }, [
        fireClickAnalytics,
        isDisabled,
        openRemix
    ]);
    const disabledTooltip = isDisabled ? aiEditInProgress && (!remixInProgress || isRemixUpdate) ? formatMessage((0, $lhZdS.messages).editInProgressTooltip) : formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : undefined;
    const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            onClick: handleClick,
            isDisabled: isDisabled,
            title: disabledTooltip
        }, formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
    return renderMenuItem();
};
/**
 * Creates block menu registration components for the Remix action.
 *
 * Registered by editor-plugin-malleable-ui (which owns the openRemixModal command)
 * when the platform_editor_remix_in_block_menu experiment is enabled.
 * The AI plugin hides its polish/improve-formatting action when this experiment is on,
 * so the Remix item effectively replaces it.
 */ const $b924ab10b3fb73fd$var$createRemixBlockMenuItemComponent = (api)=>{
    const RemixBlockMenuItemWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
        const $ = (0, $bDgLe.c)(1);
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b924ab10b3fb73fd$var$RemixBlockMenuItem, {
                api: api
            });
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    } : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b924ab10b3fb73fd$var$RemixBlockMenuItem, {
            api: api
        });
    RemixBlockMenuItemWrapper.displayName = 'RemixBlockMenuItemWrapper';
    return RemixBlockMenuItemWrapper;
};
const $b924ab10b3fb73fd$var$getCachedTextLength = (api, editorView, cache)=>{
    const { state: state } = editorView;
    if (cache.state === state) return cache.textLength;
    const textLength = api?.blockControls?.actions.getTextInfo(editorView)?.textLength ?? null;
    cache.state = state;
    cache.textLength = textLength;
    return textLength;
};
const $b924ab10b3fb73fd$export$96499eef52eb1886 = ({ api: api, getEditorView: getEditorView })=>{
    const textLengthCache = {
        state: null,
        textLength: null
    };
    return [
        {
            type: 'block-menu-item',
            key: `ai-${(0, $8i6M6.AI_REMIX_MENU_ITEM).key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.AI_MENU_SECTION).key,
                rank: (0, $cCXFd.AI_MENU_SECTION_RANK)[(0, $8i6M6.AI_MENU_SECTION).key]
            },
            component: $b924ab10b3fb73fd$var$createRemixBlockMenuItemComponent(api),
            isHidden: ()=>{
                if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_blockmenu_integration', 'isEnabled', true)) return true;
                const editorView = getEditorView();
                const menuTriggerByNode = api?.blockControls?.sharedState?.currentState()?.menuTriggerByNode;
                const triggerPos = menuTriggerByNode?.rootPos ?? menuTriggerByNode?.pos;
                const triggeredNode = editorView && triggerPos !== undefined ? editorView.state.doc.nodeAt(triggerPos) : undefined;
                if (triggeredNode?.type.name === 'extension' && (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                    node: triggeredNode
                }) && (0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return false;
                const textLength = editorView ? $b924ab10b3fb73fd$var$getCachedTextLength(api, editorView, textLengthCache) : null;
                // When context is unavailable, default to visible (matches AI plugin behaviour)
                if (textLength === null) return false;
                return textLength < (0, $8i6M6.AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD);
            }
        }
    ];
};
function $b924ab10b3fb73fd$var$_temp(states) {
    return {
        aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState),
        isRemixUpdate: states.malleableUiState?.isUpdate ?? false,
        remixInProgress: $b924ab10b3fb73fd$var$hasRemixInProgressState(states.malleableUiState)
    };
}
function $b924ab10b3fb73fd$var$_temp2() {
    (0, $ieeJu.expValEquals)("platform_editor_remix_in_block_menu", "isEnabled", true);
}

















const $1241c1c67d4cf71c$export$96efdb7b52c260a3 = (editorState, targetId)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate') || !editorState || !targetId) return undefined;
    try {
        let metadata;
        editorState.doc.descendants((node)=>{
            if (metadata || node.attrs.localId !== targetId) return metadata ? false : true;
            const history = (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
                state: editorState,
                url: node.attrs.parameters?.macroParams?.url?.value,
                fieldId: node.type.name === 'mediaSingle' ? node.firstChild?.attrs.id : node.attrs.id
            });
            if (history?.dynamicUiType) metadata = {
                remixType: history.dynamicUiType,
                remixSubtype: history.dynamicUiSubtype
            };
            return false;
        });
        return metadata;
    } catch  {
        return undefined;
    }
};


const $b2e4188f0e483040$export$fdca5082072fada0 = ({ api: api, LifecycleAdapterHost: LifecycleAdapterHost })=>{
    const lifecycleOwner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const retain = lifecycleOwner?.retain;
    const forgetMachineAuthority = lifecycleOwner?.forgetMachineAuthority;
    // Register only stable owner actions so activity changes cannot tear down an admitted attempt.
    const lifecycleOwnerForRegistration = (0, $cozmU.useMemo)(()=>{
        if (!retain || !forgetMachineAuthority) return undefined;
        return {
            active: undefined,
            forgetMachineAuthority: forgetMachineAuthority,
            retain: retain
        };
    }, [
        forgetMachineAuthority,
        retain
    ]);
    const onRegisterEditorRemixMachineLifecycleOwnership = (0, $cozmU.useCallback)((session)=>(0, $dc44c0de1ed07c1a$export$10406465ad92edb2)(api, session), [
        api
    ]);
    const onRegisterEditorInlineRovoEditLifecycleAdapter = (0, $cozmU.useCallback)((adapter)=>(0, $d41f3058f4db498d$export$a890533e09d530df)(api, adapter), [
        api
    ]);
    const onStartInlineRovoEditHandoffPresentation = (0, $cozmU.useCallback)((attemptId)=>{
        if (!api?.core.actions.execute || !api.malleableUi?.commands.startRemixThinking) return false;
        if (!(0, $d41f3058f4db498d$export$516511b718918dc3)(api, attemptId)) return false;
        // Chat can already be open when the inline prompt submits. Promote the
        // toolbar's staged target before the prompt closes its editor experience.
        if ((0, $4o0zT.isExperimentEnabled)('cc_maui_1293_chat_thinking_bar')) api.aiExperience?.actions.commitInlineRovoStreaming?.();
        api.core.actions.execute(api.malleableUi.commands.startRemixThinking({
            isUpdate: true,
            remixAttemptId: attemptId
        }));
        return true;
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!lifecycleOwnerForRegistration) return;
        return (0, $d41f3058f4db498d$export$12ede4f917884c4)(api, lifecycleOwnerForRegistration);
    }, [
        api,
        lifecycleOwnerForRegistration
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditAdmission?.((targetId, editorState)=>{
            try {
                const admission = api.malleableUi?.actions.beginInlineRovoEdit?.(targetId) ?? {
                    status: 'unavailable'
                };
                if (!(0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate') || !editorState || !targetId) return admission;
                const remixMetadata = (0, $1241c1c67d4cf71c$export$96efdb7b52c260a3)(editorState, targetId);
                return {
                    ...admission,
                    ...remixMetadata && {
                        remixMetadata: remixMetadata
                    }
                };
            } catch  {
                // The bridge is optional; unavailable lifecycle infrastructure preserves legacy submission.
                return {
                    status: 'unavailable'
                };
            }
        });
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditProducerAttemptReporting?.((observation)=>(0, $d41f3058f4db498d$export$ffcbf537033846f5)(api, observation));
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditHandoffPresentation?.(onStartInlineRovoEditHandoffPresentation);
    }, [
        api,
        onStartInlineRovoEditHandoffPresentation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return api?.aiExperience?.actions.registerInlineRovoEditReporting?.((attemptId_0, outcome)=>api.malleableUi?.actions.reportInlineRovoEdit?.(attemptId_0, outcome) ?? false);
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LifecycleAdapterHost, {
        onRegisterEditorRemixMachineLifecycleOwnership: onRegisterEditorRemixMachineLifecycleOwnership,
        onRegisterEditorInlineRovoEditLifecycleAdapter: onRegisterEditorInlineRovoEditLifecycleAdapter
    });
};















const $9dcb43796e09f96b$export$136ced6b11a40bba = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { api: api } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $4o0zT.isExperimentEnabled)("maui_remix_feature_area_by_type_exp_gate");
        $[0] = t1;
    } else t1 = $[0];
    const isMetadataEnabled = t1;
    let t2;
    if ($[1] !== api?.aiExperience?.actions) {
        t2 = ()=>{
            if (!isMetadataEnabled) return;
            return api?.aiExperience?.actions.registerInlineRovoEditAdmission?.($9dcb43796e09f96b$var$_temp);
        };
        $[1] = api?.aiExperience?.actions;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== api) {
        t3 = [
            api,
            isMetadataEnabled
        ];
        $[3] = api;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    return null;
} : ({ api: api })=>{
    const isMetadataEnabled = (0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate');
    (0, $cozmU.useEffect)(()=>{
        if (!isMetadataEnabled) return;
        return api?.aiExperience?.actions.registerInlineRovoEditAdmission?.((targetId, editorState)=>{
            const remixMetadata = (0, $1241c1c67d4cf71c$export$96efdb7b52c260a3)(editorState, targetId);
            return {
                status: 'unavailable',
                ...remixMetadata && {
                    remixMetadata: remixMetadata
                }
            };
        });
    }, [
        api,
        isMetadataEnabled
    ]);
    return null;
};
function $9dcb43796e09f96b$var$_temp(targetId, editorState) {
    const remixMetadata = (0, $1241c1c67d4cf71c$export$96efdb7b52c260a3)(editorState, targetId);
    return {
        status: "unavailable",
        ...remixMetadata && {
            remixMetadata: remixMetadata
        }
    };
}















var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");


var $iZMIZ = parcelRequire("iZMIZ");


var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");




const $8990df313a4c5595$export$2a1e596305c92bc7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).DISMISS_FLAG
        });
        return tr;
    };





const $cf98493589757f0e$var$getIcon = (type)=>{
    switch(type){
        case (0, $3kyUj.MauiDiagramPasteFlagType).SUCCESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            });
        case (0, $3kyUj.MauiDiagramPasteFlagType).INFO:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            });
        case (0, $3kyUj.MauiDiagramPasteFlagType).ERROR:
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            });
    }
};
const $cf98493589757f0e$var$getProductFlagType = (type)=>{
    switch(type){
        case (0, $3kyUj.MauiDiagramPasteFlagType).SUCCESS:
            return 'success';
        case (0, $3kyUj.MauiDiagramPasteFlagType).INFO:
            return 'info';
        case (0, $3kyUj.MauiDiagramPasteFlagType).ERROR:
        default:
            return 'error';
    }
};
const $cf98493589757f0e$export$bdca710d02013452 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { api: api, productFlags: productFlags } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeFlag = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $cf98493589757f0e$var$_temp);
    const previousProductFlagIdRef = (0, $cozmU.useRef)();
    let t2;
    if ($[1] !== api?.core.actions) {
        t2 = ()=>{
            api?.core.actions.execute((0, $8990df313a4c5595$export$2a1e596305c92bc7)());
        };
        $[1] = api?.core.actions;
        $[2] = t2;
    } else t2 = $[2];
    const onDismissed = t2;
    let t3;
    let t4;
    if ($[3] !== activeFlag || $[4] !== onDismissed || $[5] !== productFlags) {
        t3 = ()=>{
            if (!productFlags) return;
            const previousProductFlagId = previousProductFlagIdRef.current;
            if (!activeFlag) {
                if (previousProductFlagId) {
                    productFlags.hideFlag(previousProductFlagId);
                    previousProductFlagIdRef.current = undefined;
                }
                return;
            }
            if (previousProductFlagId && previousProductFlagId !== activeFlag.id) productFlags.hideFlag(previousProductFlagId);
            previousProductFlagIdRef.current = activeFlag.id;
            productFlags.showFlag({
                description: activeFlag.description ?? "",
                icon: $cf98493589757f0e$var$getIcon(activeFlag.type),
                id: activeFlag.id,
                onDismissed: onDismissed,
                title: activeFlag.title ?? "",
                type: $cf98493589757f0e$var$getProductFlagType(activeFlag.type)
            });
        };
        t4 = [
            activeFlag,
            onDismissed,
            productFlags
        ];
        $[3] = activeFlag;
        $[4] = onDismissed;
        $[5] = productFlags;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!activeFlag || productFlags) return null;
    const title = activeFlag.title ?? "";
    const description = activeFlag.description ?? "";
    let t5;
    if ($[8] !== activeFlag.type) {
        t5 = $cf98493589757f0e$var$getIcon(activeFlag.type);
        $[8] = activeFlag.type;
        $[9] = t5;
    } else t5 = $[9];
    const icon = t5;
    let t6;
    if ($[10] !== activeFlag.id || $[11] !== description || $[12] !== icon || $[13] !== onDismissed || $[14] !== title) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: icon
        }));
        $[10] = activeFlag.id;
        $[11] = description;
        $[12] = icon;
        $[13] = onDismissed;
        $[14] = title;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ api: api, productFlags: productFlags })=>{
    const activeFlag = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.diagramPaste?.activeFlag ?? null);
    const previousProductFlagIdRef = (0, $cozmU.useRef)();
    const onDismissed = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $8990df313a4c5595$export$2a1e596305c92bc7)());
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!productFlags) return;
        const previousProductFlagId = previousProductFlagIdRef.current;
        if (!activeFlag) {
            if (previousProductFlagId) {
                productFlags.hideFlag(previousProductFlagId);
                previousProductFlagIdRef.current = undefined;
            }
            return;
        }
        if (previousProductFlagId && previousProductFlagId !== activeFlag.id) productFlags.hideFlag(previousProductFlagId);
        previousProductFlagIdRef.current = activeFlag.id;
        productFlags.showFlag({
            description: activeFlag.description ?? '',
            icon: $cf98493589757f0e$var$getIcon(activeFlag.type),
            id: activeFlag.id,
            onDismissed: onDismissed,
            title: activeFlag.title ?? '',
            type: $cf98493589757f0e$var$getProductFlagType(activeFlag.type)
        });
    }, [
        activeFlag,
        onDismissed,
        productFlags
    ]);
    if (!activeFlag || productFlags) return null;
    const title = activeFlag.title ?? '';
    const description = activeFlag.description ?? '';
    const icon = $cf98493589757f0e$var$getIcon(activeFlag.type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: icon
    }));
};
function $cf98493589757f0e$var$_temp(states) {
    return states.malleableUiState?.diagramPaste?.activeFlag ?? null;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





const $828d24cf3c31b50c$var$remixHoverHighlightBackground = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $828d24cf3c31b50c$var$remixHoverHighlightBorder = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $828d24cf3c31b50c$var$persistedHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- ProseMirror decoration class
    '.akEditor div.ProseMirror .remix-thinking-highlight': {
        backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)",
        textDecorationSkipInk: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Default remix hover highlight for non-table nodes
    '.akEditor div.ProseMirror .remix-hover-highlight': {
        background: $828d24cf3c31b50c$var$remixHoverHighlightBackground,
        boxShadow: `0 0 0 2px ${$828d24cf3c31b50c$var$remixHoverHighlightBorder}`
    }
});
const $828d24cf3c31b50c$export$3bccfb6f759a17 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: $828d24cf3c31b50c$var$persistedHighlightStyles
    }));
};


/* RemixContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $2sp5n = parcelRequire("2sp5n");


var $2iHw5 = parcelRequire("2iHw5");














var $iMnC5 = parcelRequire("iMnC5");

















var $7jUr8 = parcelRequire("7jUr8");



/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");





var $w6R6I = parcelRequire("w6R6I");


var $1jz5K = parcelRequire("1jz5K");





var $l3wuH = parcelRequire("l3wuH");








var $8RXjp = parcelRequire("8RXjp");

const $cdf71ed8a5ea431a$var$styles = {
    container: "_2mHwu82ADO _0bjKvDyzSk _1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIwBC3 _4kiQYApJKa _2Zuz6Q5zaO _1Znuxb2ADO _0KLXrulfZc _2OUyjtGk8v _42Yu6BbFo4",
    absolute: "_1mT5xdWVPG",
    readyMessage: "_2sNsIgmnOE _2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _2Zuz6Q2ADO _1UtDYzZpcK _1kk5Tkf7mX"
};
const $cdf71ed8a5ea431a$var$AUTO_DISMISS_DELAY_MS = 10000;
const $cdf71ed8a5ea431a$var$SHORT_AUTO_DISMISS_DELAY_MS = 1000;
function $cdf71ed8a5ea431a$export$c758b087b04ee4fe({ isUpdate: isUpdate = false, onView: onView, onClose: onClose, showActions: showActions = true } = {}) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [isAbsolute, setIsAbsolute] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
         // no scrollParent, such as Jira description editor
        // if in the future, they do have scrollParent, then we need to check if offsetParent is in scrollParent
        const scrollParent = (0, $1jz5K.findOverflowScrollParent)(wrapperRef.current);
        if (!scrollParent) {
            // wrapperRef.current.offsetParent is null when it's fixed
            // so we have to check the parentElement's offsetParent
            const offsetParent = wrapperRef.current.parentElement?.offsetParent;
            if (offsetParent) {
                const offsetParentRect = offsetParent.getBoundingClientRect();
                if (offsetParentRect.bottom < window.innerHeight) setIsAbsolute(true);
            }
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = window.setTimeout(()=>{
            onClose?.({
                auto: true
            });
        }, showActions ? $cdf71ed8a5ea431a$var$AUTO_DISMISS_DELAY_MS : $cdf71ed8a5ea431a$var$SHORT_AUTO_DISMISS_DELAY_MS);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        onClose,
        showActions
    ]);
    const readyMessage = isUpdate ? (0, $8RXjp.remixReadyMessages).updateReady : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $8RXjp.remixReadyMessages).remixReadyUpdated : (0, $8RXjp.remixReadyMessages).remixReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef,
        xcss: (0, $w6R6I.cx)($cdf71ed8a5ea431a$var$styles.container, isAbsolute && $cdf71ed8a5ea431a$var$styles.absolute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cdf71ed8a5ea431a$var$styles.readyMessage
    }, formatMessage(readyMessage)), showActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onView
    }, formatMessage((0, $8RXjp.remixReadyMessages).viewButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        spacing: "compact",
        appearance: "subtle",
        label: formatMessage((0, $8RXjp.remixReadyMessages).closeButton),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            }),
        onClick: ()=>onClose?.()
    })));
}






var $3sXr4 = parcelRequire("3sXr4");


var $ft2zO = parcelRequire("ft2zO");


function $c3515eab9d989c2d$export$81acf0fbb9db54fa(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            payload: options,
            type: 'addHistoryEntry'
        });
        return tr;
    };
}






function $005eb73a7f6b40e4$export$9f60bd9ee414a7c0(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $93f21268088062df$export$2e13bdf171bca4ae), {
            type: 'addHistoryStackEntry',
            payload: options
        });
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixUpdateScrollTargetUrl: options.url
        });
        return tr;
    };
}




const $36058288d319cae1$export$788d053d96dbd6b6 = ({ tr: tr })=>{
    tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
        lifecycle: {
            kind: 'dismiss'
        }
    });
    return tr;
};








const $94cf8481f86e3649$export$e119ad44c40da033 = ({ contentId: contentId, originalUrl: originalUrl, flag: flag })=>({ tr: tr })=>{
        if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return null;
        if (!contentId || !originalUrl) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
            contentId: contentId,
            originalUrl: originalUrl,
            status: (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_SPACE_SELECTION,
            flag: flag
        });
        return tr;
    };



var $90zNn = parcelRequire("90zNn");


const $8ac54cfa8c1aac76$export$831107003cfefb8 = (isComplete)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            lifecycle: {
                kind: isComplete ? 'legacy-complete' : 'legacy-complete-false'
            }
        });
        return tr;
    };
const $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587 = ({ tr: tr })=>{
    tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
        presentation: {
            kind: 'reset'
        }
    });
    return tr;
};



const $5641e9520598103d$export$92f20a5f93e2b790 = (isWaitingForInput)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            isWaitingForInput: isWaitingForInput
        });
        return tr;
    };





const $0a73920d50ae3ac4$export$9c8ccf478e05e6c0 = (showLocationPicker)=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            showLocationPicker: showLocationPicker
        });
        return tr;
    };








var $loghT = parcelRequire("loghT");


















/**
 * Position of the `mediaSingle` wrapping the media node with this id (media is its first child, so
 * the wrapper sits one position earlier), or the media node's own position when it isn't wrapped.
 */ const $8d75a090c1bd5f30$var$findMediaNodePosByMediaId = (doc, mediaId)=>{
    let mediaPos;
    doc.descendants((node, pos, parent)=>{
        if (mediaPos !== undefined) return false;
        if (node.type.name === 'media' && node.attrs.id === mediaId) {
            mediaPos = parent?.type.name === 'mediaSingle' ? pos - 1 : pos;
            return false;
        }
        return true;
    });
    return mediaPos;
};
const $8d75a090c1bd5f30$export$d286e3535d15a9f0 = (editorView, mediaId)=>{
    const mediaPos = $8d75a090c1bd5f30$var$findMediaNodePosByMediaId(editorView.state.doc, mediaId);
    const mediaDom = mediaPos !== undefined ? editorView.nodeDOM(mediaPos) : null;
    return mediaDom instanceof HTMLElement ? mediaDom : mediaDom?.parentElement ?? null;
};


const $d1bf1147fd18e4d3$var$getViewportPlacement = ({ element: element, root: root, requireSubstantiallyVisible: requireSubstantiallyVisible = false })=>{
    try {
        const elementRect = element.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        const isInViewport = elementRect.bottom > rootRect.top && elementRect.right > rootRect.left && elementRect.top < rootRect.bottom && elementRect.left < rootRect.right;
        if (isInViewport && requireSubstantiallyVisible) {
            // Clamp the scroll root to the window: the `document.body` fallback root reports the whole
            // document height rather than the visible area.
            const viewportTop = Math.max(rootRect.top, 0);
            const viewportBottom = Math.min(rootRect.bottom, window.innerHeight);
            const visibleHeight = Math.min(elementRect.bottom, viewportBottom) - Math.max(elementRect.top, viewportTop);
            const requiredVisibleHeight = Math.min(elementRect.height, viewportBottom - viewportTop) / 2;
            return visibleHeight >= requiredVisibleHeight ? 'in-view' : 'bottom';
        }
        if (isInViewport) return 'in-view';
        // The floating bar always sits at the bottom of the viewport when the inline
        // widget is scrolled out of view, regardless of scroll direction.
        return 'bottom';
    } catch  {
        // On measurement failure, behave as if the widget is in view so we never
        // show a stuck floating bar we cannot position.
        return 'in-view';
    }
};
const $d1bf1147fd18e4d3$export$c58dfb1653294667 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { editorView: editorView, isActive: isActive, diagramContentId: diagramContentId, imageMediaId: imageMediaId, onDiagramBoardReady: onDiagramBoardReady, onDiagramBoardTimeout: onDiagramBoardTimeout } = t0;
    const [placement, setPlacement] = (0, $cozmU.useState)("in-view");
    const boardElementRef = (0, $cozmU.useRef)(null);
    const imageElementRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== diagramContentId || $[1] !== editorView || $[2] !== imageMediaId || $[3] !== isActive || $[4] !== onDiagramBoardReady || $[5] !== onDiagramBoardTimeout) {
        t1 = ()=>{
            if (!isActive || !editorView) {
                boardElementRef.current = null;
                imageElementRef.current = null;
                setPlacement("in-view");
                return;
            }
            const isDiagram = diagramContentId !== undefined;
            const isImage = imageMediaId !== undefined;
            const anchorElement = ()=>(0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
            const resolveTrackedElement = ()=>{
                if (isImage) {
                    if (imageElementRef.current?.isConnected) return {
                        element: imageElementRef.current,
                        isImageNode: true
                    };
                    const image = (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, imageMediaId);
                    if (image) {
                        imageElementRef.current = image;
                        return {
                            element: image,
                            isImageNode: true
                        };
                    }
                    const anchor = anchorElement();
                    return anchor ? {
                        element: anchor,
                        isImageNode: false
                    } : null;
                }
                if (isDiagram) {
                    if (boardElementRef.current?.isConnected) return {
                        element: boardElementRef.current,
                        isImageNode: false
                    };
                    const pos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, diagramContentId);
                    if (pos !== undefined) {
                        const dom = editorView.nodeDOM(pos);
                        const boardElement = dom instanceof HTMLElement ? dom : dom?.parentElement instanceof HTMLElement ? dom.parentElement : null;
                        boardElementRef.current = boardElement;
                        return boardElement ? {
                            element: boardElement,
                            isImageNode: false
                        } : null;
                    }
                    return null;
                }
                const anchor_0 = anchorElement();
                return anchor_0 ? {
                    element: anchor_0,
                    isImageNode: false
                } : null;
            };
            const runMeasure = (root)=>{
                const tracked = resolveTrackedElement();
                if (!tracked) {
                    setPlacement("in-view");
                    return;
                }
                setPlacement($d1bf1147fd18e4d3$var$getViewportPlacement({
                    element: tracked.element,
                    root: root,
                    requireSubstantiallyVisible: tracked.isImageNode
                }));
            };
            if (isDiagram) {
                const root_0 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
                const measure = ()=>runMeasure(root_0);
                let frameId;
                let unbindScroll = $d1bf1147fd18e4d3$var$_temp;
                let unbindResize = $d1bf1147fd18e4d3$var$_temp2;
                const startTracking = ()=>{
                    measure();
                    onDiagramBoardReady?.();
                    const scrollTarget = root_0 === document.body ? window : root_0;
                    unbindScroll = (0, $cbY7C.bind)(scrollTarget, {
                        type: "scroll",
                        listener: measure,
                        options: {
                            passive: true,
                            capture: true
                        }
                    });
                    unbindResize = (0, $cbY7C.bind)(window, {
                        type: "resize",
                        listener: measure,
                        options: {
                            passive: true
                        }
                    });
                };
                let frames = 0;
                const pollForBoard = ()=>{
                    if (resolveTrackedElement()) {
                        startTracking();
                        return;
                    }
                    frames = frames + 1;
                    frames;
                    if (frames >= 300) {
                        onDiagramBoardTimeout?.();
                        return;
                    }
                    frameId = requestAnimationFrame(pollForBoard);
                };
                if (resolveTrackedElement()) startTracking();
                else frameId = requestAnimationFrame(pollForBoard);
                return ()=>{
                    if (frameId !== undefined) cancelAnimationFrame(frameId);
                    unbindScroll();
                    unbindResize();
                    boardElementRef.current = null;
                    imageElementRef.current = null;
                };
            }
            if (!resolveTrackedElement()) {
                setPlacement("in-view");
                return;
            }
            const root_1 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
            const measure_0 = ()=>runMeasure(root_1);
            measure_0();
            const scrollTarget_0 = root_1 === document.body ? window : root_1;
            const unbindScroll_0 = (0, $cbY7C.bind)(scrollTarget_0, {
                type: "scroll",
                listener: measure_0,
                options: {
                    passive: true,
                    capture: true
                }
            });
            const unbindResize_0 = (0, $cbY7C.bind)(window, {
                type: "resize",
                listener: measure_0,
                options: {
                    passive: true
                }
            });
            return ()=>{
                unbindScroll_0();
                unbindResize_0();
                boardElementRef.current = null;
                imageElementRef.current = null;
            };
        };
        t2 = [
            editorView,
            isActive,
            diagramContentId,
            imageMediaId,
            onDiagramBoardReady,
            onDiagramBoardTimeout
        ];
        $[0] = diagramContentId;
        $[1] = editorView;
        $[2] = imageMediaId;
        $[3] = isActive;
        $[4] = onDiagramBoardReady;
        $[5] = onDiagramBoardTimeout;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    return placement;
} : ({ editorView: editorView, isActive: isActive, diagramContentId: diagramContentId, imageMediaId: imageMediaId, onDiagramBoardReady: onDiagramBoardReady, onDiagramBoardTimeout: onDiagramBoardTimeout })=>{
    const [placement, setPlacement] = (0, $cozmU.useState)('in-view');
    // Caches the resolved diagram DOM node so we don't walk the doc on every
    // scroll/resize; re-resolved only once the cached node leaves the document.
    const boardElementRef = (0, $cozmU.useRef)(null);
    // Same for the inserted image: resolving it walks the doc, so cache it rather than traversing on
    // every scroll/resize.
    const imageElementRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isActive || !editorView) {
            boardElementRef.current = null;
            imageElementRef.current = null;
            setPlacement('in-view');
            return;
        }
        const isDiagram = diagramContentId !== undefined;
        const isImage = imageMediaId !== undefined;
        const anchorElement = ()=>(0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
        // For diagrams, track the whiteboard node itself (its position drives the scroll-vs-"View"
        // decision); for images, the inserted media node; other remixes track the thinking widget.
        // `isImageNode` says whether we ended up on the image itself rather than falling back to the
        // anchor, so `runMeasure` doesn't have to re-query the DOM to work that out.
        const resolveTrackedElement = ()=>{
            if (isImage) {
                if (imageElementRef.current?.isConnected) return {
                    element: imageElementRef.current,
                    isImageNode: true
                };
                const image = (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, imageMediaId);
                if (image) {
                    imageElementRef.current = image;
                    return {
                        element: image,
                        isImageNode: true
                    };
                }
                // Fall back to the anchor if the media node has gone (e.g. the user deleted it). Not
                // cached: the upload may still be in flight, and the anchor is a cheap querySelector.
                const anchor = anchorElement();
                return anchor ? {
                    element: anchor,
                    isImageNode: false
                } : null;
            }
            if (isDiagram) {
                if (boardElementRef.current?.isConnected) return {
                    element: boardElementRef.current,
                    isImageNode: false
                };
                const pos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, diagramContentId);
                if (pos !== undefined) {
                    const dom = editorView.nodeDOM(pos);
                    const boardElement = dom instanceof HTMLElement ? dom : dom?.parentElement instanceof HTMLElement ? dom.parentElement : null;
                    boardElementRef.current = boardElement;
                    return boardElement ? {
                        element: boardElement,
                        isImageNode: false
                    } : null;
                }
                // The board mounts asynchronously, so it may not be in the document yet — the caller
                // keeps polling until it appears.
                return null;
            }
            const anchor_0 = anchorElement();
            return anchor_0 ? {
                element: anchor_0,
                isImageNode: false
            } : null;
        };
        // Re-resolves the tracked element each call (it can mount/unmount/be replaced mid-remix) and
        // updates placement against the scroll root.
        const runMeasure = (root)=>{
            const tracked = resolveTrackedElement();
            if (!tracked) {
                setPlacement('in-view');
                return;
            }
            setPlacement($d1bf1147fd18e4d3$var$getViewportPlacement({
                element: tracked.element,
                root: root,
                // Only the image path tracks a full-size result element; the zero-height anchor and
                // the diagram board keep the plain intersection rule.
                requireSubstantiallyVisible: tracked.isImageNode
            }));
        };
        // Nothing to measure when the effect first runs (board mounts async, widget already cleared),
        // so poll until the board mounts, then track it with the usual scroll/resize listeners.
        if (isDiagram) {
            const root_0 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
            const measure = ()=>runMeasure(root_0);
            let frameId;
            let unbindScroll = ()=>{};
            let unbindResize = ()=>{};
            const startTracking = ()=>{
                measure();
                // The board is now in the document and its placement measured — signal the earliest
                // point a scroll can safely target it.
                onDiagramBoardReady?.();
                const scrollTarget = root_0 === document.body ? window : root_0;
                unbindScroll = (0, $cbY7C.bind)(scrollTarget, {
                    type: 'scroll',
                    listener: measure,
                    options: {
                        passive: true,
                        capture: true
                    }
                });
                unbindResize = (0, $cbY7C.bind)(window, {
                    type: 'resize',
                    listener: measure,
                    options: {
                        passive: true
                    }
                });
            };
            // ~300 frames ≈ 5s at 60fps — a ceiling for the async insert to land; past it assume a failed
            // insert and stop rather than poll forever. (rAF pauses in background tabs, so no hidden spin.)
            const MAX_POLL_FRAMES = 300;
            let frames = 0;
            const pollForBoard = ()=>{
                if (resolveTrackedElement()) {
                    startTracking();
                    return;
                }
                frames += 1;
                if (frames >= MAX_POLL_FRAMES) {
                    onDiagramBoardTimeout?.();
                    return;
                }
                frameId = requestAnimationFrame(pollForBoard);
            };
            if (resolveTrackedElement()) startTracking();
            else frameId = requestAnimationFrame(pollForBoard);
            return ()=>{
                if (frameId !== undefined) cancelAnimationFrame(frameId);
                unbindScroll();
                unbindResize();
                boardElementRef.current = null;
                imageElementRef.current = null;
            };
        }
        // Non-diagram: bail out (without querying the scroll parent) when the widget isn't present yet.
        if (!resolveTrackedElement()) {
            setPlacement('in-view');
            return;
        }
        const root_1 = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || document.body;
        const measure_0 = ()=>runMeasure(root_1);
        measure_0();
        // Re-measure on scroll (both the overflow scroll parent and the window, to
        // cover page-level scrolling) and on resize.
        const scrollTarget_0 = root_1 === document.body ? window : root_1;
        const unbindScroll_0 = (0, $cbY7C.bind)(scrollTarget_0, {
            type: 'scroll',
            listener: measure_0,
            options: {
                passive: true,
                capture: true
            }
        });
        const unbindResize_0 = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: measure_0,
            options: {
                passive: true
            }
        });
        return ()=>{
            unbindScroll_0();
            unbindResize_0();
            boardElementRef.current = null;
            imageElementRef.current = null;
        };
    }, [
        editorView,
        isActive,
        diagramContentId,
        imageMediaId,
        onDiagramBoardReady,
        onDiagramBoardTimeout
    ]);
    return placement;
};
const $d1bf1147fd18e4d3$export$7523f6d059999b11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { editorView: editorView, isComplete: isComplete } = t0;
    let t1;
    if ($[0] !== editorView || $[1] !== isComplete) {
        t1 = {
            editorView: editorView,
            isActive: isComplete
        };
        $[0] = editorView;
        $[1] = isComplete;
        $[2] = t1;
    } else t1 = $[2];
    const placement = $d1bf1147fd18e4d3$export$c58dfb1653294667(t1);
    return placement === "in-view";
} : ({ editorView: editorView, isComplete: isComplete })=>{
    const placement = $d1bf1147fd18e4d3$export$c58dfb1653294667({
        editorView: editorView,
        isActive: isComplete
    });
    return placement === 'in-view';
};
function $d1bf1147fd18e4d3$var$_temp() {}
function $d1bf1147fd18e4d3$var$_temp2() {}


















const $ce233e243bc5fa07$export$2e3ceb21b2f61793 = (remixDiagramContentId)=>({ tr: tr })=>{
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            remixDiagramContentId: remixDiagramContentId
        });
        return tr;
    };


const $e4ad0a68bee3bd68$export$34656d0347a5137b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { api: api, isThinking: isThinking } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const remixDiagramContentId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $e4ad0a68bee3bd68$var$_temp);
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    let t2;
    if ($[1] !== api?.core || $[2] !== isThinking || $[3] !== remixDiagramContentId) {
        t2 = ()=>{
            const justStartedThinking = isThinking && !prevIsThinkingRef.current;
            prevIsThinkingRef.current = isThinking;
            if (justStartedThinking && remixDiagramContentId !== undefined) api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(undefined));
        };
        $[1] = api?.core;
        $[2] = isThinking;
        $[3] = remixDiagramContentId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== api || $[6] !== isThinking || $[7] !== remixDiagramContentId) {
        t3 = [
            isThinking,
            remixDiagramContentId,
            api
        ];
        $[5] = api;
        $[6] = isThinking;
        $[7] = remixDiagramContentId;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== api?.core) {
        t4 = (contentId)=>{
            api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(contentId));
        };
        $[9] = api?.core;
        $[10] = t4;
    } else t4 = $[10];
    const recordDiagramContentId = t4;
    let t5;
    if ($[11] !== remixDiagramContentId) {
        t5 = (editorView)=>{
            if (remixDiagramContentId === undefined) return null;
            const boardPos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, remixDiagramContentId);
            const boardDom = boardPos !== undefined ? editorView.nodeDOM(boardPos) : null;
            return boardDom instanceof HTMLElement ? boardDom : boardDom?.parentElement ?? null;
        };
        $[11] = remixDiagramContentId;
        $[12] = t5;
    } else t5 = $[12];
    const resolveDiagramScrollTarget = t5;
    let t6;
    if ($[13] !== recordDiagramContentId || $[14] !== remixDiagramContentId || $[15] !== resolveDiagramScrollTarget) {
        t6 = {
            recordDiagramContentId: recordDiagramContentId,
            remixDiagramContentId: remixDiagramContentId,
            resolveDiagramScrollTarget: resolveDiagramScrollTarget
        };
        $[13] = recordDiagramContentId;
        $[14] = remixDiagramContentId;
        $[15] = resolveDiagramScrollTarget;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ api: api, isThinking: isThinking })=>{
    // contentId of the diagram produced by the in-flight remix (set at streaming-start).
    // Presence marks this remix as a diagram and lets the ready-signal UI target the board node.
    const remixDiagramContentId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixDiagramContentId);
    // Clear a diagram contentId left over from a previous remix when a new one starts (rising edge
    // of isThinking), so a later non-diagram remix never targets a stale board.
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justStartedThinking = isThinking && !prevIsThinkingRef.current;
        prevIsThinkingRef.current = isThinking;
        if (justStartedThinking && remixDiagramContentId !== undefined) api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(undefined));
    }, [
        isThinking,
        remixDiagramContentId,
        api
    ]);
    // Record the streaming diagram's contentId (called from the 'suppressed' finalize-status branch
    // as the board starts streaming in).
    const recordDiagramContentId = (0, $cozmU.useCallback)((contentId)=>{
        api?.core.actions.execute((0, $ce233e243bc5fa07$export$2e3ceb21b2f61793)(contentId));
    }, [
        api
    ]);
    // The whiteboard's DOM element (by contentId) so the scroll can target the board. Null for
    // non-diagram remixes or before the board mounts — callers fall back to the anchor resolution.
    const resolveDiagramScrollTarget = (0, $cozmU.useCallback)((editorView)=>{
        if (remixDiagramContentId === undefined) return null;
        const boardPos = (0, $51bd462f1be2ad42$export$c3cec2ff440d20b7)(editorView.state.doc, remixDiagramContentId);
        const boardDom = boardPos !== undefined ? editorView.nodeDOM(boardPos) : null;
        return boardDom instanceof HTMLElement ? boardDom : boardDom?.parentElement ?? null;
    }, [
        remixDiagramContentId
    ]);
    return {
        recordDiagramContentId: recordDiagramContentId,
        remixDiagramContentId: remixDiagramContentId,
        resolveDiagramScrollTarget: resolveDiagramScrollTarget
    };
};
function $e4ad0a68bee3bd68$var$_temp(states) {
    return states.malleableUiState?.remixDiagramContentId;
}
















const $0e92e32cfa4af727$export$62164441b7fc0faa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { api: api, isThinking: isThinking } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const recordedImageMediaId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $0e92e32cfa4af727$var$_temp);
    const remixImageMediaId = recordedImageMediaId;
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    let t2;
    if ($[1] !== api?.core || $[2] !== isThinking || $[3] !== remixImageMediaId) {
        t2 = ()=>{
            const justStartedThinking = isThinking && !prevIsThinkingRef.current;
            prevIsThinkingRef.current = isThinking;
            if (justStartedThinking && remixImageMediaId !== undefined) api?.core.actions.execute((0, $8ef7f637f4ca3dda$export$f36198854f9520d1)({
                mediaId: undefined
            }));
        };
        $[1] = api?.core;
        $[2] = isThinking;
        $[3] = remixImageMediaId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== api || $[6] !== isThinking || $[7] !== remixImageMediaId) {
        t3 = [
            isThinking,
            remixImageMediaId,
            api
        ];
        $[5] = api;
        $[6] = isThinking;
        $[7] = remixImageMediaId;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== remixImageMediaId) {
        t4 = (editorView)=>{
            if (remixImageMediaId === undefined) return null;
            return (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, remixImageMediaId);
        };
        $[9] = remixImageMediaId;
        $[10] = t4;
    } else t4 = $[10];
    const resolveImageScrollTarget = t4;
    let t5;
    if ($[11] !== remixImageMediaId || $[12] !== resolveImageScrollTarget) {
        t5 = {
            remixImageMediaId: remixImageMediaId,
            resolveImageScrollTarget: resolveImageScrollTarget
        };
        $[11] = remixImageMediaId;
        $[12] = resolveImageScrollTarget;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ api: api, isThinking: isThinking })=>{
    // Media id of the image this remix inserted (set by the rovo bridge once the upload lands).
    const recordedImageMediaId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixImageMediaId);
    const remixImageMediaId = recordedImageMediaId;
    // Clear an image id left over from a previous remix when a new one starts (rising edge of
    // isThinking), so a later non-image remix never targets a stale image.
    const prevIsThinkingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justStartedThinking = isThinking && !prevIsThinkingRef.current;
        prevIsThinkingRef.current = isThinking;
        if (justStartedThinking && remixImageMediaId !== undefined) api?.core.actions.execute((0, $8ef7f637f4ca3dda$export$f36198854f9520d1)({
            mediaId: undefined
        }));
    }, [
        isThinking,
        remixImageMediaId,
        api
    ]);
    // The inserted image's DOM element. Null for non-image remixes or before the upload lands —
    // callers fall back to the anchor resolution.
    const resolveImageScrollTarget = (0, $cozmU.useCallback)((editorView)=>{
        if (remixImageMediaId === undefined) return null;
        return (0, $8d75a090c1bd5f30$export$d286e3535d15a9f0)(editorView, remixImageMediaId);
    }, [
        remixImageMediaId
    ]);
    return {
        remixImageMediaId: remixImageMediaId,
        resolveImageScrollTarget: resolveImageScrollTarget
    };
};
function $0e92e32cfa4af727$var$_temp(states) {
    return states.malleableUiState?.remixImageMediaId;
}







const $da0e6f79e5c28019$var$isEmptyParagraphNode = (node)=>{
    return node.type === 'paragraph' && (node.content?.length ?? 0) === 0;
};
const $da0e6f79e5c28019$var$isNativeEmbedNode = (node)=>{
    const { attrs: attrs } = node;
    return node.type === 'extension' && typeof attrs === 'object' && attrs !== null && 'extensionKey' in attrs && typeof attrs.extensionKey === 'string' && attrs.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && 'localId' in attrs && typeof attrs.localId === 'string' && attrs.localId.length > 0;
};
const $da0e6f79e5c28019$var$getNativeEmbedUrl = (node)=>{
    const url = node.attrs.parameters?.macroParams?.url?.value;
    return typeof url === 'string' ? url : undefined;
};
const $da0e6f79e5c28019$var$getTerminalUrlSegment = (url)=>{
    try {
        const pathname = new URL(url).pathname;
        return pathname.split('/').filter(Boolean).pop();
    } catch  {
        return url.split('/').filter(Boolean).pop();
    }
};
const $da0e6f79e5c28019$export$5afa7589883bc579 = ({ nodeUrl: nodeUrl, targetUrl: targetUrl })=>{
    if (nodeUrl === targetUrl) return true;
    const nodeId = $da0e6f79e5c28019$var$getTerminalUrlSegment(nodeUrl);
    const targetId = $da0e6f79e5c28019$var$getTerminalUrlSegment(targetUrl);
    return Boolean(nodeId && targetId && nodeId === targetId);
};
const $da0e6f79e5c28019$var$resolveNativeEmbedScrollTargetByUrl = ({ doc: doc, targetUrl: targetUrl, editorView: editorView })=>{
    if (!targetUrl) return null;
    let targetPos;
    doc.descendants((node, pos)=>{
        if (targetPos !== undefined) return false;
        const nodeUrl = $da0e6f79e5c28019$var$getNativeEmbedUrl(node);
        if (node.type.name === 'extension' && typeof node.attrs.extensionKey === 'string' && node.attrs.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && nodeUrl && $da0e6f79e5c28019$export$5afa7589883bc579({
            nodeUrl: nodeUrl,
            targetUrl: targetUrl
        })) {
            targetPos = pos;
            return false;
        }
        return true;
    });
    const targetDom = targetPos !== undefined ? editorView.nodeDOM(targetPos) : null;
    return targetDom instanceof HTMLElement ? targetDom : targetDom?.parentElement ?? null;
};
const $da0e6f79e5c28019$var$isNativeContentContextFragment = (context)=>{
    return context?.type === 'nativeContentContext' && 'contentResult' in context;
};
const $da0e6f79e5c28019$var$isEmbeddedPageContent = (content)=>{
    return typeof content === 'object' && content !== null && 'embeddedPageBody' in content && typeof content.embeddedPageBody === 'string';
}; // JSON.parse succeeds on non-document payloads (`123`, `null`, `[]`), so the shape must be checked.
const $da0e6f79e5c28019$var$isAdfDocument = (value)=>{
    return typeof value === 'object' && value !== null && !Array.isArray(value) && value.type === 'doc';
};
const $da0e6f79e5c28019$var$getRemixTypeProps = (selectedContext)=>{
    const blockProps = {
        remixType: 'block'
    };
    if (!(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return blockProps;
     // The AI selection context can include empty paragraph nodes adjacent to the
    // user-selected object. Ignore those placeholders so selecting a single native
    // embed plus surrounding empty paragraphs still enables object remix, while
    // any other selected content continues to fall back to block remix.
    const nodes = selectedContext.selectionFragment?.filter((node)=>!$da0e6f79e5c28019$var$isEmptyParagraphNode(node));
    if (nodes?.length !== 1) return blockProps;
    const [node] = nodes;
    if (!node || !$da0e6f79e5c28019$var$isNativeEmbedNode(node)) return blockProps;
    const { localId: localId } = node.attrs;
    const context = selectedContext.additionalNodeContext?.[localId];
    if (!$da0e6f79e5c28019$var$isNativeContentContextFragment(context)) return blockProps;
     // A rejection here (or a rejected `contentResult`) is the read failure; the consumer handles it as a non-success.
    const adfDocument = context.contentResult.then((content)=>{
        if (content === undefined) throw new Error('Native embed content is unavailable');
        if (!$da0e6f79e5c28019$var$isEmbeddedPageContent(content) || content.embeddedPageBody === '') throw new Error('Native embed content is missing an embedded page body');
        let parsedBody;
        try {
            parsedBody = JSON.parse(content.embeddedPageBody);
        } catch  {
            throw new Error('Native embed content is malformed');
        }
        if (!$da0e6f79e5c28019$var$isAdfDocument(parsedBody)) throw new Error('Native embed content is not a valid ADF document');
        return parsedBody;
    }); // The consumer only awaits this on option-select, so a read that fails earlier has no awaiter yet.
    // The inert handler prevents an unhandled rejection; the consumer's await still gets the rejection.
    adfDocument.catch(()=>undefined);
    return {
        remixType: 'object',
        adfDocument: adfDocument
    };
};
const $da0e6f79e5c28019$var$styles = {
    floatingBarBottom: "_1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _39xV02E6Kk _4ouGXIHakr _42Yu6BbFo4"
}; // How long the floating "ready" bar stays visible while the remix is out of
// view before auto-dismissing (per the Remix Figma spec).
const $da0e6f79e5c28019$var$READY_BAR_AUTO_DISMISS_MS = 10000; // Operational event fired when diagram board tracking gives up (custom event — not part of the
const $da0e6f79e5c28019$var$EMPTY_EDITOR_REMIX_LIFECYCLE_PRESENTATION = {
    animationFinished: false,
    authority: undefined,
    phase: undefined,
    remixId: undefined,
    token: undefined
};
const $da0e6f79e5c28019$export$9b636cd211668abd = ({ api: api, hiddenOptions: hiddenOptions, isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment, remixContentComponent: Component })=>{
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    const machinePresentation = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api) : $da0e6f79e5c28019$var$EMPTY_EDITOR_REMIX_LIFECYCLE_PRESENTATION;
    const capturedAnimationFinishedSink = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$66f5178019bac961)(api) : undefined;
    const capturedTerminalCleanupSink = isEditorRemixStateRearchitectureTreatment ? (0, $dc44c0de1ed07c1a$export$3a7772ffa9a9fcc0)(api) : undefined;
    const [dismissedReadySession, setDismissedReadySession] = (0, $cozmU.useState)(undefined);
    const previousImageMediaIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isEditorRemixStateRearchitectureTreatment) return;
        return (0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation((value)=>value + 1));
    }, [
        api,
        isEditorRemixStateRearchitectureTreatment,
        machinePresentation.remixId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (dismissedReadySession !== undefined && dismissedReadySession !== machinePresentation.remixId) setDismissedReadySession(undefined);
    }, [
        dismissedReadySession,
        machinePresentation.remixId
    ]);
    const { editorView: editorView } = (0, $cozmU.useContext)((0, $2iHw5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCurrentReadyPresentationDismissed = dismissedReadySession !== undefined && dismissedReadySession === machinePresentation.remixId; /**
                                                                                                                                             * True while a lifecycle-machine session still owns this flow.
                                                                                                                                             *
                                                                                                                                             * An early streaming whiteboard moves the machine into `inserting` before generation finishes,
                                                                                                                                             * and the projection reports that as `!isThinking && isComplete`. That is not a ready result, so
                                                                                                                                             * every ready-presentation path below has to use this ownership boundary rather than trusting
                                                                                                                                             * those two booleans on their own. The session is registered for the life of the flow.
                                                                                                                                             */ 
    const hasLiveMachineFlow = machinePresentation.authority === 'active'; /**
                                                                          * True only while the machine is inserting, which for a diagram starts when the early streaming
                                                                          * whiteboard lands and generation is still running.
                                                                          *
                                                                          * `hasLiveMachineFlow` cannot stand in for this. It is also true after the flow genuinely
                                                                          * completes, and suppressing the ready presentation for that whole window would take away the
                                                                          * treatment ready bar and its auto-dismiss.
                                                                          */ 
    const isMachineInserting = machinePresentation.phase === 'inserting';
    const registerRemixResultTracking = (0, $7jUr8.useRemixRetentionTracker)(api?.malleableUi?.actions?.observeRemixResultLifecycle);
    const isViewMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode === 'view');
    const isModalOpen = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_0)=>states_0.malleableUiState?.isRemixModalOpen || false);
    const isThinking = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_1)=>states_1.malleableUiState?.isThinking || false);
    const isWaitingForInput = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_2)=>states_2.malleableUiState?.isWaitingForInput || false);
    const isComplete = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_3)=>states_3.malleableUiState?.isComplete || false);
    const remixModalMetadata = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_4)=>states_4.malleableUiState?.remixModalMetadata);
    const remixSource = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_5)=>states_5.malleableUiState?.remixSource);
    const remixAttemptId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_6)=>states_6.malleableUiState?.remixAttemptId);
    const showLocationPicker = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_7)=>states_7.malleableUiState?.showLocationPicker || false);
    const isUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_8)=>states_8.malleableUiState?.isUpdate || false);
    const historyEntryForUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_9)=>states_9.malleableUiState?.historyEntryForUpdate);
    const dynamicUiSubtypeForUpdate = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_10)=>states_10.malleableUiState?.dynamicUiSubtypeForUpdate);
    const savedSelection = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_11)=>states_11.malleableUiState?.savedSelection);
    const remixUpdateScrollTargetUrl = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_12)=>states_12.malleableUiState?.remixUpdateScrollTargetUrl); // Diagram-specific ready-signal logic (board tracking + scroll targeting) lives in its own hook.
    // When this isn't a diagram remix the returned values are inert.
    const { remixDiagramContentId: remixDiagramContentId, recordDiagramContentId: recordDiagramContentId, resolveDiagramScrollTarget: resolveDiagramScrollTarget } = (0, $e4ad0a68bee3bd68$export$34656d0347a5137b)({
        api: api,
        isThinking: isThinking
    }); // Image-specific ready-signal logic (media-node scroll target). Inert for non-image remixes.
    const { remixImageMediaId: remixImageMediaId, resolveImageScrollTarget: resolveImageScrollTarget } = (0, $0e92e32cfa4af727$export$62164441b7fc0faa)({
        api: api,
        isThinking: isThinking
    }); // Start Remix experience for floating toolbar entry point (can't use hooks in toolbar config).
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const isSuggestedRemix = remixSource === 'suggestedRemix' && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
    const prevIsModalOpen = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!prevIsModalOpen.current && isModalOpen && remixSource === 'floatingToolbar') {
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'floatingToolbar',
                    product: 'confluence',
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            if (!isUpdate) (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'floatingToolbar',
                    product: 'confluence'
                }
            });
        }
        prevIsModalOpen.current = isModalOpen;
    }, [
        isModalOpen,
        isUpdate,
        remixSource,
        experienceTracker
    ]);
    const previousSuggestedRemixAttemptId = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (isSuggestedRemix && remixAttemptId !== undefined && previousSuggestedRemixAttemptId.current !== remixAttemptId) {
            previousSuggestedRemixAttemptId.current = remixAttemptId;
            const attributes = {
                entryPoint: 'editor',
                remixAttemptId: remixAttemptId,
                remixSource: 'suggestedRemix',
                product: 'confluence'
            };
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: attributes
            });
            if (!isUpdate) (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: attributes,
                includeOpenMenuExperience: false
            });
        }
    }, [
        experienceTracker,
        isSuggestedRemix,
        isUpdate,
        remixAttemptId
    ]);
    const capturedSelectionContext = isSuggestedRemix || !isViewMode && (0, $4o0zT.isExperimentEnabled)('cc-ce-mau-remix-editor-selection-boundaries') && remixModalMetadata?.hasNormalizedSelection ? remixModalMetadata?.capturedSelectionContext : undefined;
    const selectedContext = capturedSelectionContext ?? api?.aiExperience?.actions.getAISelectionContext();
    const hasSelectionFragment = selectedContext?.selectionFragment != null;
    const failedMenuOpenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isModalOpen) {
            failedMenuOpenRef.current = false;
            return;
        }
        if (failedMenuOpenRef.current || remixSource !== 'floatingToolbar' || Component && hasSelectionFragment) return;
        failedMenuOpenRef.current = true;
        const error = new Error(Component ? 'Could not open Remix menu: selectionFragment is null or undefined' : 'Could not open Remix menu: remixContentComponent is undefined');
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            error: error
        });
        (0, $kDDrf.failRemixOpenMenuExperience)(experienceTracker, error);
        (0, $kDDrf.failRemixCreateExperience)(experienceTracker, error);
        api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
    }, [
        api,
        Component,
        experienceTracker,
        hasSelectionFragment,
        isModalOpen,
        remixSource
    ]);
    const remixTypeProps = (0, $cozmU.useMemo)(()=>selectedContext ? $da0e6f79e5c28019$var$getRemixTypeProps(selectedContext) : undefined, [
        selectedContext
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
    }, [
        api
    ]);
    const onStartThinking = (0, $cozmU.useCallback)((options)=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $3ed7f22374c9e3fb$export$fdf82e9851b59bf0)({
            api: api,
            options: options
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
            api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
        }
    }, [
        api
    ]);
    const onStopThinking = (0, $cozmU.useCallback)((options_0)=>{
        // Settle the rendered attempt unless the request is being preserved for handoff.
        if (!options_0?.preserveRequest && remixAttemptId) api?.malleableUi?.actions.reportInlineRovoEdit?.(remixAttemptId, 'generation-aborted');
        const cleanup = ()=>{
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                // Abort before cancelling so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events via AbortError.
                // `preserveRequest` keeps the in-flight request alive (the preview it streams into is
                // opening) while still dismissing the thinking UI.
                if (!options_0?.preserveRequest) (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                    api: api,
                    reopenModal: options_0?.reopenModal
                });
            } else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_0));
            }
        }; // Treatment callbacks capture their session before any UX mutation. A delayed callback from
        // A must not abort, toggle, or dispatch cleanup against replacement B. Legacy callbacks have
        // no captured sink and retain their existing behavior.
        if (capturedTerminalCleanupSink) capturedTerminalCleanupSink(cleanup);
        else cleanup();
    }, [
        api,
        capturedTerminalCleanupSink,
        remixAttemptId
    ]);
    const onCancelThinking = (0, $cozmU.useCallback)((cleanup_0)=>{
        const cancel = ()=>{
            const cancelFromThinkingBar = (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.cancelFromThinkingBar;
            if (cancelFromThinkingBar) cancelFromThinkingBar(cleanup_0);
            else cleanup_0();
        };
        if (capturedTerminalCleanupSink) capturedTerminalCleanupSink(cancel);
        else cancel();
    }, [
        api,
        capturedTerminalCleanupSink
    ]);
    const onDismissThinkingUi = (0, $cozmU.useCallback)((options_1)=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
            api: api,
            reopenModal: options_1?.reopenModal
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_1));
        } // The dismissal above clears `isThinking` through a `legacy-stop` write, which the reducer
        // drops while write authority is held. Same predicate as that fence, so control is untouched.
        if (options_1?.endsFlow && (0, $dc44c0de1ed07c1a$export$f2d1c70f96537b99)(api)) api?.core.actions.execute((0, $36058288d319cae1$export$788d053d96dbd6b6));
    }, [
        api
    ]);
    const onRegisterAbortRequest = (0, $cozmU.useCallback)((abortFn)=>(0, $b96b9e650a905796$export$f9cb53c9d12f6f55)(api, abortFn), [
        api
    ]);
    const onRegisterEditorRemixMachineLifecycleOwnership = (0, $cozmU.useCallback)((session)=>(0, $dc44c0de1ed07c1a$export$10406465ad92edb2)(api, session), [
        api
    ]); /**
                                                                                                                                                                                           * Deliberately not gated, matching `onRegisterAbortRequest` above: this is the same kind of
                                                                                                                                                                                           * api-keyed bridge, and publishing into a registry slot is inert on its own.
                                                                                                                                                                                           *
                                                                                                                                                                                           * The only reader is `EditorRemixEffectHost`, and `malleableUiPlugin` mounts that behind the
                                                                                                                                                                                           * master gate and an exposure-free cohort read — so in control, master-gate-off and adapter-absent
                                                                                                                                                                                           * Jira the slot is written and never read. `malleableUiPlugin-remixEffectHost.test.tsx` asserts
                                                                                                                                                                                           * the host is absent for those cohorts, which is what makes that structural rather than a
                                                                                                                                                                                           * convention.
                                                                                                                                                                                           *
                                                                                                                                                                                           * Gating here would mean evaluating the same experiment a second time on a render path, or
                                                                                                                                                                                           * threading the plugin's decision down purely to guard a `WeakMap` write.
                                                                                                                                                                                           */ 
    const onRegisterEditorRemixUxHandles = (0, $cozmU.useCallback)((handles)=>(0, $dc44c0de1ed07c1a$export$7d31a25b751a9034)(api, handles), [
        api
    ]);
    const onRegisterEditorRemixMutationCancellationSink = (0, $cozmU.useCallback)((sink)=>(0, $dc44c0de1ed07c1a$export$e4c5d0e97ec647cf)(api, sink), [
        api
    ]);
    const onBeforeEditorRemixResultInsertion = (0, $cozmU.useCallback)(()=>(0, $dc44c0de1ed07c1a$export$8c3960abef4008ee)(api), [
        api
    ]);
    const remixRecoveryCoordinator = (0, $loghT.useEditorRemixRecoveryCoordinator)();
    const clearThinkingDecoration = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $592515a66bfc26f7$export$65f89d2d4741e4b7)());
    }, [
        api
    ]);
    const replaceWhiteboardEmbed = (0, $cozmU.useCallback)((options_2)=>{
        if (!api) return {
            acknowledged: false,
            outcome: 'editor-unavailable'
        };
        let outcome;
        const acknowledged = api.core.actions.execute(api.malleableUi.commands.replaceWhiteboardEmbed({
            ...options_2,
            onOutcome: (nextOutcome)=>{
                outcome = nextOutcome;
            }
        })) === true;
        return {
            acknowledged: acknowledged,
            outcome: !acknowledged && outcome === 'replaced' ? 'execution-not-acknowledged' : outcome ?? 'execution-not-acknowledged'
        };
    }, [
        api
    ]); // Maps the MAUI-side string status to the editor's finalize-status enum.
    const setMauiEmbedFinalizeStatus = (0, $cozmU.useCallback)((options_3)=>{
        api?.core.actions.execute(api?.malleableUi.commands.setMauiEmbedFinalizeStatus({
            contentId: options_3.contentId,
            status: options_3.status === 'suppressed' ? (0, $3kyUj.MauiEmbedFinalizeStatus).STREAMING : (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_FINALIZE
        })); // The 'suppressed' status is set as the diagram starts streaming in — record its
        // contentId so the ready-signal UI can target the board node.
        if (options_3.status === 'suppressed') recordDiagramContentId(options_3.contentId);
    }, [
        api,
        recordDiagramContentId
    ]);
    const setThinkingComplete = (0, $cozmU.useCallback)((isComplete_0)=>{
        // this is to clear the inline-Rovo streaming target when the remix is complete
        if (isComplete_0) api?.aiExperience?.actions?.endInlineRovoStreaming?.();
        if (isEditorRemixStateRearchitectureTreatment && (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api)) {
            if (!isComplete_0) {
                setDismissedReadySession(machinePresentation.remixId); // Lifecycle stays machine-owned. Clear only the editor presentation so the completed
                // inline portal is removed without a legacy lifecycle write being discarded.
                api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587));
            }
        } else api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$831107003cfefb8)(isComplete_0));
         // View mode owns the floating thinking bar; let that bar finish its completion
        // animation and open the preview before stopping thinking.
        if (isComplete_0 && !isViewMode) (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api,
            capturedAnimationFinishedSink: capturedAnimationFinishedSink
        });
    }, [
        api,
        capturedAnimationFinishedSink,
        isEditorRemixStateRearchitectureTreatment,
        isViewMode,
        machinePresentation.remixId
    ]);
    const setThinkingWaitingForInput = (0, $cozmU.useCallback)((waiting)=>{
        api?.core.actions.execute((0, $5641e9520598103d$export$92f20a5f93e2b790)(waiting));
    }, [
        api
    ]);
    const _onRemixThinkingCompleteAnimationFinished = (0, $cozmU.useCallback)(()=>{
        (0, $b96b9e650a905796$export$ae8cbff5055b0856)({
            api: api,
            capturedAnimationFinishedSink: capturedAnimationFinishedSink
        });
    }, [
        api,
        capturedAnimationFinishedSink
    ]);
    const setShowLocationPicker = (0, $cozmU.useCallback)((showLocationPicker_0)=>{
        api?.core.actions.execute((0, $0a73920d50ae3ac4$export$9c8ccf478e05e6c0)(showLocationPicker_0));
    }, [
        api
    ]); // When automatic finalization of a remixed whiteboard fails, open the shared
    // native-embed space picker (the same UI used by the paste / in-embed banner
    // flow) instead of the platform's remix-only picker. We dispatch two separate
    // transactions: first register the embed as NEEDS_SPACE_SELECTION (carrying
    // the "Choose where to save whiteboard" flag), then open the picker. Returns
    // `true` so the platform skips its own fallback flag + picker.
    const onFinalizeFailed = (0, $cozmU.useCallback)(({ contentId: contentId, originalUrl: originalUrl })=>{
        if (!api) return false;
        api.core.actions.execute((0, $94cf8481f86e3649$export$e119ad44c40da033)({
            contentId: contentId,
            originalUrl: originalUrl,
            flag: {
                id: `maui-embed-finalize-space-picker-${contentId}`,
                type: (0, $3kyUj.MauiDiagramPasteFlagType).INFO,
                title: formatMessage((0, $lhZdS.messages).flagFinalizeSpacePickerTitle),
                description: formatMessage((0, $lhZdS.messages).flagFinalizeSpacePickerDescription)
            }
        }));
        api.core.actions.execute((0, $90zNn.openMauiEmbedSpacePickerCommand)({
            contentId: contentId,
            originalUrl: originalUrl
        }));
        remixRecoveryCoordinator?.defer(contentId);
        return true;
    }, [
        api,
        formatMessage,
        remixRecoveryCoordinator
    ]);
    const addHistoryEntry = (0, $cozmU.useCallback)((options_4)=>{
        api?.core.actions.execute((0, $c3515eab9d989c2d$export$81acf0fbb9db54fa)(options_4));
    }, [
        api
    ]);
    const addHistoryStackEntry = (0, $cozmU.useCallback)((options_5)=>{
        api?.core.actions.execute((0, $005eb73a7f6b40e4$export$9f60bd9ee414a7c0)(options_5));
    }, [
        api
    ]); // Bridges the plugin's `trackVariantUpdateComplete` command into the
    // remix flow; `useOnComplete` fires it once the FE insertion settles.
    const onVariantUpdateComplete = (0, $cozmU.useCallback)((id)=>{
        if (!api?.malleableUi?.commands.trackVariantUpdateComplete) return;
        api.core.actions.execute(api.malleableUi.commands.trackVariantUpdateComplete({
            id: id
        }));
    }, [
        api
    ]); // Shows the "Output adjusted" flag via editor-level plugin state, which
    // survives this component unmounting on completion.
    const onSubtypeMismatch = (0, $cozmU.useCallback)(()=>{
        if (!api?.malleableUi?.commands.showSubtypeAdjustedFlag) return;
        api.core.actions.execute(api.malleableUi.commands.showSubtypeAdjustedFlag());
    }, [
        api
    ]); // The whiteboard is inserted asynchronously, so it isn't in the document when the remix reports
    // "ready". Latch its mount so the scroll waits for it (else it lands on the pre-remix selection).
    const [isDiagramBoardReady, setIsDiagramBoardReady] = (0, $cozmU.useState)(false);
    const handleDiagramBoardReady = (0, $cozmU.useCallback)(()=>{
        setIsDiagramBoardReady(true);
    }, []); // Reset the latch when a new remix begins so a prior remix's board can't trigger this one's scroll.
    (0, $cozmU.useEffect)(()=>{
        if (isThinking) setIsDiagramBoardReady(false);
    }, [
        isThinking
    ]); // Report when diagram board tracking gives up (the board never mounted) so we can measure how
    // often the ready-signal silently falls back to the shared behaviour. Fires at most once per remix.
    const handleDiagramBoardTimeout = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'timedOut',
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'readySignalBoardTracking',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: remixDiagramContentId
            }
        });
    }, [
        api,
        remixDiagramContentId
    ]); // Track where the inline thinking widget sits relative to the viewport so we
    // can float a bar at the matching edge (top/bottom) whenever it scrolls out
    // of view — during both the thinking phase and the completed "ready" phase.
    // Gated so we don't resolve DOM or bind scroll/resize listeners when the
    // in-editor loading feature is off.
    const floatingBarPlacement = (0, $d1bf1147fd18e4d3$export$c58dfb1653294667)({
        editorView: editorView,
        // `isComplete` alone would start the viewport work during the whiteboard's `inserting` gap,
        // where the result is not actually ready yet.
        isActive: (isThinking || isComplete && !isMachineInserting) && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'),
        diagramContentId: remixDiagramContentId,
        // Once an image remix's upload lands, the in-view decision is about the media node rather
        // than the zero-height thinking anchor that sits just above it.
        imageMediaId: remixImageMediaId,
        onDiagramBoardReady: handleDiagramBoardReady,
        onDiagramBoardTimeout: handleDiagramBoardTimeout
    });
    const isRemixReady = !isViewMode && isComplete && !isThinking && !isModalOpen && // An inserting flow is still generating even when the projection says complete, so it must not
    // present as ready. This also keeps the ready bar's auto-dismiss from firing mid-flow and
    // resetting presentation state the flow still needs.
    !isMachineInserting && !isCurrentReadyPresentationDismissed && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
    (0, $cozmU.useEffect)(()=>{
        if (remixImageMediaId !== undefined && previousImageMediaIdRef.current !== remixImageMediaId) setDismissedReadySession(undefined);
        previousImageMediaIdRef.current = remixImageMediaId;
    }, [
        remixImageMediaId
    ]);
    const handleReadyToastView = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            // For diagrams, scroll to the whiteboard node itself; null for other remixes or before
            // the board mounts, so we fall back to the anchor resolution below.
            const boardTarget = resolveDiagramScrollTarget(editorView);
            const updateTarget = isUpdate ? $da0e6f79e5c28019$var$resolveNativeEmbedScrollTargetByUrl({
                doc: editorView.state.doc,
                editorView: editorView,
                targetUrl: remixUpdateScrollTargetUrl
            }) : null; // Images are uploaded and inserted after the remix reports ready, so target the media node
            // once it has landed — by then the thinking anchor no longer marks the result.
            const imageTarget = boardTarget ? null : resolveImageScrollTarget(editorView);
            const container = (0, $29d6db7c0a9c3ffe$export$2f3df55a342cf539)(editorView);
            const target = boardTarget || updateTarget || imageTarget || savedSelection?.from !== undefined && editorView.nodeDOM(savedSelection.from) || container || (()=>{
                try {
                    if (!savedSelection?.to) return null;
                    const resolved = editorView.state.doc.resolve(savedSelection.to);
                    const anchorPos = resolved.depth >= 1 ? resolved.after(1) : savedSelection.to;
                    const domAtPos = editorView.domAtPos(anchorPos);
                    return domAtPos.node instanceof HTMLElement ? domAtPos.node : domAtPos.node.parentElement;
                } catch  {
                    return null;
                }
            })();
            if (target instanceof HTMLElement) {
                // Leave breathing room above the board (below the sticky toolbar). scrollIntoView reads the
                // margin synchronously, so set it for this scroll then clear it — no lingering node mutation.
                const needsScrollMargin = target === boardTarget || target === imageTarget;
                if (needsScrollMargin) target.style.scrollMarginTop = "var(--ds-space-300, 24px)";
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                if (needsScrollMargin) target.style.scrollMarginTop = '';
            }
        } // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        editorView,
        savedSelection?.from,
        savedSelection?.to,
        isUpdate,
        remixUpdateScrollTargetUrl,
        resolveDiagramScrollTarget,
        resolveImageScrollTarget,
        setThinkingComplete
    ]);
    const handleReadyToastClose = (0, $cozmU.useCallback)(()=>{
        // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        setThinkingComplete
    ]); // Diagrams must wait for the async board mount before scrolling; other remixes have their result
    // in place already, so they scroll as soon as ready.
    const isDiagramRemix = remixDiagramContentId !== undefined;
    const isScrollTargetReady = isRemixReady && (!isDiagramRemix || isDiagramBoardReady); // Only scroll on the rising edge of readiness — not on later 'in-view' transitions from the user
    // scrolling the result into view, which would hijack their scroll.
    const prevIsScrollTargetReadyRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justBecameReady = isScrollTargetReady && !prevIsScrollTargetReadyRef.current;
        prevIsScrollTargetReadyRef.current = isScrollTargetReady;
        if (!justBecameReady || !editorView) return;
         // These updates never scroll, so they never reach `handleReadyToastView`, which is what clears
        // the presentation. Only machine-owned flows need it done here: control clears the decoration
        // through `stopRemixThinking` on the legacy completion branch, which treatment skips.
        if (isUpdate) {
            if ((0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api)) setThinkingComplete(false);
            return;
        } // Out of view the ready bar owns dismissal, and clears the presentation with it.
        if (floatingBarPlacement !== 'in-view') return;
        const animationFrameId = requestAnimationFrame(handleReadyToastView);
        return ()=>cancelAnimationFrame(animationFrameId);
    }, [
        api,
        editorView,
        floatingBarPlacement,
        handleReadyToastView,
        isScrollTargetReady,
        isUpdate,
        setThinkingComplete
    ]); // handle escape key to stop remix thinking
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isThinking || !editorView) return;
         // focus editor first
        if (!editorView.hasFocus()) editorView.focus();
        return (0, $cbY7C.bind)(editorView.dom, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    onCancelThinking(()=>{
                        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                            // Abort before cancelling so send-message-action.ts fires the paired
                            // aiInteraction initiated + dismissed events via AbortError.
                            (0, $b96b9e650a905796$export$e125c3b8c9ddf1a1)(api)?.();
                            (0, $b96b9e650a905796$export$e02ace41eac2e13a)({
                                api: api,
                                reopenModal: false
                            });
                        } else {
                            if ((0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                                // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
                                // call the onCancel callback instead of reopening the remix modal.
                                const currentMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
                                const cancelledPrompt = currentMetadata?.userPrompt;
                                const onCancel = currentMetadata?.onCancel;
                                if (cancelledPrompt && onCancel) {
                                    onStopThinking({
                                        reopenModal: false
                                    });
                                    onCancel();
                                    return;
                                }
                            }
                            onStopThinking({
                                reopenModal: false
                            });
                        }
                    });
                }
            }
        });
    }, [
        isThinking,
        onStopThinking,
        onCancelThinking,
        editorView,
        api?.malleableUi.sharedState,
        api
    ]); // When the remix modal overlay is open (isModalOpen),
    // set the editor user intent to 'overlayOpen' so the floating toolbar is suppressed
    // (it would otherwise appear above the overlay in Jira).
    // We intentionally do NOT suppress during the thinking-only state
    // — the user may still interact with the editor while the AI is thinking.
    // Reset to 'default' when the modal closes or the component unmounts.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isModalOpen) {
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'overlayOpen') api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            return;
        }
        api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('overlayOpen'));
        return ()=>{
            api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
        };
    }, [
        isModalOpen,
        api
    ]); // Auto-dismiss the floating "ready" bar after a fixed delay when the remix is
    // complete but out of view (per the Figma spec). Resetting thinking-complete
    // removes the bar; if the user scrolls back to their remix (placement becomes
    // 'in-view') the bar is hidden anyway and the timer is cleared.
    const isFloatingReadyBarVisible = !isViewMode && isComplete && !isThinking && !isModalOpen && // Same boundary as `isRemixReady`: no ready bar, and so no auto-dismiss, while inserting.
    !isMachineInserting && !isCurrentReadyPresentationDismissed && floatingBarPlacement !== 'in-view' && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading'); // `remixImageMediaId` is a dep so the window restarts when an image remix's upload finally
    // lands: for images the bar appears before the media node exists, and dismissing it while the
    // result is still arriving would leave the user with no way back to it.
    (0, $cozmU.useEffect)(()=>{
        if (!isFloatingReadyBarVisible) return;
        const scheduledTreatmentSession = isEditorRemixStateRearchitectureTreatment && (0, $dc44c0de1ed07c1a$export$4050079e84e0fec6)(api) ? machinePresentation.remixId : undefined;
        const timeoutId = setTimeout(()=>{
            if (scheduledTreatmentSession !== undefined) {
                if ((0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api).remixId === scheduledTreatmentSession) // Marks the ready session dismissed and clears the presentation, which this path used
                // to skip: the decoration then survived an auto-dismiss that never scrolled.
                setThinkingComplete(false);
                return;
            }
            setThinkingComplete(false);
        }, $da0e6f79e5c28019$var$READY_BAR_AUTO_DISMISS_MS);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        api,
        isFloatingReadyBarVisible,
        isEditorRemixStateRearchitectureTreatment,
        machinePresentation.remixId,
        remixImageMediaId,
        setThinkingComplete
    ]);
    if (!api || !Component || !selectedContext || !remixTypeProps) return null;
     // when the remix isComplete and
    // - the modal is not open because isComplete may not be reset to false when the modal is open
    // - not thinking because we need to show the thinking bar when isThinking and isComplete
    //   - after onCompleteAnimationFinished, isThinking will be false and only isComplete will be true
    // we need to show the ready toast
    if (isRemixReady) {
        // Surface the shared Rovo "ready" state as a floating bar at the edge of the
        // viewport (closing the inline thinking bar). Only show it when the inline
        // widget is scrolled out of view so it can take the user back to their remix.
        if (floatingBarPlacement === 'in-view') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $da0e6f79e5c28019$var$styles.floatingBarBottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sXr4.RovoThinkingBarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ft2zO.RovoThinkingReady), {
            onView: handleReadyToastView,
            onClose: handleReadyToastClose,
            readyText: formatMessage(isUpdate ? (0, $8RXjp.remixReadyMessages).updateReady : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $8RXjp.remixReadyMessages).remixReadyUpdated : (0, $8RXjp.remixReadyMessages).remixReady)
        })));
    } // When the flag is ON, only show when isModalOpen, isThinking, or showLocationPicker — this
    // is the correct gating behaviour for the new loading path.
    // When the flag is OFF (legacy path), always show — EXCEPT when a pre-supplied userPrompt
    // is present (image-gen flow) and the flow is done (neither isModalOpen nor isThinking),
    // to prevent the option-picker from flashing on cancellation.
    const hasPreSuppliedPrompt = !!remixModalMetadata?.userPrompt;
    const canShow = isModalOpen || isThinking || // `Component` owns the subtree that finalizes the insertion. The machine reports
    // `!isThinking` from the moment the early streaming whiteboard lands, so without this the
    // owner unmounts mid-flow and the final message never arrives to finalize it.
    hasLiveMachineFlow || showLocationPicker || !(0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') && !hasPreSuppliedPrompt; // While the remix is generating, surface a floating thinking bar at the edge
    // of the viewport whenever the inline thinking widget is scrolled out of view,
    // so the user stays aware the process is ongoing. It sticks to the bottom when
    // the widget is above the viewport, or the top when it is below. Rendered
    // alongside the modal/option-picker Component (not instead of it) so any
    // underlying streaming/staging state is never unmounted.
    //
    // During an update (edit of an existing remix), the RemixContainer inside
    // `Component` already renders its own fixed thinking bar (its `hideThinkingBar`
    // guard is `isThinking && !isUpdate`, so it is only hidden for fresh inserts).
    // Rendering this floating bar as well would produce two overlapping, slightly
    // offset bars, so it is gated off for updates to keep a single loading bar.
    const showFloatingThinkingBar = !isViewMode && isThinking && !isUpdate && !isModalOpen && floatingBarPlacement !== 'in-view' && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading');
    const floatingThinkingBar = showFloatingThinkingBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da0e6f79e5c28019$var$styles.floatingBarBottom
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: remixAttemptId,
        loadingBarType: "mini-bar",
        isRelative: true,
        onStop: ()=>{
            onCancelThinking(()=>onStopThinking({
                    reopenModal: false
                }));
        }
    })) : null;
    if (!canShow || Component === undefined) return floatingThinkingBar;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, floatingThinkingBar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ...remixTypeProps,
        remixAttemptId: remixAttemptId,
        isViewMode: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? isViewMode : undefined,
        isModalOpen: isModalOpen,
        hasLiveMachineFlow: hasLiveMachineFlow,
        isThinking: isThinking,
        isUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? isUpdate : undefined,
        historyEntryForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? historyEntryForUpdate : undefined,
        dynamicUiSubtypeForUpdate: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? dynamicUiSubtypeForUpdate : undefined,
        isComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? isComplete : undefined,
        registerRemixResultTracking: registerRemixResultTracking,
        handleModalClose: handleModalClose,
        remixSource: remixSource,
        isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment,
        selectedContext: selectedContext,
        editorApi: api,
        clearThinkingDecoration: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? clearThinkingDecoration : undefined,
        replaceWhiteboardEmbed: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? replaceWhiteboardEmbed : undefined,
        setMauiEmbedFinalizeStatus: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setMauiEmbedFinalizeStatus : undefined,
        setThinkingComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setThinkingComplete : undefined,
        setThinkingWaitingForInput: setThinkingWaitingForInput,
        onStartThinking: onStartThinking,
        onDismissThinkingUi: onDismissThinkingUi,
        onStopThinking: onStopThinking,
        onRegisterAbortRequest: onRegisterAbortRequest,
        onRegisterEditorRemixMachineLifecycleOwnership: onRegisterEditorRemixMachineLifecycleOwnership,
        onRegisterEditorRemixUxHandles: onRegisterEditorRemixUxHandles,
        onRegisterEditorRemixMutationCancellationSink: onRegisterEditorRemixMutationCancellationSink,
        onBeforeEditorRemixResultInsertion: onBeforeEditorRemixResultInsertion,
        onRemixThinkingCompleteAnimationFinished: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? _onRemixThinkingCompleteAnimationFinished : undefined,
        showLocationPicker: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? showLocationPicker : false,
        setShowLocationPicker: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? setShowLocationPicker : ()=>{},
        onFinalizeFailed: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? onFinalizeFailed : undefined,
        addHistoryEntry: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? addHistoryEntry : ()=>{},
        addHistoryStackEntry: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? addHistoryStackEntry : ()=>{},
        onVariantUpdateComplete: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? onVariantUpdateComplete : undefined,
        onSubtypeMismatch: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? onSubtypeMismatch : undefined,
        remixModalMetadata: remixModalMetadata,
        hiddenOptions: hiddenOptions
    }));
};


/**
 * Remix right surface block control, registered via the UI Control Registry API as a replacement
 * for `RemixButtonDecoration`. Positioning is fully owned by the block-controls right-surface host
 * (`BlockControlsRightSurfaces` / `getSurfacePlacement`) — this component only renders content.
 */ 


















































const $b3a2adec84b86170$export$9097235bf2b51422 = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, surfaceContext: surfaceContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const rootNodeType = context?.rootNode.type.name ?? context?.targetNode.type.name ?? '';
    const rootPos = context?.rootNode.pos ?? context?.targetNode.pos;
    const { editorViewMode: editorViewMode, contentId: contentId, isOwnRemixing: isOwnRemixing, isAnyRemixing: isAnyRemixing, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            editorViewMode: states.editorViewModeState?.mode,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isOwnRemixing: Boolean(states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking),
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
        }));
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    const isRemixAvailable = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const hasRemixOrEditInProgress = (isRemixing || aiEditInProgress) && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const nodePosRef = (0, $cozmU.useRef)(rootPos);
    nodePosRef.current = rootPos;
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const clearHoverHighlight = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    const openRemix = (0, $cozmU.useCallback)(()=>{
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        // Clear the hover highlight decoration before opening the modal to prevent flashing
        clearHoverHighlight();
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: nodePosRef.current,
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge'
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        clearHoverHighlight,
        experienceTracker,
        rootNodeType
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        openRemix();
    }, [
        isDisabled,
        openRemix
    ]);
    const handleRemixButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3') || rootPos === undefined) return;
        api?.core.actions.execute(({ tr: tr_0 })=>tr_0.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: rootPos,
                rootNodeType: rootNodeType
            }));
    }, [
        api,
        rootNodeType,
        rootPos
    ]);
    const handleRemixButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        api?.core.actions.execute(({ tr: tr_1 })=>tr_1.setMeta((0, $3397a9320ab7f32b$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
    }, [
        api
    ]);
    if (!isRemixAvailable || areAiEntryPointsDisabled || hasRemixOrEditInProgress) return null;
    const tooltipContent = isRemixing ? formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : isDisabled ? (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : (0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? formatMessage((0, $lhZdS.messages).remixBlockTooltipUpdated) : formatMessage((0, $lhZdS.messages).remixBlockTooltip);
    const renderIconButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            label: formatMessage((0, $lhZdS.messages).remixBlockLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
            isDisabled: isDisabled || isRemixing,
            analyticsContext: {
                actionSubjectId: 'remix',
                source: 'remixModalFromNudge',
                attributes: {
                    ...pageMode !== undefined && {
                        pageMode: pageMode
                    },
                    nodeType: rootNodeType,
                    ...contentId !== undefined && contentId !== '' && {
                        contentId: contentId
                    }
                }
            },
            testId: "visible-block-ctrl-remix-button",
            onMouseEnter: handleRemixButtonMouseEnter,
            onMouseLeave: handleRemixButtonMouseLeave,
            onBlur: handleRemixButtonMouseLeave,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: handleClick
        }));
    return renderIconButton();
};


















var $a2foB = parcelRequire("a2foB");











const $7d0e604702ca44aa$var$FLAG_ID = 'maui-remix-subtype-adjusted';
const $7d0e604702ca44aa$export$a91404893a3e2794 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { api: api, productFlags: productFlags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const isShown = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $7d0e604702ca44aa$var$_temp);
    let t2;
    if ($[1] !== api?.core.actions) {
        t2 = ()=>{
            api?.core.actions.execute((0, $756f290e221243c1$export$cc7138497964f45a)());
        };
        $[1] = api?.core.actions;
        $[2] = t2;
    } else t2 = $[2];
    const onDismissed = t2;
    let t3;
    if ($[3] !== intl) {
        t3 = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagTitle);
        $[3] = intl;
        $[4] = t3;
    } else t3 = $[4];
    const title = t3;
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagDescription);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    const description = t4;
    const hasShownFlag = (0, $cozmU.useRef)(false);
    let t5;
    let t6;
    if ($[7] !== description || $[8] !== isShown || $[9] !== onDismissed || $[10] !== productFlags || $[11] !== title) {
        t5 = ()=>{
            if (!productFlags) return;
            if (!isShown) {
                if (hasShownFlag.current) {
                    productFlags.hideFlag($7d0e604702ca44aa$var$FLAG_ID);
                    hasShownFlag.current = false;
                }
                return;
            }
            hasShownFlag.current = true;
            productFlags.showFlag({
                autoDismissSeconds: 8,
                description: description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: "",
                    color: "var(--ds-icon-information, #357DE8)"
                }),
                id: $7d0e604702ca44aa$var$FLAG_ID,
                onDismissed: onDismissed,
                title: title,
                type: "info"
            });
        };
        t6 = [
            description,
            isShown,
            onDismissed,
            productFlags,
            title
        ];
        $[7] = description;
        $[8] = isShown;
        $[9] = onDismissed;
        $[10] = productFlags;
        $[11] = title;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (productFlags) return null;
    if (!isShown) return null;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-information, #357DE8)"
        });
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== description || $[16] !== onDismissed || $[17] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: $7d0e604702ca44aa$var$FLAG_ID,
            testId: $7d0e604702ca44aa$var$FLAG_ID,
            icon: t7
        }));
        $[15] = description;
        $[16] = onDismissed;
        $[17] = title;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ api: api, productFlags: productFlags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const isShown = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.showSubtypeAdjustedFlag ?? false);
    const onDismissed = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute((0, $756f290e221243c1$export$cc7138497964f45a)());
    }, [
        api
    ]);
    const title = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagTitle);
    const description = intl.formatMessage((0, $lhZdS.messages).subtypeAdjustedFlagDescription);
    // Track whether we have ever raised the flag through the product sink, so we
    // only call hideFlag after a real show. Without this guard, hideFlag(FLAG_ID)
    // would fire on initial mount whenever productFlags is provided and isShown is
    // false, spuriously asking the host to hide a flag that was never shown.
    const hasShownFlag = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!productFlags) return;
        if (!isShown) {
            if (hasShownFlag.current) {
                productFlags.hideFlag($7d0e604702ca44aa$var$FLAG_ID);
                hasShownFlag.current = false;
            }
            return;
        }
        hasShownFlag.current = true;
        productFlags.showFlag({
            autoDismissSeconds: 8,
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            }),
            id: $7d0e604702ca44aa$var$FLAG_ID,
            onDismissed: onDismissed,
            title: title,
            type: 'info'
        });
    }, [
        description,
        isShown,
        onDismissed,
        productFlags,
        title
    ]);
    if (productFlags) return null;
    if (!isShown) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: $7d0e604702ca44aa$var$FLAG_ID,
        testId: $7d0e604702ca44aa$var$FLAG_ID,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-information, #357DE8)"
        })
    }));
};
function $7d0e604702ca44aa$var$_temp(states) {
    return states.malleableUiState?.showSubtypeAdjustedFlag ?? false;
}






var $9DHhW = parcelRequire("9DHhW");

/**
 * The editor's command-effect boundary: machine commands in, editor UX out.
 *
 * Registered by the editor plugin's persistent effect host for the state-machine cohort. The
 * Confluence lifecycle adapter starts admitted flows with `useCommandBus`, so commands reach this
 * hook through the process-default in-memory dispatcher.
 *
 * What this owns is the *policy* — which flow a command belongs to, whether its effect has already
 * run, and when the latched terminal read session may be dismissed. The product effects themselves
 * are injected, because they are editor UX (experience settlement, preview close, sidebar) that this
 * product-neutral package must not know about.
 *
 * ## Command order is not the order you would guess
 *
 * `@atlassian/state-machine` fires transition listeners *before* a state's `onEnter` effects. The
 * lifecycle observer in `editorRemixLifecycleOwner` runs on the transition and releases machine
 * ownership, which tears the flow down and announces `RemixFlowEnded`; the commands for the state
 * just entered are dispatched afterwards. So a terminal phase arrives as:
 *
 *     RemixFlowEnded('error')   →  RemixErrored  →  RemixGenerationEnded('error')
 *     RemixFlowEnded('aborted') →  RemixAborted  →  RemixGenerationEnded('aborted')
 *
 * `RemixFlowEnded` is therefore NOT last for a terminal outcome, and two rules follow:
 *
 *  1. The claim set is reset on session replacement only, never on `RemixFlowEnded` — clearing it
 *     there would wipe the claims immediately *before* the terminal UX commands arrive, so a
 *     repeated `RemixErrored` would run error cleanup twice.
 *  2. `RemixFlowEnded('error' | 'aborted')` must retain the session. The paired `RemixErrored` /
 *     `RemixAborted` cleanup dismisses it, and only once that cleanup has run.
 *
 * Dismissal is still ordering-safe: the observer writes the latched phase into the provider's ref
 * synchronously before releasing, and `dismissTerminal` reads that ref rather than rendered state.
 * A cleanup handler that dismisses at the end of the same synchronous turn therefore sees the latch,
 * even though React has not re-rendered the session yet.
 *
 * ## Mount this at the persistent owner level, not inside the Remix content component
 *
 * `RemixContentComponent` renders nothing unless the modal, thinking UI or location picker is up, so
 * terminal cleanup unmounts it — and unmounting drops this hook's subscription along with it, losing
 * the dismissal and every command that follows. It has to be mounted somewhere that outlives a
 * settled flow, inside `EditorRemixLifecycleOwnerProvider` but above that content component.
 *
 * The practical consequence: the editor UX closures that live in `RemixContentComponentInner`
 * (`onStopThinking`, `handleModalClose`, the preview open/close pair, the experience tracker) are
 * not in scope at that level, so the host reaches them through the plugin's api-keyed callback
 * registry, read at invocation time rather than captured at mount.
 *
 * ## A safety/AUP violation is not a command, and must never become one
 *
 * A safety or AUP violation arrives as a *completed* action while the friendly response is still
 * streaming into the conversation, so the editor handles it locally off the AIFC store signal:
 * dismiss the thinking UI, close any preview, open the side chat. There is deliberately no command
 * for it here. Mapping it onto `RemixErrored` would run error cleanup — which aborts the in-flight
 * request — and cut off the friendly response before the user ever sees it.
 *
 * ## `onAborted` is origin-blind, deliberately
 *
 * `CANCELLED` transitions the machine to `aborted`, so the observer's `end('aborted')` pre-empts
 * every producer `end('cancelled')`. In treatment a local cancel, a Rovo-side abort and a preview
 * dismissal all arrive as the same `RemixAborted`. A caller that needs to tell them apart records
 * its own intent before driving the machine and reads it inside `onAborted`, the way the renderer
 * surface does — this hook cannot infer it from the command.
 */ 



var $lEf8v = parcelRequire("lEf8v");




/** End reasons whose read session must survive teardown until terminal UX dismisses it. */ const $d5e099afc0dbe32a$var$isTerminalFlowEndReason = (reason)=>reason === 'error' || reason === 'aborted';
const $d5e099afc0dbe32a$export$b2a1915e04b347a = ({ onReady: onReady, onErrored: onErrored, onAborted: onAborted, onInserted: onInserted, onCancellationSettled: onCancellationSettled, onHandlerError: onHandlerError })=>{
    const { remixId: sessionRemixId, dismissTerminal: dismissTerminal } = (0, $fjeDY.useEditorRemixLifecycle)();
    const claimedRef = (0, $cozmU.useRef)({
        remixId: undefined,
        claims: new Set(),
        isCleared: false
    });
    (0, $lEf8v.useRemixCommands)((command)=>{
        // Session identity alone, never `isAdmitted`: admission is already cleared by the time the
        // terminal commands arrive.
        if (sessionRemixId === undefined || command.remixId !== sessionRemixId) return;
        // The only reset. Clearing on `RemixFlowEnded` would drop the claims just before the terminal
        // commands arrive — see the module comment on ordering.
        if (claimedRef.current.remixId !== command.remixId) claimedRef.current = {
            remixId: command.remixId,
            claims: new Set(),
            isCleared: false
        };
        // Suppress same-turn commands until the cleared session is rendered.
        if (claimedRef.current.isCleared) return;
        const claimOnce = (claim)=>{
            if (claimedRef.current.claims.has(claim)) return false;
            claimedRef.current.claims.add(claim);
            return true;
        };
        /** Whether a terminal command has already settled this session's cleanup UX. */ const hasSettledTerminalCleanup = ()=>claimedRef.current.claims.has('RemixErrored') || claimedRef.current.claims.has('RemixAborted');
        /**
		 * Isolates the injected effect from the dismissal that follows it: an unwrapped throw in
		 * `onErrored` would skip `dismissTerminal()` and strand the latched session forever.
		 */ const runEffect = (effect)=>{
            try {
                effect();
            } catch (error) {
                try {
                    onHandlerError({
                        commandType: command.type,
                        error: error
                    });
                } catch  {
                // Diagnostics must never affect command handling.
                }
            }
        };
        switch(command.type){
            // Effect-free on this surface, so not claimed either.
            case 'RemixStarted':
            case 'RemixGenerationEnded':
                return;
            case 'RemixReady':
                if (claimOnce('RemixReady')) runEffect(()=>onReady(command));
                return;
            case 'RemixErrored':
                if (claimOnce('RemixErrored')) {
                    runEffect(()=>onErrored(command));
                    dismissTerminal();
                }
                return;
            case 'RemixAborted':
                if (claimOnce('RemixAborted')) {
                    runEffect(()=>onAborted(command));
                    dismissTerminal();
                }
                return;
            case 'RemixFlowEnded':
                if (!claimOnce(`RemixFlowEnded:${command.reason}`)) return;
                // Retained, not cleared: the paired terminal command arrives after this one and still
                // owns the cleanup and the dismissal.
                if ($d5e099afc0dbe32a$var$isTerminalFlowEndReason(command.reason)) return;
                if (command.reason === 'inserted') runEffect(()=>onInserted?.(command));
                claimedRef.current.isCleared = true;
                // A rollback releases ownership before sending `CANCELLED`, so the machine reaches
                // `aborted` unobserved and `RemixAborted` lands before this. Abort ownership wins;
                // running cancellation cleanup on top would settle the same experience twice.
                if (command.reason === 'cancelled' && !hasSettledTerminalCleanup()) // Relies on React batching to retain sessionRemixId for this command turn.
                runEffect(()=>onCancellationSettled?.(command));
                return;
        }
    });
};














const $3ea14f9b5e4b7135$export$287b8183f0ccac41 = (api, isAnyRemixing)=>({ tr: tr })=>{
        if (api?.malleableUi?.sharedState?.currentState()?.isAnyRemixing === isAnyRemixing) return null;
        tr.setMeta((0, $bpOXf.malleableUiPluginKey), {
            isAnyRemixing: isAnyRemixing
        });
        return tr;
    };




const $0887781a4e706550$export$f8dbf6fdfa5ec676 = (lifecycle)=>({ tr: tr })=>{
        tr.setMeta((0, $5ea92dab24394af7$export$38c8fc373d691b1d), {
            lifecycle: {
                kind: 'machine-projection',
                ...lifecycle
            }
        });
        return tr;
    };














const $23d615222ee2c9e3$export$d81f524b6935fe5c = ({ animationFinished: animationFinished, phase: phase })=>{
    switch(phase){
        case 'inactive':
        case 'error':
        case 'aborted':
            return {
                isThinking: false,
                isComplete: false
            };
        case 'thinking':
            return {
                isThinking: true,
                isComplete: false
            };
        case 'ready':
            return animationFinished ? {
                isThinking: false,
                isComplete: true
            } : {
                isThinking: true,
                isComplete: true
            };
        case 'previewing':
            return {
                isThinking: false,
                isComplete: true
            };
        case 'inserting':
            return {
                isThinking: false,
                isComplete: true
            };
        default:
            {
                const exhaustive = phase;
                return exhaustive;
            }
    }
};


const $687d619d27fd7060$export$e1c711fd1a28ed63 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { animationFinished: animationFinished, presentationRemixId: presentationRemixId, dispatchProjection: dispatchProjection } = t0;
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const effectivePhase = terminalPhase ?? phase;
    const lastRef = (0, $cozmU.useRef)(undefined);
    let t1;
    let t2;
    if ($[0] !== animationFinished || $[1] !== dispatchProjection || $[2] !== effectivePhase || $[3] !== presentationRemixId || $[4] !== remixId || $[5] !== terminalPhase) {
        t1 = ()=>{
            const last = lastRef.current;
            if (remixId === undefined) {
                if (last?.remixId === undefined) return;
                const projection = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                    phase: "inactive",
                    animationFinished: false
                });
                dispatchProjection(projection);
                lastRef.current = {
                    remixId: undefined,
                    ...projection
                };
                return;
            }
            const hasLatchedTerminalOutcome = terminalPhase === "error" || terminalPhase === "aborted";
            if (presentationRemixId !== remixId && !hasLatchedTerminalOutcome) return;
            const projection_0 = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                phase: effectivePhase,
                animationFinished: animationFinished
            });
            if (last?.remixId === remixId && last.isThinking === projection_0.isThinking && last.isComplete === projection_0.isComplete) return;
            dispatchProjection(projection_0);
            lastRef.current = {
                remixId: remixId,
                ...projection_0
            };
        };
        t2 = [
            animationFinished,
            dispatchProjection,
            remixId,
            effectivePhase,
            presentationRemixId,
            terminalPhase
        ];
        $[0] = animationFinished;
        $[1] = dispatchProjection;
        $[2] = effectivePhase;
        $[3] = presentationRemixId;
        $[4] = remixId;
        $[5] = terminalPhase;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ animationFinished: animationFinished, presentationRemixId: presentationRemixId, dispatchProjection: dispatchProjection })=>{
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const effectivePhase = terminalPhase ?? phase;
    const lastRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const last = lastRef.current;
        if (remixId === undefined) {
            // Nothing to release: either the initial mount, or the release write already happened.
            if (last?.remixId === undefined) return;
            const projection = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
                phase: 'inactive',
                animationFinished: false
            });
            dispatchProjection(projection);
            lastRef.current = {
                remixId: undefined,
                ...projection
            };
            return;
        }
        // The React lifecycle context and the synchronous registry can briefly be on adjacent
        // sessions during replacement. Never combine A's live phase with B's presentation. A
        // terminal phase is different: it is latched before ownership release, so its inactive
        // projection remains authoritative after the synchronous registry has cleared its identity.
        const hasLatchedTerminalOutcome = terminalPhase === 'error' || terminalPhase === 'aborted';
        if (presentationRemixId !== remixId && !hasLatchedTerminalOutcome) return;
        const projection_0 = (0, $23d615222ee2c9e3$export$d81f524b6935fe5c)({
            phase: effectivePhase,
            animationFinished: animationFinished
        });
        if (last?.remixId === remixId && last.isThinking === projection_0.isThinking && last.isComplete === projection_0.isComplete) return;
        // Recorded after the dispatch returns so a throwing dispatcher stays retryable.
        dispatchProjection(projection_0);
        lastRef.current = {
            remixId: remixId,
            ...projection_0
        };
    }, [
        animationFinished,
        dispatchProjection,
        remixId,
        effectivePhase,
        presentationRemixId,
        terminalPhase
    ]);
};



const $adce69c763bccff9$export$1ab134daab5fcbca = ({ api: api })=>{
    const { remixId: remixId, phase: phase, terminalPhase: terminalPhase } = (0, $fjeDY.useEditorRemixLifecycle)();
    const isAnyRemixing = (0, $gRoSG.useIsAnyRemixing)();
    const [, refreshPresentation] = (0, $cozmU.useReducer)((count)=>count + 1, 0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useLayoutEffect)(()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, refreshPresentation), [
        api,
        remixId
    ]);
    const presentation = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
    const dispatchProjection = (0, $cozmU.useCallback)((projection)=>{
        api?.core.actions.execute((0, $0887781a4e706550$export$f8dbf6fdfa5ec676)(projection));
    }, [
        api
    ]);
    const resetTerminalPresentation = (0, $cozmU.useCallback)((commandRemixId)=>{
        // A stale terminal command must not reset a replacement presentation.
        if (commandRemixId !== remixId) return;
        api?.core.actions.execute((0, $8ac54cfa8c1aac76$export$a9d5e9b88fbfa587));
    }, [
        api,
        remixId
    ]);
    (0, $687d619d27fd7060$export$e1c711fd1a28ed63)({
        animationFinished: presentation.animationFinished,
        presentationRemixId: presentation.remixId ?? null,
        dispatchProjection: dispatchProjection
    });
    // Publish the phase alongside the projection this host already mirrors. Presentation consumers
    // need to tell `inserting` apart from a genuinely ready result, and the projected booleans are
    // identical for both. Written here because this host has the api, the session token, and the
    // lifecycle context in one place.
    const effectivePhase = terminalPhase ?? phase;
    const presentationToken = presentation.token;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (presentation.remixId !== remixId) // Adjacent sessions during replacement: never label B's presentation with A's phase.
        return;
        (0, $dc44c0de1ed07c1a$export$1ae55ee74816df71)(api, presentationToken, effectivePhase);
    }, [
        api,
        effectivePhase,
        presentationToken,
        presentation.remixId,
        remixId
    ]);
    const commandHandlers = (0, $cozmU.useMemo)(()=>({
            onReady: ()=>{
                // Lifecycle completion is projected by the mirror; this starts presentation only.
                (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.markReady();
            },
            onErrored: (command)=>{
                const handles = (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api);
                if (!handles) return;
                handles.settleExperience({
                    kind: 'failed',
                    // Match the legacy fallback when no Rovo store error is available.
                    error: new Error((0, $iCjKh.DEFAULT_REMIX_ERROR_MESSAGE))
                });
                // Stop before closing: stop preserves selection but reopens the modal.
                handles.stopThinking({
                    reopenModal: true
                });
                resetTerminalPresentation(command.remixId);
                handles.closeTerminalPreview();
                handles.closeModal();
                handles.openSidebar();
            },
            onAborted: (command_0)=>{
                const handles_0 = (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api);
                if (!handles_0) return;
                const presentSourceOrTargetInvalidation = (0, $dc44c0de1ed07c1a$export$c2ad78149c7e98ec)(api, command_0.remixId);
                // `RemixAborted` is origin-blind, so it settles with the reason legacy reports for an
                // abort this surface did not initiate, keeping the two cohorts comparable. Legacy
                // conflates the same cases under that wording, so matching it reproduces legacy
                // exactly, and the content component still overrides it with a recorded local intent.
                if (handles_0.settleExperience({
                    kind: 'aborted',
                    reason: (0, $iCjKh.REMIX_REMOTE_ABORT_REASON),
                    remixId: command_0.remixId
                }) === 'ignored') // A different terminal outcome already owns teardown.
                return;
                if (!presentSourceOrTargetInvalidation) {
                    handles_0.stopThinking({
                        reopenModal: false
                    });
                    resetTerminalPresentation(command_0.remixId);
                    return;
                }
                // Source invalidation must preserve the current Rovo Chat sidebar state.
                handles_0.stopThinking({
                    reopenModal: true
                });
                resetTerminalPresentation(command_0.remixId);
                handles_0.closeTerminalPreview();
                handles_0.closeModal();
            },
            onInserted: (command_1)=>{
                // The machine has accepted INSERTED only after the editor acknowledges the write.
                // Reset the matching decoration explicitly: lifecycle projection intentionally leaves
                // presentation untouched, and a stale command must never clear a replacement session.
                resetTerminalPresentation(command_1.remixId);
            },
            onCancellationSettled: (command_2)=>{
                // Cancellation teardown already handled presentation cleanup.
                (0, $dc44c0de1ed07c1a$export$a174cbea3e7863fe)(api)?.settleCancellation(command_2.remixId);
            },
            onHandlerError: ({ commandType: commandType, error: error })=>{
                try {
                    createAnalyticsEvent({
                        eventType: 'operational',
                        action: 'failed',
                        actionSubject: 'editorRemixCommandHandler',
                        actionSubjectId: commandType,
                        source: 'editorRemix',
                        attributes: {
                            operation: 'commandEffect',
                            commandType: commandType,
                            // Do not log service-supplied error messages.
                            errorName: error instanceof Error ? error.name : typeof error
                        }
                    }).fire();
                } catch  {
                // Diagnostics must never affect command handling.
                }
            }
        }), [
        api,
        createAnalyticsEvent,
        resetTerminalPresentation
    ]);
    (0, $d5e099afc0dbe32a$export$b2a1915e04b347a)(commandHandlers);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (api?.malleableUi?.sharedState?.currentState()?.isAnyRemixing === isAnyRemixing) return;
        api?.core.actions.execute((0, $3ea14f9b5e4b7135$export$287b8183f0ccac41)(api, isAnyRemixing));
    }, [
        api,
        isAnyRemixing
    ]);
    return null;
};









var $3nacY = parcelRequire("3nacY");





const $d684c767eb9debf9$export$385bdd630aa6668b = 'ai-paste-menu-remix';























const $471b94445789f952$export$7619bedffcb929ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onClick: onClick } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl) {
        t2 = intl.formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle);
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== onClick || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            testId: "ai-paste-menu__remix",
            elemBefore: t1,
            onClick: onClick
        }, t2);
        $[3] = onClick;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onClick: onClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "ai-paste-menu__remix",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: ""
        }),
        onClick: onClick
    }, intl.formatMessage((0, $93WrI.aiConfigItemMessages).remixTitle));
};


const $48fd160920f56916$export$e79e54e0ad32496e = ({ api: api })=>{
    const rules = api.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
    if (!rules) return [];
    const { allRules: allRules, containsTableRule: containsTableRule, excludedAncestorRule: excludedAncestorRule, hideIfSingleNodeRule: hideIfSingleNodeRule, isSingleLinkRule: isSingleLinkRule, minCharsRule: minCharsRule, notProseRule: notProseRule } = rules;
    const disabled = excludedAncestorRule([
        'codeBlock',
        'heading'
    ]);
    const AI_PASTE_MENU_SECTION_KEY = (0, $3nacY.AI_PASTE_MENU_SECTION).key;
    return [
        {
            type: 'menu-item',
            key: (0, $d684c767eb9debf9$export$385bdd630aa6668b),
            parents: [
                {
                    type: 'menu-section',
                    key: AI_PASTE_MENU_SECTION_KEY,
                    // Rank 6 — shown after Make Longer (rank 5).
                    rank: 6
                }
            ],
            isHidden: allRules(minCharsRule(100), hideIfSingleNodeRule, isSingleLinkRule, disabled, notProseRule, containsTableRule),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $471b94445789f952$export$7619bedffcb929ce), {
                    onClick: ()=>{
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
                        api?.core?.actions.execute((0, $a41417a475703a7a$export$e01f52b7ef73f07b)(api)({
                            metadata: {
                                interactionSource: 'remixModalFromPasteMenu'
                            },
                            source: (0, $a41417a475703a7a$export$f437f2a5f6852f29)
                        }));
                    }
                })
        }
    ];
};




















const $9ca8eb041284f342$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $krYZG.ACTION).CLICKED,
    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $krYZG.EVENT_TYPE).UI,
    source: 'remix'
};
function $9ca8eb041284f342$export$f5e01f6a1e2eeb41({ api: api, options: options }) {
    return ({ node: node, intl: intl })=>{
        if (!api || !node) return undefined;
        if (options?.isRemixHidden) return undefined;
        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') || !(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return undefined;
        // A machine-owned flow is a Remix in progress even though the projection reports
        // `!isThinking` once the early streaming whiteboard lands. Without this the button reads as
        // disabled with no reason and the tooltip helper's default renders the archived copy.
        const isRemixing = api?.malleableUi?.sharedState.currentState()?.isRemixModalOpen || api?.malleableUi?.sharedState.currentState()?.isThinking || (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api).phase === 'inserting';
        const areAiEntryPointsDisabled = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled;
        const disabled = options?.isDisabled || isRemixing || areAiEntryPointsDisabled;
        let tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
        if (isRemixing) tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        else if (options?.remixDisabledReason) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(intl.formatMessage, options?.remixDisabledReason);
        else if ((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text')) tooltipContent = intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
        const onClick = (editorState)=>{
            if (disabled) return false;
            (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
            const $pos = editorState.selection.$from;
            let nodePos;
            for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                nodePos = $pos.before(depth);
                break;
            }
            api.analytics?.actions.fireAnalyticsEvent($9ca8eb041284f342$var$remixFloatingToolbarClickAnalyticsPayload);
            api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                nodePos: nodePos,
                nodeType: node.type.name,
                metadata: {
                    interactionSource: 'remixModalFromFloatingToolbar'
                },
                source: 'floatingToolbar'
            }));
            return true;
        };
        return {
            id: 'editor.malleable-ui.remix',
            type: 'button',
            title: intl.formatMessage((0, $lhZdS.messages).remixToolbarLabel),
            tooltipContent: tooltipContent,
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
            onClick: onClick,
            disabled: disabled,
            testId: 'editor-floating-toolbar__remix-button'
        };
    };
}









var $loej8 = parcelRequire("loej8");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $9d7Pd = parcelRequire("9d7Pd");


var $huzJY = parcelRequire("huzJY");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");





var $4n1IT = parcelRequire("4n1IT");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9z4Bk = parcelRequire("9z4Bk");

const $7829ee1aabc510af$var$MENU_ITEM_HEIGHT = 32;
const $7829ee1aabc510af$var$HEADING_HEIGHT = 32;
const $7829ee1aabc510af$var$MENU_WIDTH = 175;
// ── Preview panel styles ────────────────────────────────────────────────────
const $7829ee1aabc510af$var$PREVIEW_WIDTH = 144;
const $7829ee1aabc510af$var$PREVIEW_HEIGHT = 104;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- internal only
const $7829ee1aabc510af$var$previewContentStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    width: `${$7829ee1aabc510af$var$PREVIEW_WIDTH}px`,
    height: `${$7829ee1aabc510af$var$PREVIEW_HEIGHT}px`,
    boxSizing: 'border-box',
    padding: "var(--ds-space-150, 12px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
function $7829ee1aabc510af$var$TypeSwitcherMenu({ siblingSubTypes: siblingSubTypes, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, groupLabelMessage: groupLabelMessage, onSelect: onSelect, intl: intl, hide: hide }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [hoveredSubType, setHoveredSubType] = (0, $cozmU.useState)(null);
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const handleMouseEnter = (0, $cozmU.useCallback)((value)=>{
        setHoveredSubType(value);
    }, []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setHoveredSubType(null);
    }, []);
    const handleSelect = (0, $cozmU.useCallback)((subType, isSelected)=>{
        if (isSelected) {
            hide();
            return;
        }
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixTypeSwitcherOption',
            attributes: {
                remixType: dynamicUiType,
                remixSubtype: subType
            }
        });
        onSelect({
            subtype: subType
        });
        hide();
    }, [
        dynamicUiType,
        hide,
        onSelect,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "remix-type-switcher-menu-wrapper"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6IL1T.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8FgJC.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huzJY.default), {
        testId: "remix-type-switcher-group-header"
    }, intl.formatMessage(groupLabelMessage)), siblingSubTypes.map((subType)=>{
        const isSelected = subType.value === dynamicUiSubtype;
        const isHovered = hoveredSubType === subType.value;
        const IconComponent = (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
        const showPreview = isHovered && IconComponent !== null;
        const button = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            onMouseEnter: ()=>handleMouseEnter(subType.value),
            onMouseLeave: handleMouseLeave,
            onFocus: ()=>handleMouseEnter(subType.value),
            onBlur: handleMouseLeave
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
            testId: `remix-type-switcher-item-${subType.value}`,
            isSelected: isSelected,
            onClick: ()=>handleSelect(subType.value, isSelected)
        }, intl.formatMessage(subType.labelMessage)));
        return showPreview ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4n1IT.Popup), {
            key: subType.value,
            isOpen: true,
            placement: "right",
            autoFocus: false,
            shouldDisableFocusLock: true,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _ariaExpanded, ...restTriggerProps } = triggerProps;
                return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    ...restTriggerProps,
                    onMouseEnter: ()=>handleMouseEnter(subType.value),
                    onMouseLeave: handleMouseLeave,
                    onFocus: ()=>handleMouseEnter(subType.value),
                    onBlur: handleMouseLeave
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    testId: `remix-type-switcher-item-${subType.value}`,
                    isSelected: isSelected,
                    onClick: ()=>handleSelect(subType.value, isSelected)
                }, intl.formatMessage(subType.labelMessage)));
            },
            content: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: $7829ee1aabc510af$var$previewContentStyles,
                    "data-testid": "remix-type-switcher-preview"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)(IconComponent, {
                    alt: intl.formatMessage(subType.labelMessage)
                }))
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: subType.value
        }, button);
    }))));
}
function $7829ee1aabc510af$export$a9e8c51842dcf4c7({ dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, currentLabel: currentLabel, currentLabelMessage: currentLabelMessage, groupLabelMessage: groupLabelMessage, siblingSubTypes: siblingSubTypes, onSelect: onSelect, intl: intl, disabled: disabled = false }) {
    if (siblingSubTypes.length === 0) return null;
    const height = $7829ee1aabc510af$var$HEADING_HEIGHT + siblingSubTypes.length * $7829ee1aabc510af$var$MENU_ITEM_HEIGHT;
    return {
        id: 'editor.malleable-ui.remix-type-switcher',
        type: 'dropdown',
        title: currentLabelMessage ? intl.formatMessage(currentLabelMessage) : currentLabel,
        options: {
            width: $7829ee1aabc510af$var$MENU_WIDTH,
            height: height,
            render: ({ hide: hide })=>/*#__PURE__*/ (0, $lOiVq.jsx)($7829ee1aabc510af$var$TypeSwitcherMenu, {
                    siblingSubTypes: siblingSubTypes,
                    dynamicUiType: dynamicUiType,
                    dynamicUiSubtype: dynamicUiSubtype,
                    groupLabelMessage: groupLabelMessage,
                    onSelect: onSelect,
                    intl: intl,
                    hide: hide
                })
        },
        showSelected: false,
        disabled: disabled,
        testId: 'editor-floating-toolbar__remix-type-switcher'
    };
}




const $d723c49ce3553147$var$MAUI_REMIX_EXTENSION_KEYS = new Set([
    'native-embed:maui',
    'native-embed:maui-whiteboard'
]);
const $d723c49ce3553147$var$shouldSuppressThinkingHighlight = (extensionKey)=>typeof extensionKey === 'string' && $d723c49ce3553147$var$MAUI_REMIX_EXTENSION_KEYS.has(extensionKey);
function $d723c49ce3553147$export$812e6631895ae78a(node) {
    const localId = node.attrs?.localId;
    return typeof localId === 'string' && localId.length > 0 ? localId : undefined;
}
function $d723c49ce3553147$export$6d88a44c576e4d7a({ node: node, schema: schema, state: state }) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const isMaui = node.attrs.extensionKey === 'native-embed:maui';
    const isWhiteboard = node.attrs.extensionKey === 'native-embed:maui-whiteboard';
    if (isMaui || isWhiteboard) {
        const url = node.attrs.parameters?.macroParams?.url?.value;
        return (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
            state: state,
            url: url
        });
    }
    const isMedia = node.type === media || node.type === mediaSingle;
    if (isMedia) {
        const mediaNode = node.type === media ? node : node.firstChild;
        if (mediaNode) {
            const fieldId = mediaNode.attrs.id;
            if (fieldId) return (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
                state: state,
                fieldId: fieldId
            });
        }
    }
}
function $d723c49ce3553147$export$8997b1d407b19449({ node: node, schema: schema, state: state, intl: intl, disabled: disabled, api: api }) {
    if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) return undefined;
    const historyEntry = $d723c49ce3553147$export$6d88a44c576e4d7a({
        node: node,
        schema: schema,
        state: state
    });
    if (!historyEntry) return undefined;
    const switcherInfo = (0, $loej8.getRemixSwitcherInfo)(historyEntry.dynamicUiType, historyEntry.dynamicUiSubtype);
    if (!switcherInfo) return undefined;
    const dropdown = (0, $7829ee1aabc510af$export$a9e8c51842dcf4c7)({
        dynamicUiType: historyEntry.dynamicUiType,
        dynamicUiSubtype: historyEntry.dynamicUiSubtype,
        currentLabel: switcherInfo.currentLabel,
        currentLabelMessage: switcherInfo.currentLabelMessage,
        groupLabelMessage: switcherInfo.groupLabelMessage,
        siblingSubTypes: switcherInfo.siblingSubTypes,
        intl: intl,
        disabled: disabled,
        onSelect: ({ subtype: subtype })=>{
            const targetId = $d723c49ce3553147$export$812e6631895ae78a(node);
            const inFlightId = historyEntry.fieldId ?? (0, $dOW9b.getMauiIdFromUrl)(historyEntry.url);
            const suppressThinkingHighlight = $d723c49ce3553147$var$shouldSuppressThinkingHighlight(node.attrs.extensionKey);
            if (targetId) {
                api?.aiExperience?.actions?.stageInlineRovoStreaming?.(targetId);
                api?.aiExperience?.actions?.commitInlineRovoStreaming?.();
            }
            // Mark in-flight so the rovo-bridge update processors skip their
            // BE-pushed insert; `useUpdateRemix`/`useOnComplete` replaces the node
            // instead. id is `fieldId` (image, matches `mediaNode.attrs.id`) or the
            // MAUI app id from the stack-entry URL (matches `data.previousMauiId`).
            if (inFlightId && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) api?.core?.actions.execute(api?.malleableUi?.commands.trackVariantUpdateStart({
                id: inFlightId
            }));
            (0, $3ed7f22374c9e3fb$export$fdf82e9851b59bf0)({
                api: api,
                options: {
                    isUpdate: true,
                    historyEntryForUpdate: historyEntry,
                    dynamicUiSubtypeForUpdate: subtype,
                    suppressThinkingHighlight: suppressThinkingHighlight
                }
            });
        }
    });
    return dropdown ?? undefined;
}
function $d723c49ce3553147$export$fb69ba203a08f43d({ api: api }) {
    return ({ schema: schema, state: state, node: node, intl: intl })=>{
        if (!node) return;
        const disabled = Boolean(api?.malleableUi?.sharedState.currentState()?.isRemixModalOpen || api?.malleableUi?.sharedState.currentState()?.isThinking || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
        return $d723c49ce3553147$export$8997b1d407b19449({
            node: node,
            schema: schema,
            state: state,
            intl: intl,
            disabled: disabled,
            api: api
        });
    };
}





















var $etoPX = parcelRequire("etoPX");














var $cOvkw = parcelRequire("cOvkw");













const $f2f7ec9e8a84769b$var$RemoveBackgroundIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            size: "xxsmall"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall"
    });
/**
 * A config with no items is how a plugin hides its toolbar, e.g. the annotation plugin while an
 * inline comment is being drafted, or the table plugin while resizing. Adding Remix or Ask Rovo
 * to it would render a lone button under the selected node, so these configs are left empty.
 */ const $f2f7ec9e8a84769b$var$hasNoToolbarItems = (config)=>Array.isArray(config.items) && config.items.length === 0;
const $f2f7ec9e8a84769b$var$isSkipEmptyToolbarsEnabled = ()=>{
    try {
        return (0, $2pQiO.UNSAFE_expValNoExposure)('cc_maui_comments_on_charts_exp', 'isEnabled', false);
    } catch  {
        return false;
    }
};
function $f2f7ec9e8a84769b$export$4acd7d829930a56d(schema) {
    return new Set((0, $1qYXT.REMIX_DENY_LIST_V1).map((name)=>schema.nodes[name]).filter(Boolean));
}
function $f2f7ec9e8a84769b$export$81aefa0141c75da9(schema) {
    return new Set((0, $444f275c146ea05d$export$d3f1ba79de0d4efe).map((name)=>schema.nodes[name]).filter(Boolean));
}
const $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo = (node)=>{
    if (node.type.name === 'media') return node;
    if (node.type.name === 'mediaSingle') return node.firstChild ?? undefined;
    return undefined;
};
const $f2f7ec9e8a84769b$var$isImageMediaNodeForAskRovo = (node)=>{
    const mediaNode = $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo(node);
    if (!mediaNode || mediaNode.type.name !== 'media') return false;
    if (mediaNode.attrs?.type === 'external') return true;
    const fileMimeType = mediaNode.attrs?.__fileMimeType;
    return typeof fileMimeType === 'string' && fileMimeType.includes('image/');
};
const $f2f7ec9e8a84769b$var$getMediaFileId = (node)=>{
    const mediaFileId = $f2f7ec9e8a84769b$var$getMediaNodeForAskRovo(node)?.attrs?.id;
    return typeof mediaFileId === 'string' && mediaFileId.length > 0 ? mediaFileId : undefined;
};
const $f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $krYZG.ACTION).CLICKED,
    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $krYZG.EVENT_TYPE).UI,
    source: 'remix'
};
const $f2f7ec9e8a84769b$var$getRemixToolbarNodePos = (selection, node)=>{
    // An expand selected as a node is not one of $from's ancestors. Its own position must be
    // used when opening Remix or the editor can open a modal with no selection context.
    if ((0, $1qYXT.REMIX_EXPAND_NODE_TYPES).includes(node.type.name) && selection instanceof (0, $kCECX.NodeSelection) && selection.node === node) return selection.from;
    const { $from: $from } = selection;
    for(let depth = $from.depth; depth > 0; depth--){
        if ($from.node(depth) === node) return $from.before(depth);
    }
    return undefined;
};
function $f2f7ec9e8a84769b$export$5b679e92b69e94fb(api, options) {
    if (!api?.toolbar) return ()=>undefined;
    return (state, intl, _providerFactory, activeConfigs)=>{
        if (!activeConfigs?.length) return;
        const unallowedNodes = $f2f7ec9e8a84769b$export$4acd7d829930a56d(state.schema);
        const malleableUiState = (0, $bpOXf.malleableUiPluginKey).getState(state);
        const remixThinkingState = (0, $5ea92dab24394af7$export$38c8fc373d691b1d).getState(state);
        const isRemixing = malleableUiState?.isRemixModalOpen || false || remixThinkingState?.isThinking || false;
        const areAiEntryPointsDisabled = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false;
        const shouldSkipEmptyToolbars = $f2f7ec9e8a84769b$var$isSkipEmptyToolbarsEnabled();
        activeConfigs.forEach((config)=>{
            // Every change in this pass serves Remix creation (the Remix button and hiding
            // toolbars while a Remix runs).
            if (options?.isRemixEditOnly) return;
            const configNodeTypes = [].concat(config.nodeType);
            const isTableConfig = !Array.isArray(config.nodeType) && config.nodeType.name === 'table';
            // When an element is being remixed (modal open or thinking bar showing), hide its
            // element/floating toolbar entirely by emptying its items so the floating toolbar plugin
            // won't show it.
            //
            // Behind `cc-maui-phase-3` this applies to every element type. Previously the toolbar
            // was only hidden for tables, which left the element toolbar visible for other nodes
            // (e.g. panels and column layouts) while the thinking bar was showing. We skip the
            // inline-suggestion toolbar so the in-editor remix loading bar itself is not affected.
            // When the gate is off we retain the legacy table-only behaviour below.
            //
            // `shouldHideToolbarWhileRemixing` is an explicit opt-in from the product (only
            // Confluence sets this to true). This replaces the previous `config.className !==
            // undefined` heuristic, which accidentally affected products (e.g. Jira) that don't
            // set a className on their element toolbar configs.
            if (isRemixing && options?.shouldHideToolbarWhileRemixing && config.className !== (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS && (0, $iDrrr.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            // Legacy behaviour (gate off): hide only the table element toolbar while remixing.
            if (isTableConfig && isRemixing && !(0, $iDrrr.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            // Check if every config node type is denied or inline. If the config also
            // includes multiBodiedExtension we defer the final decision to the items
            // callback where we can inspect the actual node's extensionKey (so that
            // allowed MBE variants like native tabs still get the Remix button).
            const hasMBENodeType = configNodeTypes.some((nt)=>nt.name === 'multiBodiedExtension');
            // Expands are deny-listed by default and only remixable under REMIX_EXPANDS_EXPERIMENT.
            // Keep their configs alive here (like MBE below) so the items callback can make the
            // gated decision against the real node — the experiment must not be read for every
            // element toolbar evaluation.
            const hasExpandNodeType = configNodeTypes.some((nt)=>(0, $1qYXT.REMIX_EXPAND_NODE_TYPES).includes(nt.name));
            const allDeniedOrInline = configNodeTypes.every((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline);
            if (config.className !== undefined && config.className === (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS || isTableConfig && config.items.length === 0 || shouldSkipEmptyToolbars && $f2f7ec9e8a84769b$var$hasNoToolbarItems(config) || configNodeTypes.some((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline) && !hasMBENodeType && !hasExpandNodeType) return;
            // When all node types are denied/inline and the only reason we didn't
            // skip is because the config includes MBE or an expand, we need to gate the Remix
            // button on the actual node: an allowed MBE variant, or an expand with the
            // experiment enabled.
            const requiresNodeCheck = allDeniedOrInline && (hasMBENodeType || hasExpandNodeType);
            const toolbarItems = config.items;
            if (Array.isArray(toolbarItems)) {
                const remixButton = {
                    id: 'editor.malleable-ui.remix',
                    type: 'button',
                    title: intl.formatMessage((0, $lhZdS.messages).remixToolbarLabel),
                    tooltipContent: isRemixing ? intl.formatMessage((0, $lhZdS.messages).remixInProgressTooltip) : intl.formatMessage((0, $lhZdS.messages).remixToolbarTooltip),
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
                    onClick: ()=>false,
                    disabled: isRemixing || areAiEntryPointsDisabled,
                    testId: (0, $444f275c146ea05d$export$dad9e20bd9ca4fef)
                };
                const remixToolbarItems = [
                    remixButton,
                    {
                        type: 'separator',
                        fullHeight: true
                    }
                ];
                config.items = (node)=>{
                    // When the config was only kept because it contains MBE or an expand, check
                    // whether the actual selected node is remixable — an allowed MBE variant
                    // (e.g. native tabs), or a non-empty expand with the experiment on. If not,
                    // return the original items without the Remix button.
                    if (requiresNodeCheck && !(0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                        node: node
                    })) return toolbarItems;
                    const isRemixButtonDisabled = isRemixing || areAiEntryPointsDisabled || (0, $444f275c146ea05d$export$ebd59c3751cfcc95)(node);
                    remixButton.onClick = (editorState)=>{
                        if (isRemixing) return false;
                        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
                        const nodePos = $f2f7ec9e8a84769b$var$getRemixToolbarNodePos(editorState.selection, node);
                        api.analytics?.actions.fireAnalyticsEvent($f2f7ec9e8a84769b$var$remixFloatingToolbarClickAnalyticsPayload);
                        api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                            nodePos: nodePos,
                            nodeType: node.type.name,
                            metadata: {
                                interactionSource: 'remixModalFromFloatingToolbar'
                            },
                            source: 'floatingToolbar'
                        }));
                        return true;
                    };
                    remixButton.disabled = isRemixButtonDisabled;
                    return [
                        ...remixToolbarItems,
                        ...toolbarItems
                    ];
                };
            }
        });
        const mediaNodesForAskRovo = $f2f7ec9e8a84769b$export$81aefa0141c75da9(state.schema);
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const showAskRovoForMedia = (0, $iDrrr.fg)('cc-maui-phase-2') || isViewMode && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
        if (!mediaNodesForAskRovo.size || !showAskRovoForMedia && isViewMode) return;
        const askRovoButton = showAskRovoForMedia ? api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
            intl: intl,
            disabled: api?.malleableUi?.actions?.shouldDisableRemix?.() && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar'),
            target: isViewMode ? 'default' : 'image'
        }) : undefined;
        const shouldShowAskRovoForMediaNode = (node)=>mediaNodesForAskRovo.has(node.type) && !node.type.isInline && $f2f7ec9e8a84769b$var$isImageMediaNodeForAskRovo(node);
        const buildTypeSwitcherItemsForMediaNode = (node)=>{
            if (options?.isRemixEditOnly) return undefined;
            return (0, $d723c49ce3553147$export$8997b1d407b19449)({
                node: node,
                schema: state.schema,
                state: state,
                intl: intl,
                disabled: Boolean(isRemixing || areAiEntryPointsDisabled),
                api: api
            });
        };
        // Build a per-node wrapped Ask Rovo button whose onClick stages the
        // selected media's target id (localId, falling back to file id) as the
        // inline-Rovo streaming target.
        const buildAskRovoItemsForMediaNode = (node)=>{
            if (!askRovoButton) return [];
            const wrappedAskRovoButton = {
                ...askRovoButton,
                ...isViewMode ? {
                    supportsViewMode: true
                } : {},
                onClick: (innerState, dispatch, view)=>{
                    if ((0, $iDrrr.fg)('cc-maui-phase-2')) {
                        const targetId = (0, $d723c49ce3553147$export$812e6631895ae78a)(node);
                        if (targetId) api?.aiExperience?.actions?.stageInlineRovoStreaming?.(targetId);
                    }
                    return askRovoButton.onClick ? askRovoButton.onClick(innerState, dispatch, view) : false;
                }
            };
            return [
                wrappedAskRovoButton,
                {
                    type: 'separator',
                    fullHeight: true,
                    ...isViewMode ? {
                        supportsViewMode: true
                    } : {}
                }
            ];
        };
        const buildRemoveBackgroundItemsForMediaNode = (node)=>{
            const mediaFileId = $f2f7ec9e8a84769b$var$getMediaFileId(node);
            if (isViewMode || !mediaFileId || isRemixing || areAiEntryPointsDisabled) return [];
            if (!(0, $cha5E.expVal)('cc_image_remove_background', 'isEnabled', false)) return [];
            const label = intl.formatMessage((0, $lhZdS.messages).removeBackgroundToolbarLabel);
            return [
                {
                    id: 'editor.malleable-ui.remove-background',
                    type: 'button',
                    title: label,
                    tooltipContent: label,
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: $f2f7ec9e8a84769b$var$RemoveBackgroundIcon,
                    disabled: false,
                    testId: (0, $444f275c146ea05d$export$287305cbde0809e),
                    onClick: ()=>false
                },
                {
                    type: 'separator',
                    fullHeight: true
                }
            ];
        };
        activeConfigs.forEach((config)=>{
            const nodeTypes = [].concat(config.nodeType);
            const isMediaConfig = nodeTypes.some((nodeType)=>mediaNodesForAskRovo.has(nodeType) && !nodeType.isInline);
            if (!isMediaConfig || shouldSkipEmptyToolbars && $f2f7ec9e8a84769b$var$hasNoToolbarItems(config)) return;
            const items = config.items;
            if (Array.isArray(items)) config.items = (node)=>{
                if (!shouldShowAskRovoForMediaNode(node)) return items;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...buildRemoveBackgroundItemsForMediaNode(node),
                    ...items
                ];
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
            else if (typeof items === 'function') config.items = (node)=>{
                const baseItems = items(node);
                if (!shouldShowAskRovoForMediaNode(node)) return baseItems;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...buildRemoveBackgroundItemsForMediaNode(node),
                    ...baseItems
                ];
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
        });
    };
}









var $hVLmg = parcelRequire("hVLmg");























var $erHVE = parcelRequire("erHVE");


var $6t3CY = parcelRequire("6t3CY");


var $lslMH = parcelRequire("lslMH");


















































var $bwoSE = parcelRequire("bwoSE");





const $cef4adf520426c79$var$sameFragment = (left, right)=>JSON.stringify(left) === JSON.stringify(right);
const $cef4adf520426c79$var$hasSupportedText = (selection)=>{
    const { from: from, to: to } = selection;
    let found = false;
    selection.$from.doc.nodesBetween(from, to, (node, pos)=>{
        if (found || (0, $1qYXT.isRemixRestrictedNodeType)(node.type.name)) return false;
        if (node.isText) {
            const selectedText = (node.text ?? '').slice(Math.max(0, from - pos), to - pos);
            found = selectedText.replace(/\u200B/g, '').trim().length > 0;
        }
    });
    return found;
};
const $cef4adf520426c79$export$71565c9b60c1e9e5 = (selection, selectionContext, isSelectionRemixable, normalizeSelection)=>{
    try {
        if (!(selection instanceof (0, $kCECX.TextSelection)) || selection.empty) return false;
        const normalizedSelection = normalizeSelection ? (0, $fd2d11a909978b4f$export$c6b79f111952071b)(selection) : selection;
        if (!(normalizedSelection instanceof (0, $kCECX.TextSelection)) || normalizedSelection.empty) return false;
        if ($cef4adf520426c79$var$hasSupportedText(normalizedSelection)) return false;
        const currentFragment = (0, $2ROjz.getFragmentsFromSelection)(normalizedSelection);
        if (currentFragment === null) // The selected content could not be derived from the current editor state.
        return false;
        if (currentFragment.some((0, $bwoSE.containsNativeEmbed))) // Native embed content is not represented by this raw selected fragment.
        return false;
        if (normalizedSelection === selection && selectionContext != null) {
            if (!Array.isArray(selectionContext.selectionFragment) || !$cef4adf520426c79$var$sameFragment(currentFragment, selectionContext.selectionFragment) || selectionContext.startIndex !== normalizedSelection.$from.parentOffset || selectionContext.endIndex !== normalizedSelection.$to.parentOffset) // The request may use this cached context, so a mismatch cannot be classified safely.
            return false;
        }
        return !isSelectionRemixable(currentFragment);
    } catch  {
        // A failed selection check leaves eligibility unknown, so keep the entry point available.
        return false;
    }
};


const $9e05995f9b4f7e6e$var$UNREMIXABLE_SELECTION_EXPERIMENT = 'platform_editor_disable_unremixable_selection';
const $9e05995f9b4f7e6e$export$1395968d45c4b2bc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { api: api, isSelectionRemixable: isSelectionRemixable, isSurfaceAvailable: isSurfaceAvailable } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "selection",
            "aiExperience",
            "editorViewMode"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { selection: selection, selectionContext: selectionContext, isViewMode: isViewMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $9e05995f9b4f7e6e$var$_temp);
    const normalizeSelection = !isViewMode && (0, $2pQiO.UNSAFE_expValNoExposure)("cc-ce-mau-remix-editor-selection-boundaries", "isEnabled", false);
    const isUnremixable = isSurfaceAvailable && isSelectionRemixable !== undefined && (0, $cef4adf520426c79$export$71565c9b60c1e9e5)(selection, selectionContext, isSelectionRemixable, normalizeSelection);
    if (!isUnremixable) return false;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $cha5E.expVal)($9e05995f9b4f7e6e$var$UNREMIXABLE_SELECTION_EXPERIMENT, "isEnabled", false);
        $[1] = t2;
    } else t2 = $[1];
    return t2 === true;
} : ({ api: api, isSelectionRemixable: isSelectionRemixable, isSurfaceAvailable: isSurfaceAvailable })=>{
    const { selection: selection, selectionContext: selectionContext, isViewMode: isViewMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection',
        'aiExperience',
        'editorViewMode'
    ], (states)=>({
            selection: states.selectionState?.selection,
            selectionContext: states.aiExperienceState?.selectionContext,
            isViewMode: states.editorViewModeState?.mode === 'view'
        }));
    const normalizeSelection = !isViewMode && (0, $2pQiO.UNSAFE_expValNoExposure)('cc-ce-mau-remix-editor-selection-boundaries', 'isEnabled', false);
    const isUnremixable = (0, $cozmU.useMemo)(()=>isSurfaceAvailable && isSelectionRemixable !== undefined && (0, $cef4adf520426c79$export$71565c9b60c1e9e5)(selection, selectionContext, isSelectionRemixable, normalizeSelection), [
        isSurfaceAvailable,
        isSelectionRemixable,
        selection,
        selectionContext,
        normalizeSelection
    ]);
    if (!isUnremixable) return false;
    return (0, $cha5E.expVal)($9e05995f9b4f7e6e$var$UNREMIXABLE_SELECTION_EXPERIMENT, 'isEnabled', false) === true;
};
function $9e05995f9b4f7e6e$var$_temp(states) {
    return {
        selection: states.selectionState?.selection,
        selectionContext: states.aiExperienceState?.selectionContext,
        isViewMode: states.editorViewModeState?.mode === "view"
    };
}








const $b38b8034b2cc03ff$var$testId = 'editor-toolbar__remix-button';
const $b38b8034b2cc03ff$export$53a35bc3b2402206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, isSelectionRemixable: isSelectionRemixable, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi",
            "aiExperience"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { isLegacyRemixing: isLegacyRemixing, isAnyRemixing: isAnyRemixing, isUpdate: isUpdate, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $b38b8034b2cc03ff$var$_temp);
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    let t2;
    if ($[1] !== api || $[2] !== refreshMachinePresentation) {
        t2 = ()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation($b38b8034b2cc03ff$var$_temp2));
        $[1] = api;
        $[2] = refreshMachinePresentation;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== api) {
        t3 = [
            api
        ];
        $[4] = api;
        $[5] = t3;
    } else t3 = $[5];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    if ($[6] !== api) {
        t4 = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
        $[6] = api;
        $[7] = t4;
    } else t4 = $[7];
    const machinePresentation = t4;
    const isOwnRemixing = isLegacyRemixing || machinePresentation.phase === "inserting";
    const isRemixing = isOwnRemixing || isAnyRemixing;
    const isMachineOwnedEditInProgress = machinePresentation.authority === "active" && isUpdate && isOwnRemixing;
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled || aiEditInProgress;
    let t5;
    if ($[8] !== isRemixHidden) {
        t5 = !isRemixHidden && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true);
        $[8] = isRemixHidden;
        $[9] = t5;
    } else t5 = $[9];
    const isRemixEnabled = t5;
    const t6 = isRemixEnabled && !effectiveDisabled && !isRemixing;
    let t7;
    if ($[10] !== api || $[11] !== isSelectionRemixable || $[12] !== t6) {
        t7 = {
            api: api,
            isSelectionRemixable: isSelectionRemixable,
            isSurfaceAvailable: t6
        };
        $[10] = api;
        $[11] = isSelectionRemixable;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const isSelectionUnremixable = (0, $9e05995f9b4f7e6e$export$1395968d45c4b2bc)(t7);
    let t8;
    if ($[14] !== api?.core || $[15] !== api?.malleableUi.commands || $[16] !== experienceTracker) {
        t8 = ()=>{
            const openModal = api?.malleableUi.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar"
                },
                source: "selectionToolbar"
            });
            if (!openModal) return;
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "selectionToolbar",
                    product: "confluence",
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "selectionToolbar",
                    product: "confluence"
                }
            });
            api?.core.actions.execute((t9)=>{
                const { tr: tr } = t9;
                openModal({
                    tr: tr
                });
                tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                    shouldShowToolbar: false
                });
                return tr;
            });
        };
        $[14] = api?.core;
        $[15] = api?.malleableUi.commands;
        $[16] = experienceTracker;
        $[17] = t8;
    } else t8 = $[17];
    const openRemix = t8;
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== effectiveDisabled || $[20] !== isRemixing || $[21] !== openRemix) {
        t9 = ()=>{
            if (effectiveDisabled || isRemixing) return;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "remixModalFromToolbar",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "remix",
                    attributes: {
                        entryPoint: "editor"
                    }
                }
            }).fire();
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            openRemix();
        };
        $[18] = createAnalyticsEvent;
        $[19] = effectiveDisabled;
        $[20] = isRemixing;
        $[21] = openRemix;
        $[22] = t9;
    } else t9 = $[22];
    const handleClick = t9;
    if (!isRemixEnabled || isSelectionUnremixable) return null;
    let tooltipContent;
    if ($[23] !== aiEditInProgress || $[24] !== effectiveDisabled || $[25] !== formatMessage || $[26] !== isMachineOwnedEditInProgress || $[27] !== isRemixing || $[28] !== remixDisabledReason) {
        if (isMachineOwnedEditInProgress || aiEditInProgress) tooltipContent = formatMessage((0, $lhZdS.messages).editInProgressTooltip);
        else if (isRemixing) tooltipContent = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        else {
            if (effectiveDisabled) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
            else if ((0, $iDrrr.fg)("cc_maui_updated_remix_tooltip_text")) tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
            else tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
        }
        $[23] = aiEditInProgress;
        $[24] = effectiveDisabled;
        $[25] = formatMessage;
        $[26] = isMachineOwnedEditInProgress;
        $[27] = isRemixing;
        $[28] = remixDisabledReason;
        $[29] = tooltipContent;
    } else tooltipContent = $[29];
    let t10;
    if ($[30] !== effectiveDisabled || $[31] !== formatMessage || $[32] !== handleClick || $[33] !== isRemixing || $[34] !== tooltipContent) {
        const renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                    label: "",
                    size: "small"
                }),
                testId: $b38b8034b2cc03ff$var$testId,
                onClick: handleClick,
                isDisabled: effectiveDisabled || isRemixing
            }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
        t10 = renderButton();
        $[30] = effectiveDisabled;
        $[31] = formatMessage;
        $[32] = handleClick;
        $[33] = isRemixing;
        $[34] = tooltipContent;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
} : ({ api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, isSelectionRemixable: isSelectionRemixable, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isLegacyRemixing: isLegacyRemixing, isAnyRemixing: isAnyRemixing, isUpdate: isUpdate, aiEditInProgress: aiEditInProgress, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isLegacyRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking || false,
            // Only the editor treatment projects this, from the shared Remix registry.
            isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
            isUpdate: states.malleableUiState?.isUpdate ?? false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
            aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
        }));
    // Ownership lives in a synchronous registry rather than plugin state, so subscribe to keep the
    // button's disabled state and tooltip in step with the flow starting and ending.
    const [, refreshMachinePresentation] = (0, $cozmU.useState)(0);
    (0, $cozmU.useLayoutEffect)(()=>(0, $dc44c0de1ed07c1a$export$ca9605d624b3c2db)(api, ()=>refreshMachinePresentation((value)=>value + 1)), [
        api
    ]);
    // A machine-owned flow is a Remix in progress even though the projection reports `!isThinking`
    // once the early streaming whiteboard lands. Without this the button reads as disabled with no
    // reason, and the tooltip helper's default renders the archived copy on an ordinary page.
    // Only `inserting` extends "in progress". Ownership stays active after the flow completes, so
    // keying off it would leave this button disabled for the rest of the editor session.
    const machinePresentation = (0, $dc44c0de1ed07c1a$export$58aeb614b6d856f7)(api);
    const isOwnRemixing = isLegacyRemixing || machinePresentation.phase === 'inserting';
    // A Remix from another surface (e.g. the Object Sidebar, including one still generating in
    // Rovo Chat after its handoff) is also in progress, and the machine would refuse a new start.
    const isRemixing = isOwnRemixing || isAnyRemixing;
    // Active lifecycle authority is the treatment-owned gate, so the toolbar need not re-evaluate
    // the editor experiment while preserving legacy and Batch 5 classification paths.
    const isMachineOwnedEditInProgress = machinePresentation.authority === 'active' && isUpdate && isOwnRemixing;
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled || aiEditInProgress;
    const isRemixEnabled = !isRemixHidden && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    const isSelectionUnremixable = (0, $9e05995f9b4f7e6e$export$1395968d45c4b2bc)({
        api: api,
        isSelectionRemixable: isSelectionRemixable,
        isSurfaceAvailable: isRemixEnabled && !effectiveDisabled && !isRemixing
    });
    const openRemix = (0, $cozmU.useCallback)(()=>{
        const openModal = api?.malleableUi.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar'
            },
            source: 'selectionToolbar'
        });
        if (!openModal) return;
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence'
            }
        });
        api?.core.actions.execute(({ tr: tr })=>{
            openModal({
                tr: tr
            });
            tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                shouldShowToolbar: false
            });
            return tr;
        });
    }, [
        api,
        experienceTracker
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'remixModalFromToolbar',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                attributes: {
                    entryPoint: 'editor'
                }
            }
        }).fire();
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        openRemix();
    }, [
        createAnalyticsEvent,
        effectiveDisabled,
        isRemixing,
        openRemix
    ]);
    if (!isRemixEnabled || isSelectionUnremixable) return null;
    let tooltipContent;
    if (isMachineOwnedEditInProgress || aiEditInProgress) tooltipContent = formatMessage((0, $lhZdS.messages).editInProgressTooltip);
    else if (isRemixing) tooltipContent = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
    else if (effectiveDisabled) tooltipContent = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
    else if ((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text')) tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltipUpdated);
    else tooltipContent = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
    const renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            testId: $b38b8034b2cc03ff$var$testId,
            onClick: handleClick,
            isDisabled: effectiveDisabled || isRemixing
        }, formatMessage((0, $lhZdS.messages).remixToolbarLabel)));
    return renderButton();
};
function $b38b8034b2cc03ff$var$_temp(states) {
    return {
        isLegacyRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking || false,
        isAnyRemixing: states.malleableUiState?.isAnyRemixing ?? false,
        isUpdate: states.malleableUiState?.isUpdate ?? false,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false,
        aiEditInProgress: (0, $d1c28dddb88abfdb$export$44c2dcb159008a4b)(states.aiExperienceState)
    };
}
function $b38b8034b2cc03ff$var$_temp2(value) {
    return value + 1;
}











































const $6928b89135447805$export$6764c57cc6522e0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RemixCommentPrimaryMenuItem(t0) {
    const $ = (0, $bDgLe.c)(30);
    const { api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason, isSelectionRemixable: isSelectionRemixable } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi",
            "aiExperience"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $6928b89135447805$var$_temp);
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const t2 = !effectiveDisabled && !isRemixing;
    let t3;
    if ($[1] !== api || $[2] !== isSelectionRemixable || $[3] !== t2) {
        t3 = {
            api: api,
            isSelectionRemixable: isSelectionRemixable,
            isSurfaceAvailable: t2
        };
        $[1] = api;
        $[2] = isSelectionRemixable;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const isSelectionUnremixable = (0, $9e05995f9b4f7e6e$export$1395968d45c4b2bc)(t3);
    let t4;
    if ($[5] !== api?.analytics?.actions || $[6] !== api?.core || $[7] !== api?.malleableUi?.commands || $[8] !== effectiveDisabled || $[9] !== experienceTracker || $[10] !== isRemixing) {
        t4 = ()=>{
            if (effectiveDisabled || isRemixing) return;
            (0, $cha5E.expVal)("cc-ce-maui-remix-menu-multivariant-aa", "variant", "control");
            api?.analytics?.actions.fireAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "remix",
                eventType: "ui",
                attributes: {
                    remixSource: "commentPrimaryToolbar"
                }
            });
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "commentPrimaryToolbar",
                    ...featureArea !== undefined && {
                        featureArea: featureArea
                    }
                }
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "commentPrimaryToolbar"
                }
            });
            api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar"
                },
                source: "commentPrimaryToolbar"
            }));
        };
        $[5] = api?.analytics?.actions;
        $[6] = api?.core;
        $[7] = api?.malleableUi?.commands;
        $[8] = effectiveDisabled;
        $[9] = experienceTracker;
        $[10] = isRemixing;
        $[11] = t4;
    } else t4 = $[11];
    const handleClick = t4;
    let t5;
    if ($[12] !== formatMessage) {
        t5 = formatMessage((0, $lhZdS.messages).remixToolbarLabel);
        $[12] = formatMessage;
        $[13] = t5;
    } else t5 = $[13];
    const label = t5;
    let t6;
    bb0: {
        if (isRemixing) {
            let t7;
            if ($[14] !== formatMessage) {
                t7 = formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
                $[14] = formatMessage;
                $[15] = t7;
            } else t7 = $[15];
            t6 = t7;
            break bb0;
        }
        if (effectiveDisabled) {
            let t7;
            if ($[16] !== formatMessage || $[17] !== remixDisabledReason) {
                t7 = (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
                $[16] = formatMessage;
                $[17] = remixDisabledReason;
                $[18] = t7;
            } else t7 = $[18];
            t6 = t7;
            break bb0;
        }
        let t7;
        if ($[19] !== formatMessage) {
            t7 = formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
            $[19] = formatMessage;
            $[20] = t7;
        } else t7 = $[20];
        t6 = t7;
    }
    const tooltipContent = t6;
    if (isSelectionUnremixable) return null;
    let t7;
    if ($[21] !== label) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: label
        });
        $[21] = label;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null);
        $[23] = t8;
    } else t8 = $[23];
    const t9 = effectiveDisabled || isRemixing;
    let t10;
    if ($[24] !== handleClick || $[25] !== label || $[26] !== t7 || $[27] !== t9 || $[28] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            elemBefore: t7,
            elemAfter: t8,
            testId: "dropdown-item__malleable-ui-remix-comment",
            isDisabled: t9,
            title: tooltipContent,
            onClick: handleClick
        }, label);
        $[24] = handleClick;
        $[25] = label;
        $[26] = t7;
        $[27] = t9;
        $[28] = tooltipContent;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
} : function RemixCommentPrimaryMenuItem({ api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason, isSelectionRemixable: isSelectionRemixable }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const isSelectionUnremixable = (0, $9e05995f9b4f7e6e$export$1395968d45c4b2bc)({
        api: api,
        isSelectionRemixable: isSelectionRemixable,
        isSurfaceAvailable: !effectiveDisabled && !isRemixing
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remix',
            eventType: 'ui',
            attributes: {
                remixSource: 'commentPrimaryToolbar'
            }
        });
        const featureArea = (0, $iBsvI.getRemixFeatureArea)({});
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'commentPrimaryToolbar',
                ...featureArea !== undefined && {
                    featureArea: featureArea
                }
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'commentPrimaryToolbar'
            }
        });
        api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar'
            },
            source: 'commentPrimaryToolbar'
        }));
    }, [
        api,
        effectiveDisabled,
        isRemixing,
        experienceTracker
    ]);
    const label = formatMessage((0, $lhZdS.messages).remixToolbarLabel);
    const tooltipContent = (0, $cozmU.useMemo)(()=>{
        if (isRemixing) return formatMessage((0, $lhZdS.messages).remixInProgressTooltip);
        if (effectiveDisabled) return (0, $185ff2366808da00$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
        return formatMessage((0, $lhZdS.messages).remixToolbarTooltip);
    }, [
        isRemixing,
        effectiveDisabled,
        formatMessage,
        remixDisabledReason
    ]);
    if (isSelectionUnremixable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null),
        testId: "dropdown-item__malleable-ui-remix-comment",
        isDisabled: effectiveDisabled || isRemixing,
        title: tooltipContent,
        onClick: handleClick
    }, label);
};
function $6928b89135447805$var$_temp(states) {
    return {
        isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
    };
}


const $5219552937bbf3f0$var$MAUI_REMIX_GROUP = {
    type: 'group',
    key: 'malleable-ui-remix-group'
};
const $5219552937bbf3f0$var$MAUI_REMIX_BUTTON = {
    type: 'button',
    key: 'malleable-ui-remix-button'
};
const $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM = {
    type: 'menu-item',
    key: 'malleable-ui-remix-comment-menu-item'
};
/**
 * Between {@link ROVO_PROMPT_MENU_SECTION_RANK}[SPELLING_AND_GRAMMAR_MENU_ITEM] (300) and
 * [CHANGE_TONE_NESTED_MENU] (400); see `packages/editor/editor-common/src/toolbar/rank.ts`.
 */ const $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK = 350;
function $5219552937bbf3f0$var$isCommentPrimaryToolbarContext(parents) {
    return parents.some((p)=>p.key === (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key);
}
const $5219552937bbf3f0$export$716af56477a0c29a = (api, options)=>{
    return [
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key] + 10
                },
                // View mode (Live Page): AI_VIEW_SECTION
                {
                    type: (0, $3nacY.AI_VIEW_SECTION).type,
                    key: (0, $3nacY.AI_VIEW_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key] + 10
                }
            ]
        },
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_BUTTON.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_BUTTON.key,
            parents: [
                {
                    type: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.type,
                    key: $5219552937bbf3f0$var$MAUI_REMIX_GROUP.key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
                if (onPrimaryToolbar) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b38b8034b2cc03ff$export$53a35bc3b2402206), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    isRemixHidden: options?.isRemixHidden,
                    remixDisabledReason: options?.remixDisabledReason,
                    isSelectionRemixable: options?.isSelectionRemixable
                });
            }
        },
        {
            type: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM.type,
            key: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM.key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: $5219552937bbf3f0$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                }
            ],
            component: ({ parents: parents })=>{
                if (!$5219552937bbf3f0$var$isCommentPrimaryToolbarContext(parents) || options?.isRemixHidden || !(0, $iDrrr.fg)('platform_editor_maui_jira_updates')) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6928b89135447805$export$6764c57cc6522e0a), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    remixDisabledReason: options?.remixDisabledReason,
                    isSelectionRemixable: options?.isSelectionRemixable
                });
            }
        }
    ];
};




var $ipkS0 = parcelRequire("ipkS0");

const $c5b4fc4a60b668cd$var$REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';

const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-nAb2bX", ()=>(parcelRequire("cpNzj")).then((mod)=>({
            default: mod.MauiEmbedSpacePicker
        }))));
Object.assign($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, {
    displayName: 'lazy(MauiEmbedSpacePicker)'
});

const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "3lNcb",
    name: "MauiEmbedSpacePickerLoadableComponent",
    loader: ()=>(parcelRequire("cpNzj")).then((mod)=>mod.MauiEmbedSpacePicker),
    loading: ()=>null
});
const $c5b4fc4a60b668cd$var$MauiEmbedSpacePickerWithSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MauiEmbedSpacePickerWithSuspense(props) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function MauiEmbedSpacePickerWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLazyComponent, props));
};
const $c5b4fc4a60b668cd$var$LoadableMauiEmbedSpacePicker = (props)=>(0, $iDrrr.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$MauiEmbedSpacePickerLoadableComponent, props);
const $c5b4fc4a60b668cd$export$90e174b945ae40c7 = ({ api: api, config: config })=>{
    const isRovoLLMEnabled = config?.__isRovoLLMEnabled ?? false;
    const isRemixEnabled = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRightSideEnabled = isRemixEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg');
    const remixDisabledReason = config?.__remixDisabledReason;
    const isRemixDisabled = !!remixDisabledReason;
    const isRemixHidden = config?.__isRemixHidden;
    const isRemixEditOnly = config?.__isRemixEditOnly ?? false;
    const isRemixAvailable = isRemixEnabled && !isRemixHidden && !isRemixDisabled;
    const remixContentCreatorResult = isRemixAvailable && !isRemixEditOnly && api !== undefined && typeof config?.createRemixContentComponent === 'function' ? config.createRemixContentComponent() : undefined;
    const isSelectionRemixable = typeof remixContentCreatorResult === 'function' ? undefined : remixContentCreatorResult?.isSelectionRemixable;
    const remixContentComponent = typeof remixContentCreatorResult === 'function' ? remixContentCreatorResult : remixContentCreatorResult?.Component;
    const editorRemixLifecycleAdapterHost = typeof remixContentCreatorResult === 'function' ? undefined : remixContentCreatorResult?.LifecycleHost;
    const hasEditorRemixLifecycleAdapter = typeof remixContentCreatorResult !== 'function' && remixContentCreatorResult?.capabilities.editorRemixLifecycleAdapter === true;
    // Adapter presence is the only remaining boundary: the editor rollout has shipped, so every host
    // that supplies a lifecycle adapter and can render Remix content runs machine-backed. Hosts
    // without an adapter (Jira) keep the legacy path. No experiment or gate exposure is recorded here.
    const isEditorRemixStateRearchitectureTreatment = isRemixAvailable && hasEditorRemixLifecycleAdapter && editorRemixLifecycleAdapterHost !== undefined && remixContentComponent !== undefined && api !== undefined;
    const editorInlineRovoEditLifecycleAdapterHost = isEditorRemixStateRearchitectureTreatment ? editorRemixLifecycleAdapterHost : undefined;
    // Seeding `init()` from the shared registry only matters for flows the Object Sidebar hands to
    // Rovo Chat, and the effect host (machine-backed editor) is what later clears a seeded `true`.
    // Read without exposure: Confluence records this experiment's exposure at Object Sidebar
    // admission.
    const shouldSeedIsAnyRemixingFromRegistry = isEditorRemixStateRearchitectureTreatment && (0, $2pQiO.UNSAFE_expValNoExposure)('remix_state_rearchitecture_object_sidebar', 'isEnabled', false) === true;
    const remixToolbarOptions = {
        remixDisabledReason: remixDisabledReason,
        isDisabled: isRemixDisabled,
        isRemixHidden: isRemixHidden || isRemixEditOnly
    };
    // Mutable reference to the editor view, set by a PM plugin on init.
    // Used by the Remix block-menu isHidden callback to compute text length.
    let editorView;
    const remixResultTracker = (0, $02be7c97acfb0d3f$export$5f81010419ef00a3)();
    if (api && !isRemixHidden && !isRemixEditOnly && isRemixEnabled) {
        api.toolbar?.actions.registerComponents((0, $5219552937bbf3f0$export$716af56477a0c29a)(api, {
            ...remixToolbarOptions,
            isSelectionRemixable: isSelectionRemixable
        }));
        // Register Remix in the block menu when the experiment is enabled and
        // Remix is not disabled (e.g. restricted-content contexts).
        // Use NoExposure here since this runs on every editor load — exposure is
        // recorded when the block menu item is actually rendered.
        if (!isRemixDisabled && (0, $anBbz.expValEqualsNoExposure)('platform_editor_remix_in_block_menu', 'isEnabled', true)) api.blockMenu?.actions.registerBlockMenuComponents((0, $b924ab10b3fb73fd$export$96499eef52eb1886)({
            api: api,
            getEditorView: ()=>editorView
        }));
        if (!isRemixDisabled && [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) api.uiControlRegistry?.actions.register((0, $48fd160920f56916$export$e79e54e0ad32496e)({
            api: api
        }));
    }
    if (api?.blockControls && !config?.__isRemixHidden && !isRemixEditOnly && isRightSideEnabled) {
        const livePage = config?.__livePage;
        // EDITOR-8771: prefer the right surface via the UI Control Registry API once block controls
        // are migrated, falling back to `registerNodeDecoration` on the legacy path.
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const remixRightSurfaceButton = {
                component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a2adec84b86170$export$9097235bf2b51422), {
                        surfaceContext: surfaceContext,
                        api: api,
                        isDisabled: isRemixDisabled,
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        livePage: livePage,
                        remixDisabledReason: remixDisabledReason
                    }),
                isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
                    if (!context || (0, $4o0zT.isExperimentEnabled)('platform_editor_remix_control_priority') && Array.from(context.controlVisibility?.values() ?? []).some((isHidden)=>!isHidden)) return true;
                    // Remix is a root-node-only control
                    if (context.targetNode.pos !== context.rootNode.pos || context.targetNode.pos !== (context.activeNode?.rootPos ?? context.activeNode?.pos)) return true;
                    return !(0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                        node: context.rootNode.node
                    });
                },
                key: 'remix-right-surface-button',
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
                        rank: (0, $4o0zT.isExperimentEnabled)('platform_editor_remix_control_priority') ? 200 : 100
                    }
                ],
                type: 'button'
            };
            api.uiControlRegistry?.actions.register([
                remixRightSurfaceButton
            ]);
        } else api.blockControls.actions.registerNodeDecoration({
            type: $c5b4fc4a60b668cd$var$REMIX_BUTTON_DECORATION_TYPE,
            create: (params)=>(0, $2986bbc07141fc36$export$d411c8f539cb0edd)({
                    ...params,
                    api: api,
                    livePage: livePage,
                    remixDisabledReason: remixDisabledReason,
                    isDisabled: isRemixDisabled,
                    isRovoLLMEnabled: isRovoLLMEnabled
                }),
            showInViewMode: true,
            shouldCreate: (params)=>{
                const { editorState: editorState, rootPos: rootPos } = params;
                if (rootPos === undefined) return false;
                const node = editorState.doc.nodeAt(rootPos);
                return (0, $444f275c146ea05d$export$ff7e5ebac3487125)({
                    node: node ?? undefined
                });
            }
        });
    }
    return {
        name: 'malleableUi',
        pmPlugins () {
            const plugins = [
                {
                    name: 'malleableUi',
                    plugin: ({ dispatch: dispatch })=>(0, $bpOXf.createMalleableUiPmPlugin)(dispatch, {
                            // Only the treatment projects the shared registry into plugin state, so only it
                            // seeds `init()` from that registry across editor state recreation (CCCEMAU-3764).
                            getInitialIsAnyRemixing: shouldSeedIsAnyRemixingFromRegistry ? (0, $gRoSG.isAnyRemixingNow) : undefined
                        })
                },
                {
                    name: 'malleableUiEditorViewCapture',
                    plugin: ()=>(0, $0714cd2e74fa9587$export$c2f4e91d1c0a0502)((view)=>{
                            editorView = view;
                        }, ()=>{
                            editorView = undefined;
                            remixResultTracker.clear();
                        }, undefined, (view)=>remixResultTracker.update(view.state.doc))
                },
                {
                    name: 'malleableUiToolbarSuppression',
                    plugin: ()=>(0, $bpOXf.createToolbarSuppressionPlugin)()
                },
                {
                    name: 'remixThinking',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $5ea92dab24394af7$export$1c17a47e3daa5065)({
                            api: api,
                            config: config,
                            dispatch: dispatch,
                            getIntl: getIntl,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        })
                },
                ...(0, $iDrrr.fg)('cc-maui-phase-3') ? [
                    {
                        name: 'remixHoverHighlight',
                        plugin: ()=>(0, $3397a9320ab7f32b$export$1c5a63402318eb67)()
                    }
                ] : [],
                ...(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                    {
                        name: 'remixHistory',
                        plugin: ({ dispatch: dispatch })=>(0, $93f21268088062df$export$275a1873be81202e)({
                                api: api,
                                dispatch: dispatch
                            })
                    }
                ] : []
            ];
            if (config?.diagramPaste) {
                const diagramPasteConfig = {
                    ...config.diagramPaste,
                    fireAnalyticsEvent: (payload)=>{
                        api?.analytics?.actions.fireAnalyticsEvent(payload);
                    }
                };
                plugins.push({
                    name: 'mauiDiagramPaste',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $3kyUj.createMauiDiagramPastePmPlugin)(dispatch, diagramPasteConfig, getIntl)
                });
            }
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const malleableUiState = (0, $bpOXf.malleableUiPluginKey).getState(editorState);
            const remixThinkingState = (0, $5ea92dab24394af7$export$38c8fc373d691b1d).getState(editorState);
            if (!malleableUiState || !remixThinkingState) return undefined;
            return {
                aiEditReplacementLocalIds: malleableUiState.aiEditReplacementLocalIds,
                inFlightVariantUpdates: malleableUiState.inFlightVariantUpdates,
                isUpdate: remixThinkingState.isUpdate ?? false,
                historyEntryForUpdate: remixThinkingState.historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: remixThinkingState.dynamicUiSubtypeForUpdate,
                isComplete: remixThinkingState.isComplete ?? false,
                isAnyRemixing: malleableUiState.isAnyRemixing,
                isRemixModalOpen: malleableUiState.isRemixModalOpen,
                remixModalMetadata: malleableUiState.remixModalMetadata,
                remixAttemptId: remixThinkingState.remixAttemptId,
                isThinking: remixThinkingState.isThinking,
                isWaitingForInput: remixThinkingState.isWaitingForInput ?? false,
                remixSource: malleableUiState.remixSource,
                remixDiagramContentId: malleableUiState.remixDiagramContentId,
                remixUpdateScrollTargetUrl: malleableUiState.remixUpdateScrollTargetUrl,
                remixImageMediaId: malleableUiState.remixImageMediaId,
                showLocationPicker: malleableUiState.showLocationPicker,
                showSubtypeAdjustedFlag: malleableUiState.showSubtypeAdjustedFlag,
                diagramPaste: (0, $3kyUj.mauiDiagramPastePluginKey).getState(editorState),
                savedSelection: remixThinkingState.savedSelection
            };
        },
        actions: {
            beginCwrRemixTarget: (localId)=>{
                if (!editorView || !(0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance')) return undefined;
                const target = (0, $f53c681beb60dc43$export$c2c0a8a24f6ef42)(editorView.state.doc, localId);
                if (target) remixResultTracker.beginCwrReplacement({
                    previousLocalId: target.localId,
                    previousResultId: target.identity.value
                });
                return target;
            },
            getCwrRemixIdentityKeys: ()=>editorView && (0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance') ? (0, $f53c681beb60dc43$export$f983a316f6fb1b98)(editorView.state.doc) : new Set(),
            cancelCwrRemixResultReplacement: (replacement)=>{
                if (editorView && (0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance')) remixResultTracker.cancelCwrReplacement(replacement, editorView.state.doc);
            },
            completeCwrRemixResultReplacement: (replacement)=>{
                if (editorView && (0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance')) remixResultTracker.completeCwrReplacement(replacement, replacement.resultId, editorView.state.doc);
            },
            // Registers the current result, emitting `applied` immediately when newly observed.
            // Later lifecycle events are emitted from subsequent document updates.
            observeRemixResultLifecycle: (options)=>{
                const isCwrRemix = (0, $dE5YE.isCwrRemixEntryPoint)(options.attributes.entryPoint);
                const isAcceptanceAnalyticsEnabled = isCwrRemix ? (0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_remix_acceptance') : (0, $4o0zT.isExperimentEnabled)('platform_maui_retention_analytics');
                if (editorView && isAcceptanceAnalyticsEnabled) remixResultTracker.track({
                    ...options,
                    attributes: {
                        ...options.attributes,
                        isLiveDoc: Boolean(config?.__livePage)
                    }
                }, editorView.state.doc);
            },
            beginInlineRovoEdit: (targetId)=>(0, $d41f3058f4db498d$export$b9869b87d1be6011)(api, targetId),
            claimInlineRovoEdit: (targetId)=>(0, $d41f3058f4db498d$export$804d6981ddbce4fe)(api, targetId),
            duplicateAndReplaceMauiApp: (0, $9ea85748e8d18b6b$export$4f422ec95246a715)({
                api: api,
                config: config
            }),
            finalizeMauiEmbedFromIndicator: (0, $157df83f4da5e36c$export$68002784dcd3d97)({
                config: config
            }),
            getRemixDynamicUiSubtype: (fieldId)=>editorView ? (0, $2bef14e94508caba$export$c976fd9e927eb20d)({
                    state: editorView.state,
                    fieldId: fieldId
                })?.dynamicUiSubtype : undefined,
            getRemixFloatingToolbarButton: (0, $9ca8eb041284f342$export$f5e01f6a1e2eeb41)({
                api: api,
                options: remixToolbarOptions
            }),
            // The variant picker runs its update through the Remix content component.
            getRemixVariantFloatingToolbarButton: isRemixEditOnly ? ()=>undefined : (0, $d723c49ce3553147$export$fb69ba203a08f43d)({
                api: api
            }),
            isVariantUpdateInFlight: (id)=>{
                const sharedState = api?.malleableUi?.sharedState?.currentState();
                return sharedState?.inFlightVariantUpdates.has(id) ?? false;
            },
            reportInlineRovoEdit: (attemptId, result)=>(0, $d41f3058f4db498d$export$5b4e6541783f126c)(api, attemptId, result),
            settleUnclaimedInlineRovoEdit: (attemptId)=>(0, $d41f3058f4db498d$export$14ce80a40ed788cd)(api, attemptId),
            shouldDisableRemix: ()=>{
                const malleableUiState = api?.malleableUi?.sharedState.currentState();
                return Boolean(malleableUiState?.isRemixModalOpen || malleableUiState?.isThinking || malleableUiState?.isAnyRemixing || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
            }
        },
        commands: {
            clearRemixThinkingDecoration: $592515a66bfc26f7$export$65f89d2d4741e4b7,
            setMauiEmbedFinalizeStatus: $39483ef3a0dde328$export$d2cccfcd66c92b90,
            setRemixImageMediaId: $8ef7f637f4ca3dda$export$f36198854f9520d1,
            addBackendRemixHistoryStackEntry: (0, $f4ca8840d77ba1f3$export$b509b1134d7bb5c1),
            openRemixModal: (0, $a41417a475703a7a$export$e01f52b7ef73f07b)(api),
            closeRemixModal: (0, $d02a52a2c9adaa11$export$8818f9db6e7370f7)(api),
            startRemixThinking: (0, $3ed7f22374c9e3fb$export$b0011c604093029)(api),
            // Modal-free remix: anchors to pre-supplied localIds and starts remixing without opening
            // the Remix modal (used by Suggested Remix).
            startRemix: (0, $5708e7965bf3427a$export$e34b9fef80996931)(api),
            stopRemixThinking: $06443500a2493931$export$5569fef6b45e570f,
            replaceMauiApp: $b4d126e73ed52524$export$ff177b3b8713a3ae,
            replaceWhiteboardEmbed: $51bd462f1be2ad42$export$1aa62896db449f52,
            trackVariantUpdateStart: (0, $7725f70f68e88b96$export$b3219bd5df32333),
            trackVariantUpdateComplete: (0, $7725f70f68e88b96$export$242a1c29a4a1fdc3),
            updateRemixImageHistoryFieldId: (0, $51d6f7d12f1d2e45$export$de0bdc3bedba2bdf),
            showSubtypeAdjustedFlag: $756f290e221243c1$export$a5258d8cd6540560,
            dismissSubtypeAdjustedFlag: $756f290e221243c1$export$cc7138497964f45a
        },
        contentComponent: ({ editorView: editorView })=>{
            if ((0, $4o0zT.isExperimentEnabled)('cc_maui_disable_remix_ssr_content') && (!api || !editorView)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fjeDY.EditorRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $loghT.EditorRemixRecoveryCoordinatorProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $828d24cf3c31b50c$export$3bccfb6f759a17), null), isEditorRemixStateRearchitectureTreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $adce69c763bccff9$export$1ab134daab5fcbca), {
                api: api
            }) : null, editorInlineRovoEditLifecycleAdapterHost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2e4188f0e483040$export$fdca5082072fada0), {
                api: api,
                LifecycleAdapterHost: editorInlineRovoEditLifecycleAdapterHost
            }) : null, isRemixAvailable && api && !editorInlineRovoEditLifecycleAdapterHost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dcb43796e09f96b$export$136ced6b11a40bba), {
                api: api
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da0e6f79e5c28019$export$9b636cd211668abd), {
                api: api,
                hiddenOptions: config?.hiddenOptions,
                remixContentComponent: remixContentComponent,
                isEditorRemixStateRearchitectureTreatment: isEditorRemixStateRearchitectureTreatment
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e604702ca44aa$export$a91404893a3e2794), {
                api: api,
                productFlags: config?.productFlags
            }), config?.diagramPaste && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf98493589757f0e$export$bdca710d02013452), {
                api: api,
                productFlags: config?.productFlags
            }), config?.diagramPaste && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
            !(0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b4fc4a60b668cd$var$LoadableMauiEmbedSpacePicker, {
                api: api,
                config: config
            }) : null));
        },
        pluginsOptions: !config?.__isRemixHidden && !config?.__remixDisabledReason && isRemixEnabled ? {
            floatingToolbar: (0, $f2f7ec9e8a84769b$export$5b679e92b69e94fb)(api, {
                isRemixEditOnly: isRemixEditOnly,
                shouldHideToolbarWhileRemixing: config?.shouldHideToolbarWhileRemixing ?? false
            })
        } : {}
    };
};
module.exports["malleableUiPlugin"] = $c5b4fc4a60b668cd$export$90e174b945ae40c7;

});

parcelRegister("iCjKh", function(module, exports) {
const $1c17feb4ff1d747f$export$bf5f4f4fd607a25 = 'User stopped from Rovo side chat';
const $1c17feb4ff1d747f$export$9b4d66054b7f534a = 'Rovo agent error during remix';
function $1c17feb4ff1d747f$export$4509aabcbe267be2(payload) {
    return 'previousMauiId' in payload;
}
module.exports["REMIX_REMOTE_ABORT_REASON"] = $1c17feb4ff1d747f$export$bf5f4f4fd607a25;
module.exports["DEFAULT_REMIX_ERROR_MESSAGE"] = $1c17feb4ff1d747f$export$9b4d66054b7f534a;
module.exports["isAddBackendMauiRemixHistoryStackEntryPayload"] = $1c17feb4ff1d747f$export$4509aabcbe267be2;

});

parcelRegister("loghT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $fjeDY = parcelRequire("fjeDY");


var $3kyUj = parcelRequire("3kyUj");

const $aa52ec003d696f70$var$EditorRemixRecoveryContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $aa52ec003d696f70$export$712696ae13ff1c32 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($aa52ec003d696f70$var$EditorRemixRecoveryContext);
} : ()=>(0, $cozmU.useContext)($aa52ec003d696f70$var$EditorRemixRecoveryContext);
const $aa52ec003d696f70$export$3694853de04accb3 = ({ children: children })=>{
    const owner = (0, $fjeDY.useEditorRemixLifecycleOwner)();
    const activeRef = (0, $cozmU.useRef)(owner?.active);
    const bindingRef = (0, $cozmU.useRef)(undefined);
    activeRef.current = owner?.active;
    const activeToken = owner?.active?.token;
    /** Drops a binding whose flow is no longer the owner's active flow; its observer must not linger. */ const dropStaleBinding = (0, $cozmU.useCallback)(()=>{
        const binding = bindingRef.current;
        if (binding && binding.token !== activeRef.current?.token) {
            bindingRef.current = undefined;
            binding.unobserve();
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        dropStaleBinding();
    }, [
        activeToken,
        dropStaleBinding
    ]);
    const consumeExactBinding = (0, $cozmU.useCallback)((contentId)=>{
        const binding_0 = bindingRef.current;
        const active = activeRef.current;
        if (!binding_0 || !active || binding_0.contentId !== contentId || binding_0.token !== active.token) return undefined;
        bindingRef.current = undefined;
        binding_0.unobserve();
        return binding_0;
    }, []);
    const discard = (0, $cozmU.useCallback)((contentId_0)=>{
        const binding_1 = consumeExactBinding(contentId_0);
        if (!binding_1?.lifecycle) return false;
        binding_1.lifecycle.transition({
            type: 'INSERTION_FAILED'
        });
        binding_1.lifecycle.end('error');
        return true;
    }, [
        consumeExactBinding
    ]);
    const defer = (0, $cozmU.useCallback)((contentId_1)=>{
        const lifecycle = activeRef.current;
        if (!lifecycle) return false;
        dropStaleBinding();
        const existing = bindingRef.current;
        if (existing) {
            // One recovery embed per flow. Repeating the same id is idempotent; a different id means
            // the flow's recovery embed moved, so the old observer is released and the id rebound.
            if (existing.contentId === contentId_1) return true;
            bindingRef.current = undefined;
            existing.unobserve();
        }
        // Observe before claiming ownership: if the embed is already gone, the streamed content was
        // not inserted, so settle now rather than retain a handle nothing can release.
        const unobserve = (0, $3kyUj.observeMauiEmbedRemoval)(contentId_1, ()=>discard(contentId_1));
        if (!unobserve) {
            lifecycle.transition({
                type: 'INSERTION_FAILED'
            });
            lifecycle.end('error');
            return false;
        }
        lifecycle.setOwnerDestructionEndReason('error');
        bindingRef.current = {
            contentId: contentId_1,
            lifecycle: lifecycle,
            token: lifecycle.token,
            unobserve: unobserve
        };
        return true;
    }, [
        discard,
        dropStaleBinding
    ]);
    const resolve = (0, $cozmU.useCallback)((contentId_2)=>{
        const binding_2 = consumeExactBinding(contentId_2);
        if (!binding_2?.lifecycle) return false;
        // The owner releases itself only on an accepted `INSERTED`. A rejected transition
        // (a concurrent terminal signal already moved the machine on) must not strand ownership.
        if (!binding_2.lifecycle.transition({
            type: 'INSERTED'
        })) binding_2.lifecycle.rollback();
        return true;
    }, [
        consumeExactBinding
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            const binding_3 = bindingRef.current;
            if (!binding_3) return;
            bindingRef.current = undefined;
            binding_3.unobserve();
            if (activeRef.current?.token === binding_3.token) {
                binding_3.lifecycle.transition({
                    type: 'INSERTION_FAILED'
                });
                binding_3.lifecycle.end('error');
            }
        }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            defer: defer,
            discard: discard,
            resolve: resolve
        }), [
        defer,
        discard,
        resolve
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa52ec003d696f70$var$EditorRemixRecoveryContext.Provider, {
        value: value
    }, children);
};
module.exports["useEditorRemixRecoveryCoordinator"] = $aa52ec003d696f70$export$712696ae13ff1c32;
module.exports["EditorRemixRecoveryCoordinatorProvider"] = $aa52ec003d696f70$export$3694853de04accb3;

});

parcelRegister("cpNzj", function(module, exports) {

let $909e452003414d55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $909e452003414d55$var$load("7i8YT"),
    $909e452003414d55$var$load("hhss7"),
    $909e452003414d55$var$load("6clcf")
]).then(()=>parcelRequire('8yELO'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bx7fw", function(module, exports) {

var $9kbDL = parcelRequire("9kbDL");


var $dCkbP = parcelRequire("dCkbP");

const $664a8ddc7a82736d$export$12f4796bbde2aa70 = {
    isRecommendedItem: (0, $9kbDL.createIsRecommendedItem)([
        (0, $dCkbP.ASK_ROVO_MENU_ITEM).key,
        (0, $dCkbP.TABS_MENU_ITEM).key,
        (0, $dCkbP.DIAGRAM_MENU_ITEM).key,
        (0, $dCkbP.DATABASE_MENU_ITEM).key,
        (0, $dCkbP.ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM).key,
        // Fallbacks
        (0, $dCkbP.LOOM_MENU_ITEM).key,
        (0, $dCkbP.SYNCED_BLOCK_MENU_ITEM).key,
        (0, $dCkbP.JIRA_ISSUE_MENU_ITEM).key,
        (0, $dCkbP.CODE_BLOCK_MENU_ITEM).key
    ]),
    maxRecommendedItems: 5
};
const $664a8ddc7a82736d$export$b3bd0c53a505a85 = {
    isRecommendedItem: (0, $9kbDL.createIsRecommendedItem)([
        (0, $dCkbP.ASK_ROVO_MENU_ITEM).key,
        (0, $dCkbP.EMOJI_MENU_ITEM).key,
        (0, $dCkbP.MENTION_MENU_ITEM).key,
        // Fallbacks
        (0, $dCkbP.DECISION_MENU_ITEM).key
    ]),
    maxRecommendedItems: 3
};
const $664a8ddc7a82736d$export$b4ae8263af36783b = {
    isRecommendedItem: (0, $9kbDL.createIsRecommendedItem)([
        (0, $dCkbP.ASK_ROVO_MENU_ITEM).key,
        (0, $dCkbP.EMOJI_MENU_ITEM).key,
        (0, $dCkbP.MENTION_MENU_ITEM).key,
        // Fallbacks
        (0, $dCkbP.MEDIA_INSERT_MENU_ITEM).key
    ]),
    maxRecommendedItems: 3
};
module.exports["fullPageQuickInsertRecommendedItems"] = $664a8ddc7a82736d$export$12f4796bbde2aa70;
module.exports["pageCommentQuickInsertRecommendedItems"] = $664a8ddc7a82736d$export$b3bd0c53a505a85;
module.exports["inlineCommentQuickInsertRecommendedItems"] = $664a8ddc7a82736d$export$b4ae8263af36783b;

});

parcelRegister("8RXjp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $11ec5a45260f5479$export$3c59230798c40d1a = (0, $kSwu1.defineMessages)({
    remixReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.remixReady",
        defaultMessage: "Your remix is ready"
    },
    remixReadyUpdated: {
        id: "malleable-ui-components.remix.remix-ready-toast.remixReady.updated",
        defaultMessage: "Your content is ready"
    },
    contentReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.contentReady",
        defaultMessage: "Your content is ready"
    },
    updateReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.updateReady",
        defaultMessage: "Your edits are ready"
    },
    viewButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.viewButton",
        defaultMessage: "View"
    },
    closeButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.closeButton",
        defaultMessage: "Close"
    }
});
module.exports["remixReadyMessages"] = $11ec5a45260f5479$export$3c59230798c40d1a;

});


//# sourceMappingURL=FullPageEditorComponent.704180a3.js.map
